import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Represents non-fractional signed whole numeric values */
  BigInt: { input: string; output: string; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: string; output: string; }
  /** Built-in String */
  Email: { input: string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: string; output: string; }
  Long: { input: string; output: string; }
  /** Decimal number represented as string. Example: "178.01" */
  MoneyAmount: { input: string; output: string; }
  /** `Date` type as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: { input: number; output: number; }
  /** URI custom scalar type */
  URI: { input: string; output: string; }
};

export type AbTest = {
  id: Scalars['ID']['output'];
  state: AbTestState;
};

export type AbTestAllocation = {
  abTest: AbTest;
  allocationVariant: AbTestAllocationVariant;
};

export enum AbTestAllocationVariant {
  VarA = 'VAR_A',
  VarB = 'VAR_B',
  VarC = 'VAR_C',
  VarD = 'VAR_D',
  VarE = 'VAR_E'
}

export enum AbTestState {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Locked = 'LOCKED'
}

export type AccumulatedRewards = {
  creditsAmountInCents: Scalars['Int']['output'];
  pointsAmount: Scalars['Int']['output'];
};

/** Fiverr::User::Achievement enum - https://github.com/fiverr/fiverrapis/blob/master/fiverr/user/achievement.proto */
export enum AchievementLevel {
  LevelOne = 'LEVEL_ONE',
  LevelTwo = 'LEVEL_TWO',
  NoLevel = 'NO_LEVEL',
  TopRatedSeller = 'TOP_RATED_SELLER'
}

export type AchievementLog = {
  createdAt: Scalars['Timestamp']['output'];
  currentLevel: Maybe<SellerLevel>;
  newLevel: SellerLevel;
  operation: AchievementStatus;
  operator: Scalars['String']['output'];
  reasons: Maybe<Array<Scalars['String']['output']>>;
  userId: Scalars['ID']['output'];
};

export enum AchievementStatus {
  Demoted = 'demoted',
  Promoted = 'promoted'
}

export type ActivateAgencyInput = {
  id: Scalars['ID']['input'];
};

export type ActivateAgencyResult = Agency | AgencyAlreadyInStatus | AgencyNotFound | KeyPointsInvalidInput;

export type Agency = {
  /** Date of when the agency was created in the database */
  createdAt: Scalars['Timestamp']['output'];
  /** The date when the agency was established(founded). It's an integer that reflects a year, for example, 2024 */
  established: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** Industry ids that the agency specializes in */
  industries: Maybe<Array<Scalars['String']['output']>>;
  /** Generated agency's key points by the OpenAI API */
  keyPoints: Maybe<Array<Scalars['String']['output']>>;
  /** Public members of the agency that will be displayed on the agency's profile */
  members: Maybe<Array<AgencyMember>>;
  /**
   * URL of the agency's profile.
   * It may be equal to null in case of infrastructure failure.
   * Please, use mocked image in this case.
   */
  profileBackgroundUrl: Maybe<Scalars['String']['output']>;
  /** Seller associated with the agency(agency owner) */
  seller: Seller;
  /** Services provided by the agency */
  services: Maybe<Array<Scalars['Int']['output']>>;
  /** Unique slug for the agency used in the URL */
  slug: Maybe<Scalars['String']['output']>;
  /** Status of the agency */
  status: AgencyStatus;
  /** Size of the agency's team in number of employees */
  teamSize: Maybe<Scalars['Int']['output']>;
};


export type AgencyProfileBackgroundUrlArgs = {
  transformation: AgencyAttachmentTransformation;
};

export type AgencyAlreadyInStatus = {
  id: Scalars['ID']['output'];
  status: AgencyStatus;
};

export enum AgencyAttachmentTransformation {
  TAgencyMainLarge = 'T_AGENCY_MAIN_LARGE',
  TAgencyMainThumb = 'T_AGENCY_MAIN_THUMB'
}

export type AgencyMember = {
  /** Date of when the member was created */
  createdAt: Scalars['Timestamp']['output'];
  /** Agency member description (e.g. John Doe is the CEO of the agency) */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Agency member name (e.g. John Doe) */
  name: Scalars['String']['output'];
  /**
   * Representing the importance of the member, by specifically indication its' position.
   * This might be taken into consideration when rendering UI elements.
   */
  position: Scalars['Int']['output'];
  /**
   * Profile URL of the agency member.
   * It may be equal to "IMAGE_UPLOADING" in case of infrastructure failure.
   * Please, use mocked image in this case.
   */
  profileImageUrl: Scalars['String']['output'];
  /** Agency member role in the agency (e.g. CEO, CTO, etc.) */
  role: Scalars['String']['output'];
};

export type AgencyMemberInput = {
  description: Scalars['String']['input'];
  id: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  profileImageAttachmentId: InputMaybe<Scalars['String']['input']>;
  role: Scalars['String']['input'];
};

export type AgencyNotFound = {
  id: Scalars['ID']['output'];
};

export enum AgencyStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  FixesRequired = 'FIXES_REQUIRED',
  Inactive = 'INACTIVE',
  PendingModeration = 'PENDING_MODERATION',
  Rejected = 'REJECTED'
}

export type AllocatedExperiments = {
  /** Array of user's allocated experiments */
  allocatedExperiments: Array<AbTestAllocation>;
};

export type AllowedBuyer = {
  followUp: Maybe<FollowUp>;
  lastOrder: LastOrder;
  order: Order;
  stats: Maybe<AllowedBuyerStats>;
  user: User;
};

export type AllowedBuyerConnection = {
  edges: Maybe<Array<AllowedBuyerEdge>>;
  nodes: Maybe<Array<AllowedBuyer>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AllowedBuyerEdge = {
  cursor: Scalars['String']['output'];
  node: AllowedBuyer;
};

export type AllowedBuyerStats = {
  completedOrders: Maybe<Scalars['Int']['output']>;
  lastCouponSentAt: Maybe<Scalars['Timestamp']['output']>;
  sentCoupons: Maybe<Scalars['Int']['output']>;
  usedCoupons: Maybe<Scalars['Int']['output']>;
};

export type AllowedBuyersFilter = {
  buyerName: InputMaybe<Scalars['String']['input']>;
  lastOrderCreatedFrom: InputMaybe<LastOrderCreatedFromOptions>;
  type: InputMaybe<AllowedBuyersType>;
};

export type AllowedBuyersSort = {
  by: InputMaybe<AllowedBuyersSortBy>;
  order: InputMaybe<SortOrder>;
};

export enum AllowedBuyersSortBy {
  CouponsUsed = 'COUPONS_USED',
  LastCouponSent = 'LAST_COUPON_SENT',
  LastFollowUpSent = 'LAST_FOLLOW_UP_SENT',
  LastOrderDate = 'LAST_ORDER_DATE',
  LastOrderPrice = 'LAST_ORDER_PRICE',
  Orders = 'ORDERS'
}

export enum AllowedBuyersType {
  Coupon = 'COUPON',
  FollowUp = 'FOLLOW_UP'
}

export enum AntivirusResult {
  AntivirusResultDetected = 'ANTIVIRUS_RESULT_DETECTED',
  AntivirusResultInProgress = 'ANTIVIRUS_RESULT_IN_PROGRESS',
  AntivirusResultPassed = 'ANTIVIRUS_RESULT_PASSED',
  AntivirusResultSkipped = 'ANTIVIRUS_RESULT_SKIPPED',
  AntivirusResultUnspecified = 'ANTIVIRUS_RESULT_UNSPECIFIED'
}

export enum ApprovalMode {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL'
}

export type AssetsSharing = InspireDeliveryAssetsSharing | OrderDeliveryAssetsSharing;

export type AssetsSharingAttachment = {
  fileName: Maybe<Scalars['String']['output']>;
  fileSizeInBytes: Scalars['Int']['output'];
  id: Maybe<Scalars['String']['output']>;
  mediaUrl: Maybe<Scalars['String']['output']>;
  previewUrl: Maybe<AssetsSharingAttachmentUrl>;
  type: AssetsSharingAttachmentType;
};


export type AssetsSharingAttachmentPreviewUrlArgs = {
  transformation: AssetsSharingAttachmentTransformation;
};

export enum AssetsSharingAttachmentTransformation {
  AssetsSharingMediumPreview = 'ASSETS_SHARING_MEDIUM_PREVIEW',
  InspireDeliveryAttachmentLargePreview = 'INSPIRE_DELIVERY_ATTACHMENT_LARGE_PREVIEW',
  InspireDeliveryAttachmentMediumPreview = 'INSPIRE_DELIVERY_ATTACHMENT_MEDIUM_PREVIEW',
  InspireDeliveryAttachmentSmallPreview = 'INSPIRE_DELIVERY_ATTACHMENT_SMALL_PREVIEW',
  InspireDeliveryAttachmentThumbnailPreview = 'INSPIRE_DELIVERY_ATTACHMENT_THUMBNAIL_PREVIEW',
  MobileFeedPreview = 'MOBILE_FEED_PREVIEW',
  None = 'NONE'
}

export enum AssetsSharingAttachmentType {
  Audio = 'AUDIO',
  Gif = 'GIF',
  Image = 'IMAGE',
  Other = 'OTHER',
  Video = 'VIDEO'
}

export type AssetsSharingAttachmentUrl = {
  transformation: Maybe<AssetsSharingAttachmentTransformation>;
  url: Maybe<Scalars['String']['output']>;
};

export type Attachment = {
  createdAt: Maybe<Scalars['Timestamp']['output']>;
  downloadUrl: Maybe<Scalars['URI']['output']>;
  fileName: Maybe<Scalars['String']['output']>;
  fileSizeInBytes: Scalars['BigInt']['output'];
  /**
   * Provides url for downloading/playing media content.
   * It's mapped from videoUrls["media_url"] in Filerr's AttachmentDto
   */
  mediaUrl: Maybe<Scalars['URI']['output']>;
  metadata: Maybe<AttachmentMetadata>;
  previewUrl: Maybe<AttachmentUrl>;
  scanStatus: Maybe<AttachmentAntiVirusResult>;
  streamUrl: Maybe<Scalars['URI']['output']>;
  type: AttachmentType;
};


export type AttachmentPreviewUrlArgs = {
  transformation: AttachmentTransformation;
};

export enum AttachmentAntiVirusResult {
  Detected = 'DETECTED',
  InProgress = 'IN_PROGRESS',
  Passed = 'PASSED',
  Skipped = 'SKIPPED'
}

export type AttachmentMetadata = {
  height: Maybe<Scalars['Float']['output']>;
  width: Maybe<Scalars['Float']['output']>;
};

export enum AttachmentPreviewTransformation {
  BriefMediumPreview = 'BRIEF_MEDIUM_PREVIEW',
  None = 'NONE'
}

export type AttachmentPreviewUrl = {
  transformation: Maybe<AttachmentPreviewTransformation>;
  url: Maybe<Scalars['URI']['output']>;
};

export enum AttachmentTransformation {
  AssetsSharingMediumPreview = 'ASSETS_SHARING_MEDIUM_PREVIEW',
  InspireDeliveryAttachmentLargePreview = 'INSPIRE_DELIVERY_ATTACHMENT_LARGE_PREVIEW',
  InspireDeliveryAttachmentMediumPreview = 'INSPIRE_DELIVERY_ATTACHMENT_MEDIUM_PREVIEW',
  InspireDeliveryAttachmentSmallPreview = 'INSPIRE_DELIVERY_ATTACHMENT_SMALL_PREVIEW',
  InspireDeliveryAttachmentThumbnailPreview = 'INSPIRE_DELIVERY_ATTACHMENT_THUMBNAIL_PREVIEW',
  InspireDeliveryAttachmentWebTilePreview = 'INSPIRE_DELIVERY_ATTACHMENT_WEB_TILE_PREVIEW',
  MessageAttachmentMobilePreview = 'MESSAGE_ATTACHMENT_MOBILE_PREVIEW',
  MessageAttachmentMobileStaticPreview = 'MESSAGE_ATTACHMENT_MOBILE_STATIC_PREVIEW',
  None = 'NONE',
  NotableClientsThumbPreview = 'NOTABLE_CLIENTS_THUMB_PREVIEW',
  SellerPortfolioProjectGrid = 'SELLER_PORTFOLIO_PROJECT_GRID',
  SellerPortfolioProjectLarge = 'SELLER_PORTFOLIO_PROJECT_LARGE',
  SellerProfileCoverWidePreview = 'SELLER_PROFILE_COVER_WIDE_PREVIEW'
}

export enum AttachmentType {
  Audio = 'AUDIO',
  Doc = 'DOC',
  Gif = 'GIF',
  Image = 'IMAGE',
  Other = 'OTHER',
  Pdf = 'PDF',
  Video = 'VIDEO',
  Zip = 'ZIP'
}

export type AttachmentUrl = {
  transformation: Maybe<AttachmentTransformation>;
  url: Maybe<Scalars['URI']['output']>;
};

export type AttachmentsByIdsResponseUnion = InternalAttachment | InternalAttachmentByIdNotFound;

export type AttachmentsByRelatedObjectsResponseUnion = InternalAttachment | InternalAttachmentByRelatedObjectNotFound;

export type Audiences = {
  highPriceAffinity: Scalars['Boolean']['output'];
  localSupply: Scalars['Boolean']['output'];
  professionOriented: Scalars['Boolean']['output'];
  urgentNeed: Scalars['Boolean']['output'];
};

export type AvailabilityTimeSlot = {
  durationMinutes: Scalars['Float']['output'];
  fromDayOfWeek: DayOfWeek;
  fromMinutes: Scalars['Float']['output'];
};

export type BackgroundCheck = {
  backgroundCheckResult: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  organizationId: Scalars['String']['output'];
  requestStatus: Scalars['String']['output'];
  requesteeId: Scalars['Int']['output'];
  requesterId: Scalars['Int']['output'];
  statusHistory: Array<StatusHistory>;
};

/** An entity with ID */
export type BaseGqlEntity = {
  /** The entity identifier */
  id: Scalars['ID']['output'];
};

export type BaseOrganization = {
  businessInfo: Maybe<BusinessInfo>;
  id: Scalars['ID']['output'];
};

export type Billing = {
  discount: ExtendedMoney;
  grossAmount: ExtendedMoney;
  refunds: Maybe<Array<Refund>>;
  serviceFee: ExtendedMoney;
  /** @deprecated use taxes */
  tax: ExtendedMoney;
  taxes: Maybe<Array<ExtendedTaxMoney>>;
  totalAmount: ExtendedMoney;
  totalBuyerRefund: ExtendedMoney;
  /** @deprecated use totalBuyerRefund */
  totalRefund: ExtendedMoney;
};

export type BillingPeriod = {
  billingPeriodType: BillingPeriodType;
};

export enum BillingPeriodType {
  Annual = 'ANNUAL',
  Monthly = 'MONTHLY',
  OneTime = 'ONE_TIME',
  SemiAnnual = 'SEMI_ANNUAL'
}

/**
 * A binary benefit is a benefit that is either granted or not granted.
 * For example, the seller plus standard benefit is either granted or not granted.
 */
export type BinarySellerBenefit = {
  /**
   * A list of seller achievements that grant this benefit.
   * For example, it can be a list of all levels that grant the seller plus standard benefit.
   */
  achievementsCriteria: Array<SellerBinaryBenefitAchievementCriterion>;
  /** Whether this benefit is granted or not granted based on the seller's current level or vetting. */
  eligible: Scalars['Boolean']['output'];
};

export type Brief = Node & {
  budget: BriefBudget;
  buyer: User;
  category: Maybe<BriefCategory>;
  closedReason: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  deliverBy: Maybe<Scalars['Timestamp']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  matchCandidates: Array<MatchCandidate>;
  pricingFactors: Array<BriefPricingFactor>;
  questionsAndAnswers: Array<MetadataQuestion>;
  status: BriefStatus;
  title: Maybe<Scalars['String']['output']>;
};


export type BriefMatchCandidatesArgs = {
  matchCandidateFilter?: InputMaybe<MatchCandidateFilter>;
};

export type BriefAttachment = {
  downloadUrl: Maybe<Scalars['URI']['output']>;
  id: Scalars['ID']['output'];
  mediaUrl: Maybe<Scalars['URI']['output']>;
  pdfOpenUrl: Maybe<Scalars['URI']['output']>;
  previewUrls: Maybe<Array<AttachmentPreviewUrl>>;
  type: Maybe<Scalars['String']['output']>;
};

export type BriefBudget = {
  budgetInCents: Maybe<Money>;
  isFlexible: Maybe<Scalars['Boolean']['output']>;
};

export type BriefCategory = {
  categoryId: Maybe<Scalars['Int']['output']>;
  nestedCategoryId: Maybe<Scalars['Int']['output']>;
  /**  nullable in order to support one_to_one briefs */
  subCategoryId: Maybe<Scalars['Int']['output']>;
};

/** The connection type for BriefConnection */
export type BriefConnection = {
  /** A list of nodes */
  nodes: Maybe<Array<Brief>>;
  /** Identifies the total count of items in the connection */
  totalCount: Scalars['Int']['output'];
};

export enum BriefContextType {
  Neo = 'NEO',
  Organization = 'ORGANIZATION',
  User = 'USER'
}

export type BriefData = {
  attachments: Maybe<Array<BriefAttachment>>;
  auctionContext: Maybe<DmAuctionContext>;
  budgetRangeInCents: Maybe<DmBriefBudgetRange>;
  categoryId: Scalars['Int']['output'];
  content: DmBriefContent;
  contentPreview: Scalars['String']['output'];
  contextId: Scalars['ID']['output'];
  contextType: BriefContextType;
  createdAt: Scalars['Timestamp']['output'];
  createdBy: Buyer;
  deliveryDate: Maybe<Scalars['Timestamp']['output']>;
  description: Scalars['String']['output'];
  displayStatus: Maybe<DmBriefDisplayStatus>;
  editDetails: Maybe<DmBriefEditDetails>;
  id: Scalars['ID']['output'];
  metadataAnswers: Maybe<DmBriefMetadataAnswers>;
  needType: Maybe<DmBriefNeedType>;
  needTypeDetails: Maybe<DmBriefNeedTypeDetails>;
  nestedSubCategoryId: Maybe<Scalars['Int']['output']>;
  originalBuyerBudget: Maybe<Money>;
  originalBuyerBudgetRange: Maybe<DmBriefMoneyRange>;
  pricingType: BriefPricingType;
  screeningQuestions: Maybe<Array<DmBriefScreeningQuestion>>;
  status: DmBriefStatus;
  subCategoryId: Maybe<Scalars['Int']['output']>;
  tier: DmBriefTier;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Timestamp']['output'];
  updatedBy: User;
};


export type BriefDataAttachmentsArgs = {
  previewTransformations?: InputMaybe<Array<AttachmentPreviewTransformation>>;
};

export type BriefMetadataQuestion = {
  answers: Array<Scalars['String']['output']>;
  question: Maybe<Scalars['String']['output']>;
};

export type BriefPricingFactor = {
  slug: Scalars['String']['output'];
};

export enum BriefPricingType {
  Fixed = 'FIXED',
  Hourly = 'HOURLY'
}

export enum BriefStatus {
  Approved = 'APPROVED',
  Closed = 'CLOSED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type BriefTemplate = {
  contextId: Scalars['ID']['output'];
  contextType: BriefContextType;
  createdAt: Scalars['Timestamp']['output'];
  createdBy: Buyer;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Timestamp']['output'];
  updatedBy: User;
};

export type BucketGoal = Goal & {
  buckets: Array<BucketGoal>;
  goals: Array<LeafGoal>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Business = {
  /** The name of the business owned by the buyer, explicitly stated in conversation. */
  businessName: Maybe<NestedString>;
  /** The sector in which the buyer's business operates, separate from business type. */
  industry: Maybe<Array<NestedString>>;
  /** The functional nature of the buyer’s business (e.g., agency, e-commerce store, SaaS, consultancy). */
  typeOfBusiness: Maybe<Array<NestedString>>;
};

export enum BusinessContextType {
  Organization = 'ORGANIZATION',
  User = 'USER'
}

export type BusinessCustomer = {
  /** The organization this business user belongs to */
  organization: Maybe<Organization>;
  /** The user this business customer belongs to */
  user: Maybe<User>;
};

export type BusinessGoal = Goal & {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BusinessInfo = {
  businessRole: Maybe<Scalars['String']['output']>;
  businessStage: Maybe<Scalars['String']['output']>;
  businessType: Maybe<Scalars['String']['output']>;
  companyDescription: Maybe<Scalars['String']['output']>;
  companyLogoUrl: Maybe<Scalars['String']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  /** Number of employees. */
  companySize: Maybe<Scalars['String']['output']>;
  companyWebsite: Maybe<Scalars['String']['output']>;
  companyWebsiteSpecified: Maybe<Scalars['Boolean']['output']>;
  /** Primary industry of the business. */
  industry: Maybe<Industry>;
  orderFrequency: Maybe<Scalars['String']['output']>;
  /** Business purposes. */
  purposes: Maybe<Array<Scalars['String']['output']>>;
};

export type BusinessMember = Node & {
  createdAt: Scalars['DateTime']['output'];
  /** Business member id */
  id: Scalars['ID']['output'];
  isHybrid: Scalars['Boolean']['output'];
  /** The organization this business user belongs to */
  organization: Maybe<BusinessOrganization>;
  /** The role of this business user in the organization */
  role: Maybe<BusinessMemberRole>;
  status: BusinessMemberStatus;
  updatedAt: Scalars['DateTime']['output'];
  /** The user this business user belongs to */
  user: Maybe<User>;
};

export type BusinessMemberFacet = {
  user: User;
};

/** Information about member role type */
export enum BusinessMemberRole {
  Admin = 'ADMIN',
  Contributor = 'CONTRIBUTOR',
  FinancialManager = 'FINANCIAL_MANAGER',
  Member = 'MEMBER'
}

export enum BusinessMemberStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum BusinessOrderSortBy {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type BusinessOrderSorting = {
  sortBy: BusinessOrderSortBy;
  sortOrder: SortOrder;
};

export type BusinessOrganization = BaseOrganization & Node & {
  businessInfo: Maybe<BusinessInfo>;
  /**
   * Business project list of the organization
   * @deprecated Use projects() query instead
   */
  businessProjects: BusinessProjectConnection;
  createdAt: Scalars['DateTime']['output'];
  /** Business organization id */
  id: Scalars['ID']['output'];
  isVib: Maybe<Scalars['Boolean']['output']>;
  loyaltyInfo: Maybe<LoyaltyInfo>;
  name: Maybe<Scalars['String']['output']>;
  /** Collection of orders assigned to this organization */
  orders: OrderConnection;
  status: BusinessOrganizationStatus;
  updatedAt: Scalars['DateTime']['output'];
};


export type BusinessOrganizationBusinessProjectsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  filters: InputMaybe<BusinessProjectFilters>;
  first: Scalars['Int']['input'];
  sorting: InputMaybe<BusinessProjectSorting>;
};


export type BusinessOrganizationOrdersArgs = {
  filter: InputMaybe<BusinessOrganizationOrderFilter>;
  pagination: Pagination;
  sorting: InputMaybe<BusinessOrderSorting>;
};

export type BusinessOrganizationOrderFilter = {
  buyerIds: InputMaybe<Array<Scalars['String']['input']>>;
  projectIds: InputMaybe<Array<Scalars['String']['input']>>;
  sellerIds: InputMaybe<Array<Scalars['String']['input']>>;
  statuses: InputMaybe<Array<OrderStatusInput>>;
};

export enum BusinessOrganizationStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type BusinessProject = Node & {
  /** Optional project brief */
  brief: Maybe<Scalars['String']['output']>;
  /** Collection of business member who made any orders in this project */
  buyers: Array<BusinessMember>;
  /** Optional project description */
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** External interest ids owned by CMS services which specified for project */
  interests: Array<Interest>;
  /** Shows if project is archived */
  isArchived: Scalars['Boolean']['output'];
  /** The project name specified when created */
  name: Scalars['String']['output'];
  /** Create date of a project */
  openedAt: Maybe<Scalars['Timestamp']['output']>;
  /** Collection of orders assigned to this project */
  orders: OrderConnection;
  /** The organization this business user belongs to */
  organization: Maybe<BusinessOrganization>;
  /** Collection of business project members */
  projectMembers: Array<BusinessProjectMember>;
  /** Selected categories with metadata questions selected on business project creation */
  selectedCategories: Array<BusinessProjectSelectedCategory>;
  /** Actual project type enumeration */
  type: BusinessProjectType;
};


export type BusinessProjectOrdersArgs = {
  filter: InputMaybe<BusinessProjectOrderFilter>;
  pagination: Pagination;
};

/** The connection type for BusinessProjectConnection */
export type BusinessProjectConnection = Connection & {
  /** A list of edges */
  edges: Maybe<Array<BusinessProjectConnectionEdge>>;
  /** A list of nodes */
  nodes: Maybe<Array<BusinessProject>>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection */
  totalCount: Scalars['Int']['output'];
};

export type BusinessProjectConnectionEdge = {
  /** The item at the end of the edge. */
  cursor: Scalars['String']['output'];
  /** A cursor for use in pagination. */
  node: BusinessProject;
};

export type BusinessProjectFilters = {
  isMember: InputMaybe<Scalars['Boolean']['input']>;
  membership: ProjectMembershipFilter;
  privileges: InputMaybe<Array<ProjectPrivilegeFilter>>;
  statuses: InputMaybe<Array<ProjectStatusInput>>;
  types: InputMaybe<Array<BusinessProjectType>>;
};

export type BusinessProjectMember = {
  organizationMember: Maybe<BusinessMember>;
  role: Maybe<BusinessProjectMemberRole>;
};

/** Information about business project membership role type */
export enum BusinessProjectMemberRole {
  Member = 'MEMBER',
  Owner = 'OWNER'
}

export type BusinessProjectOrderFilter = {
  buyerIds: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt: InputMaybe<DateQuery>;
  statuses: InputMaybe<Array<OrderStatusInput>>;
};

export type BusinessProjectSelectedCategory = {
  briefMetadataQuestions: Array<BriefMetadataQuestion>;
  category: GigCategory;
};

export type BusinessProjectSorting = {
  sortBy: BusinessProjectsSortBy;
  sortOrder: SortOrder;
};

export enum BusinessProjectType {
  Personal = 'PERSONAL',
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export enum BusinessProjectsSortBy {
  RecentlyViewed = 'RECENTLY_VIEWED'
}

export type Buyable = {
  buyableData: Maybe<ItemBuyableData>;
};

export type Buyer = Node & {
  availabilityTimeSlots: Maybe<Array<AvailabilityTimeSlot>>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insights: Maybe<Insights>;
  intents: Maybe<Array<BuyerIntent>>;
  isSelectMember: Maybe<Scalars['Boolean']['output']>;
  languagePreferences: Maybe<Array<LanguagePreference>>;
  organization: Maybe<BaseOrganization>;
  profileCompletion: ProfileCompletion;
  rating: Maybe<BuyerRating>;
  regionalGroups: Array<RegionalGroup>;
  user: Maybe<User>;
};

export type BuyerBusiness = {
  /** Boolean indicator capturing whether the buyer has a business need. */
  businessNeed: Maybe<NestedBoolean>;
  /** Boolean indicator capturing whether the buyer explicitly states they own a business. (e.g., "I own a company called X" or "I run my own business"). */
  businessOwner: Maybe<NestedBoolean>;
  /** An array of objects representing the businesses the buyer is associated with. */
  businesses: Maybe<Array<Business>>;
};

export enum BuyerIntent {
  Buying = 'BUYING',
  Selling = 'SELLING'
}

export type BuyerOnlinePresence = {
  /** Boolean indicator capturing whether the buyer owns a website. */
  ownsWebsite: Maybe<NestedBoolean>;
  /** Boolean indicator capturing whether the buyer is active on social media platforms. */
  socialMediaActivity: Maybe<NestedBoolean>;
  /** The types of activities the buyer engages in on social media (e.g., "posting", "advertising", "engagement"). */
  socialMediaActivityType: Maybe<Array<NestedString>>;
  /** The social media platforms the buyer is active on (e.g., "Facebook", "Instagram", "LinkedIn"). */
  socialMediaPlatforms: Maybe<Array<NestedString>>;
  /** The platforms the buyer uses for their website (e.g., "WordPress", "Shopify", "custom"). */
  websitePlatform: Maybe<Array<NestedString>>;
  /** The types of websites the buyer owns (e.g., "e-commerce", "portfolio", "blog"). */
  websiteType: Maybe<Array<NestedString>>;
};

export type BuyerPersonalData = {
  /** The hobbies and interests of the buyer. */
  hobbies: Maybe<Array<Scalars['String']['output']>>;
  /** Significant life events mentioned by the buyer. */
  lifeEvents: Maybe<Array<LifeEvent>>;
};

export type BuyerPredictions = {
  /** Predicted lifetime value (GMV) calibrated for the buyer */
  predictionLtvGmvCalibrated: Maybe<Scalars['Float']['output']>;
};

export type BuyerRating = Rating & {
  /** Represents the count of ratings for a buyer. */
  count: Scalars['Int']['output'];
  /** Represents the final rating score of a buyer, based on all relevant metrics. */
  score: Scalars['Float']['output'];
};

export type BuyerServices = {
  /** Boolean indicator capturing whether the buyer has a complex project requiring specialized skills. */
  complexProject: Maybe<NestedMultiString>;
  /** Concerns or issues the buyer has mentioned regarding the services they need. */
  concerns: Maybe<NestedMultiString>;
  /** The current stage of the buyer's deal or project (e.g., "planning", "execution", "completed"). */
  stageOfDeal: Maybe<NestedString>;
  /** The sub-category ID associated with the services the buyer is interested in. */
  subCategoryId: Maybe<Scalars['Int']['output']>;
  /** Indicates how urgently the buyer needs the service (e.g., "urgent", "flexible"). */
  timeUrgency: Maybe<NestedString>;
};

export type BuyerState = {
  hasActiveOrders: Scalars['Boolean']['output'];
  type: BuyerType;
};

export type BuyerStatistics = {
  /** Statistics related to the buyer's order history. */
  order: Maybe<OrderStatistics>;
};

export enum BuyerType {
  FirstTimeBuyer = 'FIRST_TIME_BUYER',
  RegisteredNotConverted = 'REGISTERED_NOT_CONVERTED',
  RepeatBuyer = 'REPEAT_BUYER',
  SecondTimeBuyer = 'SECOND_TIME_BUYER',
  VeryImportantDoer = 'VERY_IMPORTANT_DOER'
}

export type BuyingReview = Node & {
  /**
   * Represents the comment left by the buyer. A buyer leaves this comment as a part
   * of their feedback after the order is completed or cancelled.
   */
  comment: Scalars['String']['output'];
  /** Represents the time when the buying review was created. */
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  /**
   * Indicates whether the work sample may be displayed as a part of the review.
   * @deprecated Use workSample
   */
  isWorkSampleVisible: Scalars['Boolean']['output'];
  /** Represents the time when the buying review will be automatically revealed. */
  revealAt: Maybe<Scalars['Timestamp']['output']>;
  /** Represents the current status of the review. */
  status: BuyingReviewStatus;
  /** Represents the list of valuations left by the buyer. */
  valuations: Array<BuyingReviewValuation>;
  /** Represents review work samples URLs and content type, null if work sample is not included in the review. */
  workSample: Maybe<BuyingReviewWorkSample>;
};

/** Status in which buying review can be found */
export enum BuyingReviewStatus {
  Deleted = 'DELETED',
  Hidden = 'HIDDEN',
  Revealed = 'REVEALED'
}

/** Represents a buyer's response to a review question. */
export type BuyingReviewValuation = {
  /**
   * A list of 'chips' that the buyer has selected in order to add more context
   * to the valuation (e.g "politeness", "professionalism", etc.).
   */
  chips: Array<BuyingReviewValuationChip>;
  /** A key which indicates the review question being asked. */
  questionKey: Scalars['String']['output'];
  /** A value (1..5, inclusive) given by the buyer as an answer to the review question. */
  value: Scalars['Int']['output'];
};

/** Represents a piece of extra information provided by a buyer when they leave a review. */
export type BuyingReviewValuationChip = {
  /** The identifier of the chip. */
  id: Scalars['ID']['output'];
  /** The title of the chip. */
  title: Scalars['String']['output'];
};

/** Represents a buyer's response to a review question. */
export type BuyingReviewWorkSample = {
  /**
   * Content type of the work sample (e.g. image/png)
   * This is the only field that is common for all work sample types.
   */
  contentType: Scalars['String']['output'];
};

export type BuyingReviewWorkSampleAudio = BuyingReviewWorkSample & {
  contentType: Scalars['String']['output'];
  /** Audio URL */
  url: Scalars['String']['output'];
};

export type BuyingReviewWorkSampleImage = BuyingReviewWorkSample & {
  contentType: Scalars['String']['output'];
  /** Work sample preview URL (used for images and PDFs) */
  previewUrl: Scalars['String']['output'];
};

export type BuyingReviewWorkSamplePdf = BuyingReviewWorkSample & {
  contentType: Scalars['String']['output'];
  /** Work sample preview URL (used for images and PDFs) */
  previewUrl: Scalars['String']['output'];
};

export type BuyingReviewWorkSampleVideo = BuyingReviewWorkSample & {
  contentType: Scalars['String']['output'];
  /** Video preview image URL */
  previewUrl: Scalars['String']['output'];
  /** Video URL */
  url: Scalars['String']['output'];
};

export type CatalogCategory = {
  id: Scalars['ID']['output'];
  /** Name of the category. */
  name: Scalars['String']['output'];
  /** Slug of the category. */
  slug: Scalars['String']['output'];
  /** Sub-categories of the category. */
  subCategories: Array<CatalogSubCategory>;
};


export type CatalogCategorySubCategoriesArgs = {
  subCategoryIds: Array<Scalars['Int']['input']>;
};

/**
 * Catalog metadata helps to categorize the Gigs. For example, a Gig can be specific to a platform (iOS, Android, etc.).
 * This taxonomy is used to help the buyers to find the Gigs they are interested in.
 */
export type CatalogMetadata = {
  /** The name of the metadata (e.g. "Platform"). */
  alias: CatalogTextualEntity;
  /** The ObjectId of the metadata. */
  id: Scalars['ID']['output'];
  /** The options of the metadata (e.g. "iOS", "Android"). */
  options: Array<CatalogMetadataOption>;
  order: Scalars['Float']['output'];
  slug: Scalars['String']['output'];
  visibility: Scalars['String']['output'];
};

export type CatalogMetadataOption = {
  /** The name of the metadata option (e.g. "iOS"). */
  alias: CatalogTextualEntity;
  order: Scalars['Float']['output'];
  /** The slug of the metadata option (e.g. "ios"). */
  slug: Scalars['String']['output'];
};

export type CatalogMetadataType = Node & {
  /** A v4 UUID of the metadata value (e.g. "612e47cf-0196-45cd-9fb6-aa479a235af6"). */
  id: Scalars['ID']['output'];
  /** The name of the metadata value (e.g. "3D texture & lighting"). */
  name: CatalogTextualEntity;
  /**
   * The slug of the metadata type (e.g. "3d_texture_and_lighting").
   * Slug is unique within the metadata type.
   */
  slug: Scalars['String']['output'];
};

export type CatalogMetadataValue = Node & {
  /** The icon of the metadata value. */
  iconUrl: Maybe<Scalars['URI']['output']>;
  /** A v4 UUID of the metadata value (e.g. "612e47cf-0196-45cd-9fb6-aa479a235af6"). */
  id: Scalars['ID']['output'];
  /** The name of the metadata value (e.g. "Lighting setups"). */
  name: CatalogTextualEntity;
  /**
   * The slug of the metadata value (e.g. "lighting_setups").
   * Slug is unique within the metadata value.
   */
  slug: Scalars['String']['output'];
  /**
   * The alias of the metadata in case it was chosen as a specialization. Otherwise, this field is null.
   * This field is not a CatalogTextualEntity since it doesn't have a translation. It would get translated only with the relevant role's specialization suffix.
   */
  specializationAlias: Maybe<Scalars['String']['output']>;
  /** The metadata type of the metadata value. */
  type: CatalogMetadataType;
};

export type CatalogNestedSubCategory = {
  id: Scalars['ID']['output'];
  /** Name of the nested-sub-category. */
  name: Scalars['String']['output'];
  /** Slug of the nested-sub-category. */
  slug: Scalars['String']['output'];
  /** The sub-category in which the nested-sub-category belongs to. */
  subCategoryId: Scalars['Float']['output'];
};

/** The Pricing factor catalog data */
export type CatalogPricingFactor = {
  label: CatalogTextualEntity;
  /** Indication whether this pricing factor is binary or numeric. */
  type: CatalogPricingFactorType;
};

export enum CatalogPricingFactorType {
  Binary = 'BINARY',
  Numeric = 'NUMERIC'
}

export type CatalogRole = Node & {
  /** The title of the role when the seller is an agency (e.g. "Software development agency"). */
  agencyTitle: CatalogTextualEntity;
  /** Specifies whether the role is experiential. */
  experiential: Scalars['Boolean']['output'];
  /** A v4 UUID of the metadata value (e.g. "612e47cf-0196-45cd-9fb6-aa479a235af6"). */
  id: Scalars['ID']['output'];
  /** The name of the role (e.g. "Full stack developer"). */
  name: CatalogTextualEntity;
  /** The plural name of the role (e.g. "Full stack developers"). */
  pluralName: CatalogTextualEntity;
  /**
   * The plural specialization suffix of the role (e.g. "developers").
   * This field is not a CatalogTextualEntity since it doesn't have a translation. It would get translated only with the relevant specialization suffix.
   */
  pluralSpecializationSuffix: Scalars['String']['output'];
  /**
   * The slug of the role (e.g. "full_stack_developer").
   * Slug is unique within the role.
   */
  slug: Scalars['String']['output'];
  /**
   * The specialization suffix of the role (e.g. "developer").
   * Used as the suffix of a specialized metadata value.
   * This field is not a CatalogTextualEntity since it doesn't have a translation. It would get translated only with the relevant specialization suffix.
   */
  specializationSuffix: Scalars['String']['output'];
};

export type CatalogRoleSpecialization = CatalogMetadataValue | CatalogService;

export type CatalogService = Node & {
  /** The name of the service as it appears in the catalog (e.g. "AI lessons"). */
  displayName: CatalogTextualEntity;
  /** The icon of the service. */
  iconUrl: Maybe<Scalars['URI']['output']>;
  /** A v4 UUID of the metadata value (e.g. "612e47cf-0196-45cd-9fb6-aa479a235af6"). */
  id: Scalars['ID']['output'];
  /**
   * The name of the service (e.g. "AI Consulting | AI Lessons").
   * Used for back-office purposes.
   * Guaranteed to be unique.
   * This field is not a CatalogTextualEntity since it doesn't have a translation. Only for internal usage.
   */
  name: Scalars['String']['output'];
  /**
   * The slug of the service (e.g. "ai_lessons").
   * Slug is unique within the service.
   */
  slug: Scalars['String']['output'];
  /**
   * The alias of the specialization (e.g. "AI education specialist").
   * In case the service is not a specialization, this field is null.
   */
  specializationAlias: Maybe<CatalogTextualEntity>;
};

export type CatalogSubCategory = {
  /** The category in which the sub-category belongs to. */
  categoryId: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  /** Name of the sub-category. */
  name: Scalars['String']['output'];
  /** Nested-sub-categories of the sub-category. */
  nestedSubCategories: Array<CatalogNestedSubCategory>;
  /** Slug of the sub-category. */
  slug: Scalars['String']['output'];
  /** Whether this sub-category is visible to buyers. */
  visibleToBuyer: Scalars['Boolean']['output'];
  /** Whether this sub-category is visible to sellers. */
  visibleToSeller: Scalars['Boolean']['output'];
};


export type CatalogSubCategoryNestedSubCategoriesArgs = {
  nestedCategoryIds: Array<Scalars['Int']['input']>;
};

export type CatalogTextualEntity = {
  /** The language of the localized text. */
  language: LanguageCode;
  /** The key of the translation in translations hub. */
  translationKey: Scalars['String']['output'];
  /** The localized text of the entity as it appears in the catalog. */
  value: Scalars['String']['output'];
};

export type CatalogWorkProcessMilestone = {
  /**
   * The milestone's description, e.g. "I'll prepare a first draft of the delivery",
   * "I'll modify assets based on your feedback", etc.
   */
  description: Scalars['String']['output'];
  /** A unique identifier for Gig milestone. A 24 character hexadecimal string. */
  id: Scalars['ID']['output'];
  /** The milestone's title, e.g. "First draft", "Modifications", etc. */
  title: Scalars['String']['output'];
};

export type CategoryMetadata = {
  categoryId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  values: Array<Maybe<MetadataFieldValue>>;
};

export type CertifiedSeller = {
  testimonials: Array<CertifiedTestimonial>;
  testimonialsEligible: Scalars['Boolean']['output'];
};


export type CertifiedSellerTestimonialsArgs = {
  statuses: InputMaybe<Array<CertifiedTestimonialStatus>>;
};

export type CertifiedTestimonial = Node & {
  client: CertifiedTestimonialClient;
  id: Scalars['ID']['output'];
  project: CertifiedTestimonialProject;
  request: CertifiedTestimonialRequest;
  revisions: Scalars['Int']['output'];
  seller: Seller;
  source: CertifiedTestimonialSource;
  status: CertifiedTestimonialStatus;
  statusReason: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
};

export type CertifiedTestimonialClient = {
  company: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

/**  Implements Connection. Omitted on purpose to avoid broken codegen dependencies */
export type CertifiedTestimonialConnection = {
  edges: Maybe<Array<CertifiedTestimonialEdge>>;
  nodes: Maybe<Array<CertifiedTestimonial>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CertifiedTestimonialEdge = {
  cursor: Scalars['String']['output'];
  node: CertifiedTestimonial;
};

export enum CertifiedTestimonialFieldValidationReason {
  Empty = 'EMPTY',
  Invalid = 'INVALID',
  NotAllowed = 'NOT_ALLOWED',
  TooLong = 'TOO_LONG',
  TooShort = 'TOO_SHORT'
}

export type CertifiedTestimonialMutationResult = CertifiedTestimonial | CertifiedTestimonialValidationError;

export type CertifiedTestimonialProject = {
  date: Scalars['Timestamp']['output'];
  name: Scalars['String']['output'];
};

export type CertifiedTestimonialRequest = {
  client: CertifiedTestimonialClient;
  message: Scalars['String']['output'];
  project: CertifiedTestimonialProject;
};

export enum CertifiedTestimonialSource {
  Certified = 'CERTIFIED',
  Pro = 'PRO',
  Unknown = 'UNKNOWN'
}

export enum CertifiedTestimonialStatus {
  Approved = 'APPROVED',
  Archived = 'ARCHIVED',
  AwaitingApproval = 'AWAITING_APPROVAL',
  New = 'NEW',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  RequiresRevision = 'REQUIRES_REVISION'
}

export enum CertifiedTestimonialStatusInput {
  Approved = 'APPROVED',
  Archived = 'ARCHIVED',
  AwaitingApproval = 'AWAITING_APPROVAL',
  New = 'NEW',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  RequiresRevision = 'REQUIRES_REVISION'
}

/**  Errors */
export type CertifiedTestimonialValidationError = {
  invalidFields: Array<InvalidCertifiedTestimonialField>;
  message: Scalars['String']['output'];
};

/**  Query Input Types */
export type CertifiedTestimonialsFilter = {
  sellerIds: InputMaybe<Array<Scalars['ID']['input']>>;
  sources: InputMaybe<Array<CertifiedTestimonialSource>>;
  statuses: InputMaybe<Array<CertifiedTestimonialStatusInput>>;
};

export type ClassificationRequestPaymentData = {
  _id: Scalars['String']['output'];
  createdAt: Scalars['Timestamp']['output'];
  currency: Maybe<Scalars['String']['output']>;
  paymentMethod: Scalars['String']['output'];
  paymentStatus: Scalars['String']['output'];
  price: Maybe<Scalars['Int']['output']>;
  updatedAt: Maybe<Scalars['Timestamp']['output']>;
};

export type CloseUserProjectGoalResult = {
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** CMS content types */
export enum CmsContentType {
  AbTest = 'AB_TEST',
  Article = 'ARTICLE',
  Banner = 'BANNER',
  BannersCarousel = 'BANNERS_CAROUSEL',
  GigCardCarousel = 'GIG_CARD_CAROUSEL',
  MediaAsset = 'MEDIA_ASSET',
  MediaGallery = 'MEDIA_GALLERY',
  PortraitTile = 'PORTRAIT_TILE',
  PortraitTilesCarousel = 'PORTRAIT_TILES_CAROUSEL',
  VerticalExperiencePage = 'VERTICAL_EXPERIENCE_PAGE'
}

export type CmsEntry = {
  /** Cms entry id */
  id: Scalars['ID']['output'];
  /** Cms entry type */
  type: Maybe<CmsContentType>;
};

export type Collection = Node & {
  /** The user who created the collection */
  creator: Maybe<User>;
  description: Maybe<Scalars['String']['output']>;
  gigsCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  inspireDeliveriesCount: Scalars['Int']['output'];
  items: CollectionItemConnection;
  name: Scalars['String']['output'];
  ownerType: Maybe<OwnerType>;
  privacy: PrivacyType;
  sellersCount: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  updatedAt: Scalars['Timestamp']['output'];
  updatedBy: Maybe<User>;
};


export type CollectionItemsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort: SortOrder;
  types: Array<CollectionItemType>;
};

export type CollectionConnection = {
  /** A list of edges. */
  edges: Maybe<Array<CollectionEdge>>;
  /** A list of nodes */
  nodes: Maybe<Array<Collection>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CollectionEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Collection>;
};

export type CollectionItem = Gig | InspireDelivery | Seller;

export type CollectionItemConnection = {
  /** A list of edges. */
  edges: Maybe<Array<CollectionItemEdge>>;
  /** A list of nodes */
  nodes: Maybe<Array<Maybe<CollectionItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CollectionItemEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item metadata. */
  metadata: Maybe<CollectionItemMeta>;
  /** The item at the end of the edge. */
  node: Maybe<CollectionItem>;
};

export type CollectionItemMeta = {
  addedAt: Maybe<Scalars['Timestamp']['output']>;
  addedBy: Maybe<User>;
};

export enum CollectionItemType {
  Gig = 'GIG',
  InspireDelivery = 'INSPIRE_DELIVERY',
  Seller = 'SELLER'
}

export enum CollectionSortBy {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type CollectionSorting = {
  sortBy: CollectionSortBy;
  sortOrder: SortOrder;
};

export enum CommunicationPreference {
  Text = 'TEXT',
  Video = 'VIDEO'
}

export type Company = {
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Indicates if a company is in Fortune list */
  inFortuneList: Scalars['Boolean']['output'];
  /** The industry of the company */
  industry: Maybe<Industry>;
  logoImage: Maybe<Attachment>;
  /** The name of the company. e.g., Microsoft */
  name: Scalars['String']['output'];
};

export type CompanyProfile = {
  /** Company description */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Indicates if a company is in Fortune list */
  inFortuneList: Scalars['Boolean']['output'];
  /** Company industry */
  industry: Maybe<Scalars['String']['output']>;
  /** Company logo url */
  logo: Maybe<Scalars['String']['output']>;
  /** Company name */
  name: Scalars['String']['output'];
  /** Company status */
  status: CompanyStatus;
};

export enum CompanyStatus {
  Approved = 'APPROVED',
  Denied = 'DENIED',
  FromLinkedin = 'FROM_LINKEDIN',
  PendingValidation = 'PENDING_VALIDATION',
  Unverified = 'UNVERIFIED'
}

/** Information about a pagination connection */
export type Connection = {
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type ContentPageData = {
  data: Maybe<Scalars['JSON']['output']>;
};

export type Context = {
  id: Scalars['String']['output'];
  type: ContextType;
};

export type ContextOrdersFilters = {
  buyerIds: InputMaybe<Array<Scalars['String']['input']>>;
  projectIds: InputMaybe<Array<Scalars['String']['input']>>;
  statuses: InputMaybe<OrderStatusInput>;
};

export enum ContextType {
  Team = 'TEAM',
  User = 'USER'
}

export enum ContextTypeInput {
  Organization = 'ORGANIZATION',
  User = 'USER'
}

export type Conversation = Node & {
  /** Identifies the time the conversation was created */
  createdAt: Scalars['Timestamp']['output'];
  /** Conversation id. */
  id: Scalars['ID']['output'];
  /** Conversation's last message body text */
  lastMessageBody: Scalars['String']['output'];
  /** Conversation's recipient user */
  recipientUser: User;
  /** Identifies the time the conversation was updated */
  updatedAt: Scalars['Timestamp']['output'];
};

/** The connection type for ConversationConnection */
export type ConversationConnection = {
  /** A list of nodes */
  nodes: Maybe<Array<Conversation>>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection */
  totalCount: Scalars['Int']['output'];
};

export type ConversationMessagingContext = {
  conversation: Maybe<Conversation>;
};

export enum ConversationType {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  HasProposal = 'HAS_PROPOSAL',
  Labels = 'LABELS',
  None = 'NONE',
  Sent = 'SENT',
  Spam = 'SPAM',
  Starred = 'STARRED',
  Unread = 'UNREAD'
}

export enum CountryCode {
  Ac = 'AC',
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  An = 'AN',
  Ao = 'AO',
  Aq = 'AQ',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Bq = 'BQ',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cp = 'CP',
  Cr = 'CR',
  Cu = 'CU',
  Cv = 'CV',
  Cw = 'CW',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dg = 'DG',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ea = 'EA',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Eu = 'EU',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Ic = 'IC',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Qo = 'QO',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Sv = 'SV',
  Sx = 'SX',
  Sy = 'SY',
  Sz = 'SZ',
  Ta = 'TA',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Um = 'UM',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Xk = 'XK',
  Ye = 'YE',
  Yt = 'YT',
  Za = 'ZA',
  Zm = 'ZM',
  Zw = 'ZW',
  Zz = 'ZZ'
}

export type Coupon = {
  buyer: User;
  code: Maybe<Scalars['String']['output']>;
  discount: CouponDiscount;
  expiresAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  minOrderAmount: Scalars['MoneyAmount']['output'];
  note: Maybe<Scalars['String']['output']>;
  seller: Seller;
  status: CouponStatus;
  type: CouponType;
  usage: Maybe<CouponUsage>;
};

export type CouponConfiguration = {
  discountRange: Array<Scalars['Int']['output']>;
  expiresWithin: CouponDuration;
  minOrderAmount: Scalars['MoneyAmount']['output'];
};

export type CouponConnection = {
  edges: Maybe<Array<CouponEdge>>;
  nodes: Maybe<Array<Coupon>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CouponDiscount = {
  type: CouponDiscountType;
  value: Scalars['Int']['output'];
};

export enum CouponDiscountType {
  /** Percent discount, subtracted from a total order amount */
  GrossPercent = 'GROSS_PERCENT',
  /** 20/80 split between fiverr and seller */
  SharedFiverrSellerPercent = 'SHARED_FIVERR_SELLER_PERCENT'
}

export type CouponDuration = {
  unit: TimeUnit;
  value: Scalars['Int']['output'];
};

export type CouponEdge = {
  cursor: Scalars['String']['output'];
  node: Coupon;
};

export type CouponQuota = {
  allowedBuyersAmount: Scalars['Int']['output'];
  availableGigsAmount: Scalars['Int']['output'];
  config: CouponConfiguration;
  hasAllowedBuyers: Scalars['Boolean']['output'];
  /**
   * Number of the allowed buyers capped by the quota limit for performance optimization.
   * Returns the smaller value of actual allowed buyers count and the quota limit.
   */
  quotaBasedAllowedBuyersAmount: Scalars['Int']['output'];
  refillDate: Scalars['Timestamp']['output'];
  remaining: Scalars['Int']['output'];
  /** Total number of coupons available for this quota, which is effectively the sum of used and remaining coupons. */
  total: Scalars['Int']['output'];
  used: Scalars['Int']['output'];
};

export enum CouponStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Used = 'USED'
}

export type CouponSummary = {
  couponsSent: Scalars['Int']['output'];
  topDiscountPercent: Maybe<Scalars['Int']['output']>;
  totalBuyers: Scalars['Int']['output'];
  totalOrders: Scalars['Int']['output'];
  totalRevenue: Scalars['Int']['output'];
};

export enum CouponType {
  /** Can be issued to any buyer, but has lesser expiration time */
  Conversion = 'CONVERSION',
  /** Can be issued only if there's at least one completed order between buyer and seller */
  Retention = 'RETENTION'
}

export type CouponUsage = {
  usedAt: Scalars['Timestamp']['output'];
};

/** Seller's completed course. */
export type Course = {
  id: Scalars['ID']['output'];
  /** The last date when the course status was updated */
  updatedAt: Maybe<Scalars['Timestamp']['output']>;
};

/** The connection type for Course to support pagination. */
export type CourseConnection = {
  /** A list of edges. */
  edges: Maybe<Array<CourseEdge>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Course>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a CourseConnection. */
export type CourseEdge = {
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge. */
  node: Maybe<Course>;
};

export type CreateAgencyInput = {
  description: InputMaybe<Scalars['String']['input']>;
  profileBackgroundAttachmentId: Scalars['String']['input'];
};

export type CreateFollowUpCampaignResult = FollowUpCampaign | FollowUpCampaignInvalidInput | FollowUpMessagesQuotaReached;

export type CreatePromotionResult = Promotion | PromotionGigInUse | PromotionInvalidInput | PromotionQuotaReached | PromotionUsageQuotaReached;

export type CreditReward = {
  amountInCents: Scalars['Int']['output'];
  expiryDate: Scalars['Timestamp']['output'];
  financialActivityId: Maybe<Scalars['String']['output']>;
};

export enum CropOptions {
  Limit = 'LIMIT'
}

export enum Currency {
  Aed = 'AED',
  Aud = 'AUD',
  Brl = 'BRL',
  Cad = 'CAD',
  Chf = 'CHF',
  Cny = 'CNY',
  Eur = 'EUR',
  Gbp = 'GBP',
  Hkd = 'HKD',
  Ils = 'ILS',
  Inr = 'INR',
  Mxn = 'MXN',
  Myr = 'MYR',
  Nzd = 'NZD',
  Php = 'PHP',
  Pkr = 'PKR',
  Sek = 'SEK',
  Sgd = 'SGD',
  Thb = 'THB',
  Try = 'TRY',
  Twd = 'TWD',
  Unknown = 'UNKNOWN',
  Usd = 'USD',
  Zar = 'ZAR'
}

export type CurrentUser = {
  /** The social providers connected to the currentUser */
  socialProviders: Array<SocialProvider>;
};

/** scalar MoneyAmount */
export type CustomOffer = {
  buyer: User;
  buyerResponse: Maybe<Scalars['String']['output']>;
  coverLetter: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  customPackage: Maybe<CustomPackage>;
  customPackageId: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  dmBrief: Maybe<DmBrief>;
  id: Scalars['ID']['output'];
  message: Maybe<Message>;
  price: Maybe<Money>;
  screeningQuestions: Maybe<Array<CustomOfferScreeningQuestion>>;
  seller: Seller;
  sellerQuestions: Maybe<Array<Maybe<QuestionAnswerPair>>>;
  status: CustomOfferStatus;
  zoomMeetingRequestSent: Maybe<Scalars['Boolean']['output']>;
};

export type CustomOfferConnection = {
  edges: Array<CustomOfferEdge>;
  nodes: Array<CustomOffer>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CustomOfferEdge = {
  cursor: Scalars['String']['output'];
  node: CustomOffer;
};

export type CustomOfferGig = {
  attachments: Array<Maybe<GigAttachment>>;
  category: GigCategory;
  customExtras: Array<Maybe<GigCustomExtra>>;
  id: Scalars['ID']['output'];
  isPro: Scalars['Boolean']['output'];
  localizedTitle: Maybe<LocalizedText>;
  packages: Array<Maybe<GigPackage>>;
  seller: CustomOfferSeller;
  slug: Scalars['String']['output'];
};


export type CustomOfferGigPackagesArgs = {
  packageIds: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CustomOfferHourlyRate = {
  id: Maybe<Scalars['ID']['output']>;
  priceInCents: Maybe<Scalars['Int']['output']>;
};

export type CustomOfferScreeningQuestion = {
  answer: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: CustomOfferScreeningQuestionKind;
  question: Scalars['String']['output'];
};

export enum CustomOfferScreeningQuestionKind {
  Custom = 'CUSTOM',
  Suggested = 'SUGGESTED'
}

export type CustomOfferSeller = {
  hourlyRate: Maybe<CustomOfferHourlyRate>;
  id: Scalars['ID']['output'];
  user: CustomOfferUser;
};

export enum CustomOfferStatus {
  Accepted = 'ACCEPTED',
  Active = 'ACTIVE',
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  Unrecognized = 'UNRECOGNIZED',
  Withdrawn = 'WITHDRAWN'
}

export type CustomOfferUser = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CustomOffersMetrics = {
  acceptedCount: Scalars['Int']['output'];
  nonCancelledCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type CustomPackage = {
  buyer: User;
  /**
   * The creation time of the custom package.
   * Format: ISO_8601
   */
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  /** The time it will take to deliver the package (in units described by durationUnit). */
  duration: Scalars['Int']['output'];
  /** The corresponding unit of measurement for the 'duration' field. */
  durationUnit: Scalars['String']['output'];
  /** The expiration time of the offer (in days), if null the offer will not expire. */
  expirationDays: Maybe<Scalars['Int']['output']>;
  /** The gig associated with the custom package. */
  gig: Gig;
  /** Data related to hourly pricing if the package supports it. */
  hourlyOption: Maybe<HourlyOption>;
  /** A unique identifier for the Custom Package. A 24 character hexadecimal string. */
  id: Scalars['ID']['output'];
  /** The order created from the custom package, if status: "accepted". */
  order: Maybe<Order>;
  /** Relative order of the package for the Gig. Can have value of -1,0,1,2,3. */
  packageId: Scalars['Int']['output'];
  /**
   * The type of the custom package.
   * Designed to be able to support different types of custom packages, currently only supports "custom_package".
   */
  packageType: Scalars['String']['output'];
  /** Number of active packages the gig offers. */
  packagesCount: Maybe<Scalars['Int']['output']>;
  /**
   * The milestones (pay-per milestone) the seller has offered, designed so the work will be split into parts the buyer pays per completion.
   * Only applicable if not a ‘single payment’ offer.
   */
  paymentMilestones: Array<PaymentMilestone>;
  /**
   * The price (in USD) of the payment milestone.
   * Example: price of 50 means $50 (5000 cents).
   */
  price: Scalars['Float']['output'];
  /**
   * Additional pricing factors for the custom package, set by the seller on offer creation.
   * Example:
   * HD resolution, source file, revisions, etc.
   */
  pricingFactors: Array<PricingFactor>;
  /** Subscription information on the custom package, if the package is a subscription. */
  recurringOption: Maybe<CustomRecurringOption>;
  seller: Seller;
  /** Skip the package requirements, order will start immediately after purchase without the buyer answering additional questions. */
  skipRequirements: Scalars['Boolean']['output'];
  /** The flow from which the custom package originated. */
  source: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  /**
   * The title of the custom package.
   * Packages created from custom offer will have the title of the original gig.
   * Other possible values determined by the flow the custom package was created from.
   * Example: "make a custom logo" from the Fiverr Logo Maker.
   */
  title: Scalars['String']['output'];
  /**
   * The last update time of the custom package.
   * Format: ISO_8601
   */
  updatedAt: Scalars['DateTime']['output'];
};

export type CustomRecurringOption = {
  /** The number of times the custom package will be billed. */
  amount: Maybe<Scalars['Int']['output']>;
  /** The interval at which the billing occurs, defined by the seller. */
  billingIntervalCount: Maybe<Scalars['Int']['output']>;
  /**
   * The discount percentage for the subscription.
   * Optional field.
   */
  discountPercentage: Maybe<Scalars['Int']['output']>;
  /** When the first discount is applied. (default 2) */
  firstDiscounted: Maybe<Scalars['Int']['output']>;
  /**
   * The corresponding unit of time for the 'billingIntervalCount' field.
   * Defines whether the billing interval is in days, months, etc.
   */
  timeUnit: Maybe<Scalars['String']['output']>;
};

export type Customer = BusinessCustomer | UserCustomer;

export type DataModel = {
  data: Maybe<Scalars['JSON']['output']>;
};

export type DataModelList = {
  data: Maybe<Scalars['JSON']['output']>;
};

export type DateQuery = {
  from: InputMaybe<Scalars['Timestamp']['input']>;
  to: InputMaybe<Scalars['Timestamp']['input']>;
};

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DeactivateAgencyInput = {
  id: Scalars['ID']['input'];
  questionnaire: InputMaybe<Array<DeactivateAgencyQuestionInput>>;
};

export type DeactivateAgencyQuestionInput = {
  answers: Array<Scalars['String']['input']>;
  question: Scalars['String']['input'];
};

export type DeactivateAgencyResult = Agency | AgencyAlreadyInStatus | AgencyNotFound;

export type DefaultIndustry = {
  defaultValue: Maybe<Industry>;
  options: IndustryOptions;
  requirementId: Maybe<Scalars['String']['output']>;
};

export type DefaultProjectGoal = {
  defaultValue: Maybe<Goal>;
  options: ProjectGoalOptions;
  requirementId: Maybe<Scalars['String']['output']>;
};

export enum DegreeTitle {
  Associate = 'ASSOCIATE',
  Ba = 'BA',
  Barch = 'BARCH',
  Bfa = 'BFA',
  Bm = 'BM',
  Bsc = 'BSC',
  Certificate = 'CERTIFICATE',
  Jd = 'JD',
  Llb = 'LLB',
  Llm = 'LLM',
  Ma = 'MA',
  Mba = 'MBA',
  Md = 'MD',
  Mfa = 'MFA',
  Msc = 'MSC',
  Other = 'OTHER',
  Phd = 'PHD'
}

export type Deliverable = {
  duration: Maybe<Duration>;
  extraFast: Scalars['Boolean']['output'];
  requiresDelivery: Scalars['Boolean']['output'];
};

export enum DeliveriesFiltrationAlgorithm {
  CriteriaByDeliveredDateOrdered = 'CRITERIA_BY_DELIVERED_DATE_ORDERED',
  NativeShuffle = 'NATIVE_SHUFFLE'
}

export type DeliveryInput = {
  gigCategory: GigCategoryInput;
  id: Scalars['ID']['input'];
};

export type DeliveryItem = {
  buyer: Maybe<User>;
  category: GigCategory;
  deliveredDate: Scalars['Timestamp']['output'];
  description: Maybe<Scalars['String']['output']>;
  gig: Maybe<Gig>;
  id: Scalars['ID']['output'];
  industries: Array<Maybe<Industry>>;
  keywords: Array<Maybe<Scalars['String']['output']>>;
  /**  The curation-system determined primary delivery attachment file of image type */
  originalDeliveryAttachment: Maybe<Attachment>;
  qualityLevel: DeliveryQualityLevel;
  shortDescription: Maybe<Scalars['String']['output']>;
};

export enum DeliveryQualityLevel {
  Awesome = 'AWESOME',
  Fair = 'FAIR',
  NotAssessed = 'NOT_ASSESSED'
}

export type DeliveryVoteInput = {
  delivery: DeliveryInput;
  value: Scalars['Int']['input'];
};

export enum DetailedOrderStatus {
  AdminCancelled = 'ADMIN_CANCELLED',
  BuyerCancelled = 'BUYER_CANCELLED',
  CancelledByMutualAgreement = 'CANCELLED_BY_MUTUAL_AGREEMENT',
  Completed = 'COMPLETED',
  Delivered = 'DELIVERED',
  InProgress = 'IN_PROGRESS',
  LateDelivery = 'LATE_DELIVERY',
  LateDeliveryNoRes = 'LATE_DELIVERY_NO_RES',
  MutualCancellationRequestedByBuyer = 'MUTUAL_CANCELLATION_REQUESTED_BY_BUYER',
  MutualCancellationRequestedBySeller = 'MUTUAL_CANCELLATION_REQUESTED_BY_SELLER',
  New = 'NEW',
  Rejected = 'REJECTED',
  SellerCancelled = 'SELLER_CANCELLED',
  WaitingForReqs = 'WAITING_FOR_REQS'
}

export type DmAuctionContext = {
  status: DmAuctionStatus;
};

export enum DmAuctionStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS'
}

export type DmBrief = BriefData & BriefTemplate & Node & {
  attachments: Maybe<Array<BriefAttachment>>;
  auctionContext: Maybe<DmAuctionContext>;
  budgetInCents: Scalars['Int']['output'];
  budgetRangeInCents: Maybe<DmBriefBudgetRange>;
  categoryId: Scalars['Int']['output'];
  content: DmBriefContent;
  contentPreview: Scalars['String']['output'];
  contextId: Scalars['ID']['output'];
  contextType: BriefContextType;
  createdAt: Scalars['Timestamp']['output'];
  createdBy: Buyer;
  customOffersMetrics: CustomOffersMetrics;
  deliveryDate: Maybe<Scalars['Timestamp']['output']>;
  description: Scalars['String']['output'];
  displayStatus: Maybe<DmBriefDisplayStatus>;
  /** Edit history and metadata for the brief. */
  editDetails: Maybe<DmBriefEditDetails>;
  /** Extra wave status information. Only present for AUCTION and HIGH_TOUCH tiers. */
  extraWaveStatus: Maybe<ExtraWaveStatusInfo>;
  /**  Interface fields (inherited from BriefData) */
  id: Scalars['ID']['output'];
  matchCandidates: Maybe<DmMatchCandidateConnection>;
  matchCandidatesMetrics: Maybe<MatchCandidatesMetrics>;
  metadataAnswers: Maybe<DmBriefMetadataAnswers>;
  needType: Maybe<DmBriefNeedType>;
  needTypeDetails: Maybe<DmBriefNeedTypeDetails>;
  nestedSubCategoryId: Maybe<Scalars['Int']['output']>;
  /**
   * amount of related ACTIVE, ACCEPTED or DRAFT custom offers
   * @deprecated nested in customOffersMetrics
   */
  offersCount: Scalars['Int']['output'];
  originalBuyerBudget: Maybe<Money>;
  originalBuyerBudgetRange: Maybe<DmBriefMoneyRange>;
  pricingType: BriefPricingType;
  screeningQuestions: Maybe<Array<DmBriefScreeningQuestion>>;
  status: DmBriefStatus;
  subCategoryId: Maybe<Scalars['Int']['output']>;
  tier: DmBriefTier;
  timeline: DmBriefTimeline;
  timelineDetails: Maybe<DmBriefTimelineDetails>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Timestamp']['output'];
  updatedBy: User;
};


export type DmBriefAttachmentsArgs = {
  previewTransformations?: InputMaybe<Array<AttachmentPreviewTransformation>>;
};


export type DmBriefMatchCandidatesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  filters: InputMaybe<MatchCandidatesFilters>;
  first: Scalars['Int']['input'];
};

export enum DmBriefAgencyPreference {
  Exclude = 'EXCLUDE',
  Prioritize = 'PRIORITIZE'
}

export type DmBriefBudgetRange = {
  max: Scalars['Int']['output'];
  min: Maybe<Scalars['Int']['output']>;
};

export type DmBriefConnection = {
  edges: Array<DmBriefEdge>;
  nodes: Array<DmBrief>;
  pageInfo: PageInfo;
  /** Identifies the total count of non deleted items in the connection */
  totalCount: Scalars['Int']['output'];
};

export type DmBriefContent = {
  generatedContent: Array<DmBriefGeneratedContent>;
};

export enum DmBriefCountryCode {
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  An = 'AN',
  Ao = 'AO',
  Ar = 'AR',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Bq = 'BQ',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cr = 'CR',
  Cu = 'CU',
  Cv = 'CV',
  Cw = 'CW',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fo = 'FO',
  Fr = 'FR',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Ps = 'PS',
  Pt = 'PT',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Sv = 'SV',
  Sx = 'SX',
  Sz = 'SZ',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Um = 'UM',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Xk = 'XK',
  Ye = 'YE',
  Yt = 'YT',
  Za = 'ZA',
  Zm = 'ZM',
  Zw = 'ZW',
  Zz = 'ZZ'
}

export enum DmBriefDisplayStatus {
  Done = 'DONE',
  Hired = 'HIRED',
  Inactive = 'INACTIVE',
  Live = 'LIVE',
  NoInvitesSent = 'NO_INVITES_SENT',
  Rejected = 'REJECTED',
  Unknown = 'UNKNOWN'
}

export type DmBriefEdge = {
  cursor: Scalars['String']['output'];
  node: DmBrief;
};

export type DmBriefEditDetails = {
  /** Total number of times the brief has been edited. */
  editCount: Scalars['Int']['output'];
  /** User ID who last edited the brief. */
  editedBy: Maybe<Scalars['ID']['output']>;
  /** Timestamp when the brief was last edited. */
  editedOn: Maybe<Scalars['Timestamp']['output']>;
};

export type DmBriefFreelancerPreferences = {
  countries: Maybe<Array<DmBriefCountryCode>>;
  freelancerType: Maybe<DmBriefFreelancerType>;
  languages: Maybe<Array<DmBriefLanguagePreference>>;
  /** Preferences match level indicators */
  matchIndicators: Maybe<Array<DmBriefSellerMatchIndicators>>;
  /** @deprecated Use regionsData instead */
  regions: Maybe<Array<Scalars['String']['output']>>;
  regionsData: Maybe<Array<DmBriefRegion>>;
  timezone: Maybe<DmBriefTimezone>;
};


export type DmBriefFreelancerPreferencesMatchIndicatorsArgs = {
  sellerIds: Array<Scalars['ID']['input']>;
};

export type DmBriefFreelancerType = {
  agencyPreference: Maybe<DmBriefAgencyPreference>;
  isVettedPro: Maybe<Scalars['Boolean']['output']>;
  minLevel: Maybe<DmBriefSellerLevel>;
};

export type DmBriefGeneratedContent = {
  content: Scalars['String']['output'];
  included: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export enum DmBriefHiringDuration {
  LessThanOneMonth = 'LESS_THAN_ONE_MONTH',
  MoreThanThreeMonths = 'MORE_THAN_THREE_MONTHS',
  OneToThreeMonths = 'ONE_TO_THREE_MONTHS'
}

export enum DmBriefLanguageCode {
  Aa = 'AA',
  Ab = 'AB',
  Ae = 'AE',
  Af = 'AF',
  Ak = 'AK',
  Am = 'AM',
  An = 'AN',
  Ar = 'AR',
  As = 'AS',
  Av = 'AV',
  Ay = 'AY',
  Az = 'AZ',
  Ba = 'BA',
  Be = 'BE',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Br = 'BR',
  Bs = 'BS',
  Ca = 'CA',
  Ce = 'CE',
  Ch = 'CH',
  Co = 'CO',
  Cr = 'CR',
  Cs = 'CS',
  Cv = 'CV',
  Cy = 'CY',
  Da = 'DA',
  De = 'DE',
  Ee = 'EE',
  El = 'EL',
  En = 'EN',
  Eo = 'EO',
  Es = 'ES',
  Et = 'ET',
  Eu = 'EU',
  Fa = 'FA',
  Ff = 'FF',
  Fi = 'FI',
  Fj = 'FJ',
  Fo = 'FO',
  Fr = 'FR',
  Fy = 'FY',
  Ga = 'GA',
  Gd = 'GD',
  Gl = 'GL',
  Gn = 'GN',
  Gu = 'GU',
  Gv = 'GV',
  Ha = 'HA',
  He = 'HE',
  Hi = 'HI',
  Ho = 'HO',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Hy = 'HY',
  Hz = 'HZ',
  Ia = 'IA',
  Id = 'ID',
  Ig = 'IG',
  Ii = 'II',
  Ik = 'IK',
  Io = 'IO',
  Is = 'IS',
  It = 'IT',
  Iu = 'IU',
  Ja = 'JA',
  Jp = 'JP',
  Jv = 'JV',
  Jw = 'JW',
  Ka = 'KA',
  Kg = 'KG',
  Ki = 'KI',
  Kj = 'KJ',
  Kk = 'KK',
  Kl = 'KL',
  Km = 'KM',
  Kn = 'KN',
  Ko = 'KO',
  Kr = 'KR',
  Ks = 'KS',
  Ku = 'KU',
  Kv = 'KV',
  Kw = 'KW',
  Ky = 'KY',
  La = 'LA',
  Lb = 'LB',
  Lg = 'LG',
  Li = 'LI',
  Ln = 'LN',
  Lo = 'LO',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Mg = 'MG',
  Mh = 'MH',
  Mi = 'MI',
  Mk = 'MK',
  Ml = 'ML',
  Mn = 'MN',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  My = 'MY',
  Na = 'NA',
  Nb = 'NB',
  Nd = 'ND',
  Ne = 'NE',
  Ng = 'NG',
  Nl = 'NL',
  Nn = 'NN',
  No = 'NO',
  Nr = 'NR',
  Nv = 'NV',
  Ny = 'NY',
  Oc = 'OC',
  Oj = 'OJ',
  Om = 'OM',
  Or = 'OR',
  Os = 'OS',
  Pa = 'PA',
  Pi = 'PI',
  Pl = 'PL',
  Ps = 'PS',
  Pt = 'PT',
  Qu = 'QU',
  Rm = 'RM',
  Rn = 'RN',
  Ro = 'RO',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Si = 'SI',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sq = 'SQ',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Su = 'SU',
  Sv = 'SV',
  Sw = 'SW',
  Ta = 'TA',
  Te = 'TE',
  Tg = 'TG',
  Th = 'TH',
  Ti = 'TI',
  Tk = 'TK',
  Tl = 'TL',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Ts = 'TS',
  Tt = 'TT',
  Tw = 'TW',
  Ty = 'TY',
  Ug = 'UG',
  Uk = 'UK',
  Ur = 'UR',
  Uz = 'UZ',
  Ve = 'VE',
  Vi = 'VI',
  Vo = 'VO',
  Wa = 'WA',
  Wo = 'WO',
  Xh = 'XH',
  Yi = 'YI',
  Yo = 'YO',
  Za = 'ZA',
  Zh = 'ZH',
  Zu = 'ZU',
  Zz = 'ZZ'
}

export type DmBriefLanguagePreference = {
  languageCode: DmBriefLanguageCode;
  minProficiency: LanguageProficiencyLevel;
};

export type DmBriefMatchIndicator = {
  matchLevel: DmBriefMatchIndicatorLevel;
};

export enum DmBriefMatchIndicatorLevel {
  FullMatch = 'FULL_MATCH',
  NoMatch = 'NO_MATCH',
  PartialMatch = 'PARTIAL_MATCH'
}

export type DmBriefMetadataAnswers = {
  /** Client preferences for potential freelancers */
  freelancerPreferences: Maybe<DmBriefFreelancerPreferences>;
  serviceOptions: Array<DmBriefMetadataAnswersEntry>;
};

export type DmBriefMetadataAnswersEntry = {
  key: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type DmBriefMoneyRange = {
  max: Money;
  min: Maybe<Money>;
};

export enum DmBriefNeedType {
  OneTime = 'ONE_TIME',
  Ongoing = 'ONGOING'
}

export type DmBriefNeedTypeDetails = {
  ongoingWorkPotential: Maybe<Scalars['Boolean']['output']>;
};

export type DmBriefRegion = {
  displayName: Scalars['String']['output'];
  regionId: Scalars['String']['output'];
};

export type DmBriefScreeningQuestion = {
  id: Scalars['ID']['output'];
  kind: DmBriefScreeningQuestionKind;
  question: Scalars['String']['output'];
};

export enum DmBriefScreeningQuestionKind {
  Custom = 'CUSTOM',
  Suggested = 'SUGGESTED'
}

export enum DmBriefSellerLevel {
  LevelOne = 'LEVEL_ONE',
  LevelTrs = 'LEVEL_TRS',
  LevelTwo = 'LEVEL_TWO',
  NoLevel = 'NO_LEVEL'
}

export type DmBriefSellerMatchIndicators = {
  freelancerType: Maybe<DmBriefMatchIndicator>;
  languages: Maybe<DmBriefMatchIndicator>;
  location: Maybe<DmBriefMatchIndicator>;
  sellerId: Scalars['ID']['output'];
  sellerLevel: Maybe<DmBriefMatchIndicator>;
  timezone: Maybe<DmBriefMatchIndicator>;
};

export enum DmBriefStatus {
  Active = 'ACTIVE',
  ClosedBuyerBlocked = 'CLOSED_BUYER_BLOCKED',
  ClosedBuyerRestricted = 'CLOSED_BUYER_RESTRICTED',
  ClosedByBuyer = 'CLOSED_BY_BUYER',
  ClosedFailedModeration = 'CLOSED_FAILED_MODERATION',
  ClosedOrganizationRemoved = 'CLOSED_ORGANIZATION_REMOVED',
  ClosedStale = 'CLOSED_STALE',
  Deleted = 'DELETED',
  PendingModeration = 'PENDING_MODERATION'
}

export enum DmBriefTier {
  Auction = 'AUCTION',
  HighTouch = 'HIGH_TOUCH',
  ManualInvites = 'MANUAL_INVITES'
}

export enum DmBriefTimeCommitment {
  OverThirtyHoursPerWeek = 'OVER_THIRTY_HOURS_PER_WEEK',
  TenToThirtyHoursPerWeek = 'TEN_TO_THIRTY_HOURS_PER_WEEK',
  UpToTenHoursPerWeek = 'UP_TO_TEN_HOURS_PER_WEEK'
}

export enum DmBriefTimeUnit {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type DmBriefTimeUnitAndValue = {
  unit: DmBriefTimeUnit;
  value: Scalars['Int']['output'];
};

export enum DmBriefTimeline {
  Flexible = 'FLEXIBLE',
  GeneralTimeline = 'GENERAL_TIMELINE',
  Ongoing = 'ONGOING',
  SoonAsPossible = 'SOON_AS_POSSIBLE',
  SpecificDate = 'SPECIFIC_DATE'
}

export type DmBriefTimelineDetails = {
  deliveriesFrequency: Maybe<DmBriefTimeUnitAndValue>;
  generalTimeline: Maybe<DmBriefTimeUnitAndValue>;
  hiringDuration: Maybe<DmBriefHiringDuration>;
  timeCommitment: Maybe<DmBriefTimeCommitment>;
};

/** Represents a brief timezone preference. */
export type DmBriefTimezone = {
  /** The buyer selected max offset from the preferred timezone in hours. */
  maxOffsetHours: Scalars['Int']['output'];
  /** The buyer preferred timezone data. */
  timezoneData: Maybe<DmBriefTimezoneData>;
  timezoneId: Scalars['String']['output'];
};

export type DmBriefTimezoneData = {
  /**
   * Difference from the current user timezone in hours. null if the current user timezone is not available.
   * positive value - the user's timezone is ahead of the brief timezone,
   * negative value - the user's timezone is behind the brief timezone.
   */
  diffFromCurrentUserTimezoneInHours: Maybe<Scalars['Int']['output']>;
  /** The timezone display name. e.g. "America/New York". */
  displayName: Scalars['String']['output'];
  timezoneId: Scalars['String']['output'];
  utcOffsetInHours: Scalars['Int']['output'];
};

export type DmMatchCandidate = Node & {
  brief: Maybe<DmBrief>;
  /** @deprecated Use buyerTemp instead */
  buyer: User;
  buyerTemp: Buyer;
  createdAt: Scalars['Timestamp']['output'];
  createdByFlow: DmMatchCandidateCreationFlow;
  customOffer: Maybe<CustomOffer>;
  id: Scalars['ID']['output'];
  rejectReason: Maybe<DmMatchCandidateRejectReason>;
  seller: Seller;
  status: DmMatchCandidateStatus;
  updatedAt: Scalars['Timestamp']['output'];
};

export type DmMatchCandidateConnection = {
  edges: Array<DmMatchCandidateEdge>;
  nodes: Array<DmMatchCandidate>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum DmMatchCandidateCreationFlow {
  AgentAndBuyerInvite = 'AGENT_AND_BUYER_INVITE',
  AgentInvite = 'AGENT_INVITE',
  Auction = 'AUCTION',
  AuctionAndBuyerInvite = 'AUCTION_AND_BUYER_INVITE',
  BuyerInvite = 'BUYER_INVITE'
}

export type DmMatchCandidateEdge = {
  cursor: Scalars['String']['output'];
  node: DmMatchCandidate;
};

export enum DmMatchCandidateRejectReason {
  BudgetTooLow = 'BUDGET_TOO_LOW',
  NoMatchedSkills = 'NO_MATCHED_SKILLS',
  Overqualified = 'OVERQUALIFIED',
  PoorClientReviews = 'POOR_CLIENT_REVIEWS',
  Spam = 'SPAM',
  TooManyProjects = 'TOO_MANY_PROJECTS',
  UnrealisticExpectations = 'UNREALISTIC_EXPECTATIONS',
  VagueDescription = 'VAGUE_DESCRIPTION'
}

export enum DmMatchCandidateStatus {
  Active = 'ACTIVE',
  ClosedBriefClosed = 'CLOSED_BRIEF_CLOSED',
  ClosedBriefFailedModeration = 'CLOSED_BRIEF_FAILED_MODERATION',
  ClosedBuyerBlocked = 'CLOSED_BUYER_BLOCKED',
  ClosedBuyerRestricted = 'CLOSED_BUYER_RESTRICTED',
  ClosedRejectedBySeller = 'CLOSED_REJECTED_BY_SELLER',
  ClosedSellerBlocked = 'CLOSED_SELLER_BLOCKED',
  ClosedStale = 'CLOSED_STALE',
  OfferSent = 'OFFER_SENT',
  PendingBriefModeration = 'PENDING_BRIEF_MODERATION'
}

export type DmSellerPreferences = {
  isDisabled: Scalars['Boolean']['output'];
  minBudgetInCents: Maybe<Scalars['Int']['output']>;
};

export type DuplicateBriefData = BriefData & {
  attachments: Maybe<Array<BriefAttachment>>;
  auctionContext: Maybe<DmAuctionContext>;
  budgetRangeInCents: Maybe<DmBriefBudgetRange>;
  categoryId: Scalars['Int']['output'];
  content: DmBriefContent;
  contentPreview: Scalars['String']['output'];
  contextId: Scalars['ID']['output'];
  contextType: BriefContextType;
  createdAt: Scalars['Timestamp']['output'];
  createdBy: Buyer;
  deliveryDate: Maybe<Scalars['Timestamp']['output']>;
  description: Scalars['String']['output'];
  displayStatus: Maybe<DmBriefDisplayStatus>;
  editDetails: Maybe<DmBriefEditDetails>;
  /**  Interface fields (inherited from BriefData) */
  id: Scalars['ID']['output'];
  metadataAnswers: Maybe<DmBriefMetadataAnswers>;
  needType: Maybe<DmBriefNeedType>;
  needTypeDetails: Maybe<DmBriefNeedTypeDetails>;
  nestedSubCategoryId: Maybe<Scalars['Int']['output']>;
  originalBuyerBudget: Maybe<Money>;
  originalBuyerBudgetRange: Maybe<DmBriefMoneyRange>;
  pricingType: BriefPricingType;
  screeningQuestions: Maybe<Array<DmBriefScreeningQuestion>>;
  status: DmBriefStatus;
  subCategoryId: Maybe<Scalars['Int']['output']>;
  tier: DmBriefTier;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Timestamp']['output'];
  updatedBy: User;
};


export type DuplicateBriefDataAttachmentsArgs = {
  previewTransformations?: InputMaybe<Array<AttachmentPreviewTransformation>>;
};

export type Duration = {
  inDays: Scalars['Int']['output'];
  inHours: Scalars['Int']['output'];
  inMinutes: Scalars['Int']['output'];
  inSeconds: Scalars['Int']['output'];
};

export type EoyUser = {
  gaveConsent: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  images: ImagesModel;
  metrics: UserMetrics;
  user: User;
  userType: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type EmbedPlatform = {
  /** List of supported platforms and their eligibility */
  platforms: Array<Platform>;
};

/** Enum of possible supported embed platform names. */
export enum EmbedPlatformName {
  Base44 = 'BASE44',
  Fiverr = 'FIVERR',
  Lovable = 'LOVABLE'
}

export type EmbedSessionMatch = {
  createdAt: Scalars['DateTime']['output'];
  matchId: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  /** @deprecated Not compliant, use 'teamMemberUserId' instead. */
  teamMemberId: Scalars['Float']['output'];
  teamMemberUserId: Scalars['ID']['output'];
};

export enum EmploymentType {
  Freelance = 'FREELANCE',
  FullTime = 'FULL_TIME',
  PartTime = 'PART_TIME',
  SelfEmployed = 'SELF_EMPLOYED',
  Unspecified = 'UNSPECIFIED'
}

export type EngagementBadgeInfo = {
  amountOver: Maybe<Scalars['Int']['output']>;
  creditBonusPercents: Scalars['Int']['output'];
  orderEntitledForCredit: OrderEntitledForCredit;
  tier: LoyaltyProgramTier;
};

export type Enrollment = {
  id: Scalars['ID']['output'];
};

export enum ErrorDetail {
  /**
   * The deadline expired before the operation could complete.
   *
   * For operations that change the state of the system, this error
   * may be returned even if the operation has completed successfully.
   * For example, a successful response from a server could have been
   * delayed long enough for the deadline to expire.
   *
   * HTTP Mapping: 504 Gateway Timeout
   * Error Type: UNAVAILABLE
   */
  DeadlineExceeded = 'DEADLINE_EXCEEDED',
  /**
   * The server detected that the client is exhibiting a behavior that
   * might be generating excessive load.
   *
   * HTTP Mapping: 429 Too Many Requests or 420 Enhance Your Calm
   * Error Type: UNAVAILABLE
   */
  EnhanceYourCalm = 'ENHANCE_YOUR_CALM',
  /**
   * The requested field is not found in the schema.
   *
   * This differs from `NOT_FOUND` in that `NOT_FOUND` should be used when a
   * query is valid, but is unable to return a result (if, for example, a
   * specific video id doesn't exist). `FIELD_NOT_FOUND` is intended to be
   * returned by the server to signify that the requested field is not known to exist.
   * This may be returned in lieu of failing the entire query.
   * See also `PERMISSION_DENIED` for cases where the
   * requested field is invalid only for the given user or class of users.
   *
   * HTTP Mapping: 404 Not Found
   * Error Type: BAD_REQUEST
   */
  FieldNotFound = 'FIELD_NOT_FOUND',
  /**
   * The client specified an invalid argument.
   *
   * Note that this differs from `FAILED_PRECONDITION`.
   * `INVALID_ARGUMENT` indicates arguments that are problematic
   * regardless of the state of the system (e.g., a malformed file name).
   *
   * HTTP Mapping: 400 Bad Request
   * Error Type: BAD_REQUEST
   */
  InvalidArgument = 'INVALID_ARGUMENT',
  /**
   * The provided cursor is not valid.
   *
   * The most common usage for this error is when a client is paginating
   * through a list that uses stateful cursors. In that case, the provided
   * cursor may be expired.
   *
   * HTTP Mapping: 404 Not Found
   * Error Type: NOT_FOUND
   */
  InvalidCursor = 'INVALID_CURSOR',
  /**
   * Unable to perform operation because a required resource is missing.
   *
   * Example: Client is attempting to refresh a list, but the specified
   * list is expired. This requires an action by the client to get a new list.
   *
   * If the user is simply trying GET a resource that is not found,
   * use the NOT_FOUND error type. FAILED_PRECONDITION.MISSING_RESOURCE
   * is to be used particularly when the user is performing an operation
   * that requires a particular resource to exist.
   *
   * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
   * Error Type: FAILED_PRECONDITION
   */
  MissingResource = 'MISSING_RESOURCE',
  /**
   * Service Error.
   *
   * There is a problem with an upstream service.
   *
   * This may be returned if a gateway receives an unknown error from a service
   * or if a service is unreachable.
   * If a request times out which waiting on a response from a service,
   * `DEADLINE_EXCEEDED` may be returned instead.
   * If a service returns a more specific error Type, the specific error Type may
   * be returned instead.
   *
   * HTTP Mapping: 502 Bad Gateway
   * Error Type: UNAVAILABLE
   */
  ServiceError = 'SERVICE_ERROR',
  /**
   * Request failed due to network errors.
   *
   * HTTP Mapping: 503 Unavailable
   * Error Type: UNAVAILABLE
   */
  TcpFailure = 'TCP_FAILURE',
  /**
   * Request throttled based on server concurrency limits.
   *
   * HTTP Mapping: 503 Unavailable
   * Error Type: UNAVAILABLE
   */
  ThrottledConcurrency = 'THROTTLED_CONCURRENCY',
  /**
   * Request throttled based on server CPU limits
   *
   * HTTP Mapping: 503 Unavailable.
   * Error Type: UNAVAILABLE
   */
  ThrottledCpu = 'THROTTLED_CPU',
  /**
   * The server detected that the client is exhibiting a behavior that
   * might be generating excessive load.
   *
   * HTTP Mapping: 429 Too Many Requests
   * Error Type: UNAVAILABLE
   */
  TooManyRequests = 'TOO_MANY_REQUESTS',
  /**
   * The operation is not implemented or is not currently supported/enabled.
   *
   * HTTP Mapping: 501 Not Implemented
   * Error Type: BAD_REQUEST
   */
  Unimplemented = 'UNIMPLEMENTED',
  /**
   * Unknown error.
   *
   * This error should only be returned when no other error detail applies.
   * If a client sees an unknown errorDetail, it will be interpreted as UNKNOWN.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  Unknown = 'UNKNOWN'
}

export enum ErrorType {
  /**
   * Bad Request.
   *
   * There is a problem with the request.
   * Retrying the same request is not likely to succeed.
   * An example would be a query or argument that cannot be deserialized.
   *
   * HTTP Mapping: 400 Bad Request
   */
  BadRequest = 'BAD_REQUEST',
  /**
   * The operation was rejected because the system is not in a state
   * required for the operation's execution.  For example, the directory
   * to be deleted is non-empty, an rmdir operation is applied to
   * a non-directory, etc.
   *
   * Service implementers can use the following guidelines to decide
   * between `FAILED_PRECONDITION` and `UNAVAILABLE`:
   *
   * - Use `UNAVAILABLE` if the client can retry just the failing call.
   * - Use `FAILED_PRECONDITION` if the client should not retry until
   * the system state has been explicitly fixed.  E.g., if an "rmdir"
   *      fails because the directory is non-empty, `FAILED_PRECONDITION`
   * should be returned since the client should not retry unless
   * the files are deleted from the directory.
   *
   * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
   */
  FailedPrecondition = 'FAILED_PRECONDITION',
  /**
   * Internal error.
   *
   * An unexpected internal error was encountered. This means that some
   * invariants expected by the underlying system have been broken.
   * This error code is reserved for serious errors.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  Internal = 'INTERNAL',
  /**
   * The requested entity was not found.
   *
   * This could apply to a resource that has never existed (e.g. bad resource id),
   * or a resource that no longer exists (e.g. cache expired.)
   *
   * Note to server developers: if a request is denied for an entire class
   * of users, such as gradual feature rollout or undocumented allowlist,
   * `NOT_FOUND` may be used. If a request is denied for some users within
   * a class of users, such as user-based access control, `PERMISSION_DENIED`
   * must be used.
   *
   * HTTP Mapping: 404 Not Found
   */
  NotFound = 'NOT_FOUND',
  /**
   * The caller does not have permission to execute the specified
   * operation.
   *
   * `PERMISSION_DENIED` must not be used for rejections
   * caused by exhausting some resource or quota.
   * `PERMISSION_DENIED` must not be used if the caller
   * cannot be identified (use `UNAUTHENTICATED`
   * instead for those errors).
   *
   * This error Type does not imply the
   * request is valid or the requested entity exists or satisfies
   * other pre-conditions.
   *
   * HTTP Mapping: 403 Forbidden
   */
  PermissionDenied = 'PERMISSION_DENIED',
  /**
   * The request does not have valid authentication credentials.
   *
   * This is intended to be returned only for routes that require
   * authentication.
   *
   * HTTP Mapping: 401 Unauthorized
   */
  Unauthenticated = 'UNAUTHENTICATED',
  /**
   * Currently Unavailable.
   *
   * The service is currently unavailable.  This is most likely a
   * transient condition, which can be corrected by retrying with
   * a backoff.
   *
   * HTTP Mapping: 503 Unavailable
   */
  Unavailable = 'UNAVAILABLE',
  /**
   * Unknown error.
   *
   * For example, this error may be returned when
   * an error code received from another address space belongs to
   * an error space that is not known in this address space.  Also
   * errors raised by APIs that do not return enough error information
   * may be converted to this error.
   *
   * If a client sees an unknown errorType, it will be interpreted as UNKNOWN.
   * Unknown errors MUST NOT trigger any special behavior. These MAY be treated
   * by an implementation as being equivalent to INTERNAL.
   *
   * When possible, a more specific error should be provided.
   *
   * HTTP Mapping: 520 Unknown Error
   */
  Unknown = 'UNKNOWN'
}

/** metrics and quality metadata used in order to calculate seller level */
export type EvaluationMetricsMetadata = {
  /** freeze mode details, null means the seller is not in a freeze mode */
  freezeMode: Maybe<FreezeMode>;
  /** grace period details, null means no active grace period */
  gracePeriod: Maybe<GracePeriod>;
  /**
   * indicating when the grace period ends, null means the seller is not currently in a grace period.
   * @deprecated use gracePeriod
   */
  gracePeriodEndsAt: Maybe<Scalars['Timestamp']['output']>;
  /** metrics list used to calculate seller level */
  metrics: Metrics;
};

export enum ExpertSourcingCancellationReason {
  Buyer = 'BUYER',
  PaymentFailed = 'PAYMENT_FAILED',
  System = 'SYSTEM'
}

export enum ExpertSourcingContextType {
  Organization = 'ORGANIZATION'
}

export enum ExpertSourcingDomain {
  DevelopmentAndProgramming = 'DEVELOPMENT_AND_PROGRAMMING',
  MarketingSolutions = 'MARKETING_SOLUTIONS',
  Unspecified = 'UNSPECIFIED'
}

export type ExpertSourcingExpertDetails = {
  displayName: Scalars['String']['output'];
  mail: Scalars['String']['output'];
};

export type ExpertSourcingMeetingData = {
  date: Maybe<Scalars['Timestamp']['output']>;
  id: Maybe<Scalars['String']['output']>;
  requestId: Scalars['String']['output'];
};

export type ExpertSourcingPaymentData = {
  refundedAt: Maybe<Scalars['Timestamp']['output']>;
  sessionId: Scalars['String']['output'];
  tokenId: Scalars['String']['output'];
};

export enum ExpertSourcingPricingType {
  Fixed = 'FIXED',
  Hourly = 'HOURLY'
}

export type ExpertSourcingReport = {
  buyer: Buyer;
  contextId: Scalars['String']['output'];
  contextType: ExpertSourcingContextType;
  createdAt: Scalars['Timestamp']['output'];
  domainExpert: ExpertSourcingExpertDetails;
  id: Scalars['ID']['output'];
  jobDescription: Maybe<JobDescription>;
  recommendations: Array<ExpertSourcingReportRecommendation>;
  request: ExpertSourcingRequest;
  serviceName: Scalars['String']['output'];
  shortDescription: Scalars['String']['output'];
  updatedAt: Scalars['Timestamp']['output'];
};

export type ExpertSourcingReportConnection = {
  edges: Array<ExpertSourcingReportEdge>;
  nodes: Maybe<Array<ExpertSourcingReport>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExpertSourcingReportData = {
  createdAt: Scalars['Timestamp']['output'];
  jobDescription: Maybe<JobDescription>;
  recommendations: Array<ExpertSourcingReportRecommendation>;
  sourcingRequestId: Scalars['String']['output'];
  updatedAt: Scalars['Timestamp']['output'];
};

export type ExpertSourcingReportEdge = {
  cursor: Scalars['String']['output'];
  node: ExpertSourcingReport;
};

export type ExpertSourcingReportRecommendation = {
  availability: Scalars['String']['output'];
  buyerSentMessage: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  gig: Maybe<Gig>;
  maxPriceInCents: Maybe<Scalars['Int']['output']>;
  minPriceInCents: Maybe<Scalars['Int']['output']>;
  priceInCents: Maybe<Scalars['Int']['output']>;
  pricingType: ExpertSourcingPricingType;
  seller: Seller;
};

export type ExpertSourcingRequest = {
  buyer: Buyer;
  cancellationReason: Maybe<ExpertSourcingCancellationReason>;
  contextId: Scalars['String']['output'];
  contextType: ExpertSourcingContextType;
  createdAt: Scalars['Timestamp']['output'];
  description: Maybe<Scalars['String']['output']>;
  domain: ExpertSourcingDomain;
  id: Scalars['ID']['output'];
  meetingData: ExpertSourcingMeetingData;
  paymentData: ExpertSourcingPaymentData;
  status: ExpertSourcingRequestStatus;
  updatedAt: Scalars['Timestamp']['output'];
};

export type ExpertSourcingRequestConnection = {
  edges: Array<ExpertSourcingRequestEdge>;
  nodes: Maybe<Array<ExpertSourcingRequest>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExpertSourcingRequestEdge = {
  cursor: Scalars['String']['output'];
  node: ExpertSourcingRequest;
};

export enum ExpertSourcingRequestStatus {
  Cancelled = 'CANCELLED',
  MeetingBooked = 'MEETING_BOOKED',
  OrderPlaced = 'ORDER_PLACED',
  Paid = 'PAID',
  ReportSent = 'REPORT_SENT'
}

export type ExtendedBackgroundCheck = {
  _id: Scalars['String']['output'];
  backgroundCheckResult: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  externalVendorAccountType: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  requestPaymentData: Maybe<RequestPaymentData>;
  requestStatus: Scalars['String']['output'];
  requesteeId: Scalars['Int']['output'];
  requesterId: Scalars['Int']['output'];
  statusHistory: Array<StatusHistory>;
};

export type ExtendedMoney = {
  moneyInCurrency: Money;
  moneyInUsd: Money;
};

export type ExtendedTaxMoney = {
  percentage: Maybe<Scalars['Float']['output']>;
  tax: ExtendedMoney;
  type: Maybe<Tax>;
};

export type ExtendedWorkforceClassification = {
  _id: Scalars['String']['output'];
  createdAt: Scalars['Timestamp']['output'];
  organizationId: Scalars['String']['output'];
  requestPaymentData: Maybe<ClassificationRequestPaymentData>;
  requestResults: Maybe<Scalars['String']['output']>;
  requestStatus: Scalars['String']['output'];
  requesteeId: Scalars['Int']['output'];
  requesterId: Scalars['Int']['output'];
  updatedAt: Maybe<Scalars['Timestamp']['output']>;
};

export enum ExtraWaveStatus {
  Active = 'ACTIVE',
  Cooldown = 'COOLDOWN',
  MaxLimitReached = 'MAX_LIMIT_REACHED'
}

export type ExtraWaveStatusInfo = {
  status: ExtraWaveStatus;
  /** Timestamp (epoch seconds) when the next wave request becomes eligible. Only set when status is COOLDOWN. */
  timeForNextWaveRequestEligibility: Maybe<Scalars['Timestamp']['output']>;
};

export type ExtrasCalculator = {
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  includedQuantity: Scalars['Int']['output'];
  priceStep: Scalars['Float']['output'];
  quantityStep: Scalars['Int']['output'];
  /** Translated title of the calculator */
  title: Scalars['String']['output'];
};

export type ExtrasOrderItem = {
  buyableType: Scalars['String']['output'];
  duration: Scalars['Int']['output'];
  extraDataValue: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Int']['output']>;
  price: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
  /** Translated title of the extra */
  title: Maybe<Scalars['String']['output']>;
};

export type FinancialActivity = {
  sessionId: Maybe<Scalars['String']['output']>;
};

/** The required locale for translations */
export enum FiverrLocale {
  DeDe = 'DE_DE',
  EnUs = 'EN_US',
  Es = 'ES',
  FrFr = 'FR_FR',
  ItIt = 'IT_IT',
  NlNl = 'NL_NL',
  PtBr = 'PT_BR'
}

export type FloatRange = {
  max: Maybe<Scalars['Float']['output']>;
  min: Maybe<Scalars['Float']['output']>;
};

export type FollowUp = {
  lastCampaign: Maybe<LastCampaign>;
  unsubscribed: Maybe<Scalars['Boolean']['output']>;
};

export type FollowUpCampaign = {
  completedOrdersAmount: Scalars['Int']['output'];
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  recipientsAmount: Scalars['Int']['output'];
  sentGigs: Array<Gig>;
  type: FollowUpCampaignType;
};

export type FollowUpCampaignConnection = {
  edges: Maybe<Array<FollowUpCampaignEdge>>;
  nodes: Maybe<Array<FollowUpCampaign>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FollowUpCampaignEdge = {
  cursor: Scalars['String']['output'];
  node: FollowUpCampaign;
};

export type FollowUpCampaignInput = {
  message: Scalars['String']['input'];
  selectedBuyerIds: Array<Scalars['String']['input']>;
  selectedGigIds: Array<Scalars['String']['input']>;
  type: FollowUpCampaignType;
};

export type FollowUpCampaignInvalidInput = {
  type: FollowUpCampaignInvalidInputType;
};

export enum FollowUpCampaignInvalidInputType {
  LongMessage = 'LONG_MESSAGE',
  NotAllowedBuyerSelected = 'NOT_ALLOWED_BUYER_SELECTED',
  NoBuyerSelected = 'NO_BUYER_SELECTED',
  NoGigSelected = 'NO_GIG_SELECTED',
  SellerIsNotEnrolledForFollowUp = 'SELLER_IS_NOT_ENROLLED_FOR_FOLLOW_UP',
  ShortMessage = 'SHORT_MESSAGE',
  UnknownGigSelected = 'UNKNOWN_GIG_SELECTED',
  UnknownTypeSelected = 'UNKNOWN_TYPE_SELECTED'
}

export enum FollowUpCampaignType {
  OfferGigs = 'OFFER_GIGS',
  Reorder = 'REORDER'
}

export type FollowUpCampaignsSort = {
  by: InputMaybe<FollowUpCampaignsSortBy>;
  order: InputMaybe<SortOrder>;
};

export enum FollowUpCampaignsSortBy {
  CreatedAt = 'CREATED_AT',
  Type = 'TYPE'
}

export type FollowUpMessagesQuota = {
  allowedBuyersAmount: Scalars['Int']['output'];
  availableGigsAmount: Scalars['Int']['output'];
  hasAllowedBuyers: Scalars['Boolean']['output'];
  /**
   * Number of the allowed buyers capped by the quota limit for performance optimization.
   * Returns the smaller value of actual allowed buyers count and the quota limit.
   */
  quotaBasedAllowedBuyersAmount: Scalars['Int']['output'];
  remaining: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  used: Scalars['Int']['output'];
};

export type FollowUpMessagesQuotaReached = {
  maxFollowUpMessages: Maybe<Scalars['Int']['output']>;
};

/** Holds the data related to seller's freeze on level promotion. */
export type FreezeMode = {
  /** The scheduled end date of the freeze period. */
  endsAt: Scalars['Timestamp']['output'];
  /** The starting date of the current freeze period. */
  startedAt: Scalars['Timestamp']['output'];
};

export type GeneratedOrderData = {
  generatedId: Scalars['String']['output'];
  previewAttachmentIds: Array<Scalars['ID']['output']>;
  sellerRevisionOptions: Scalars['String']['output'];
};

export type Gig = Node & {
  attachments: Array<Maybe<GigAttachment>>;
  /** @deprecated Added for DQA purposes */
  attachmentsDqa: Array<Maybe<GigGalleryAttachment>>;
  /** Returns available Promotion to buyer (from Contexto). Seller Plus feature. */
  availablePromotion: Maybe<Promotion>;
  /** @deprecated Do not use this field! Only exposed for backwards compatibility. */
  buyingReviews: Maybe<GigBuyingReviews>;
  catalogCategory: CatalogCategory;
  catalogNestedSubCategory: Maybe<CatalogNestedSubCategory>;
  catalogSubCategory: CatalogSubCategory;
  category: GigCategory;
  /** @deprecated Added for DQA purposes */
  categoryDqa: GigCategory;
  /** @deprecated Use category.categoryId. */
  categoryId: Maybe<Scalars['Int']['output']>;
  /**
   * The category used for tax and invoice purposes.
   * When null, the categoryId should be used.
   */
  categoryReportId: Maybe<Scalars['Int']['output']>;
  createdAt: Maybe<Scalars['Timestamp']['output']>;
  customExtras: Array<Maybe<GigCustomExtra>>;
  /** @deprecated Added for DQA purposes */
  customExtrasDqa: Array<Maybe<GigCustomExtra>>;
  description: Maybe<LocalizedText>;
  /** @deprecated Added for DQA purposes */
  descriptionDqa: LocalizedText;
  /** Frequently asked questions about the gig with answers the seller provides. */
  faqs: Array<GigFaq>;
  gallery: Array<Maybe<GigGalleryAttachment>>;
  hasRequirements: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** An indication if the Gig is an entry point to at least one AI Model. */
  isAI: Maybe<Scalars['Boolean']['output']>;
  /** A flag indicating whether the gig has more orders in the queue then the seller accepts. */
  isOverbooked: Scalars['Boolean']['output'];
  isPro: Scalars['Boolean']['output'];
  /** @deprecated Added for DQA purposes */
  isProDqa: Scalars['Boolean']['output'];
  isRisingTalent: Scalars['Boolean']['output'];
  localizedFAQ: Array<GigFaq>;
  localizedTitle: Maybe<LocalizedText>;
  /** @deprecated Added for DQA purposes */
  localizedTitleDqa: LocalizedText;
  /** The seller-chosen metadata for the gig. It might cover only a subset of the catalog leaf-category's metadata. */
  metadata: Array<GigMetadata>;
  /**
   * Min price of gigs packages
   * @deprecated Use startingPackagePrice
   */
  minPackagePrice: Maybe<Scalars['Int']['output']>;
  packages: Array<Maybe<GigPackage>>;
  /** @deprecated WIP field - use packages instead */
  packagesDqa: Array<Maybe<GigPackage>>;
  /** Performance clusters are metrics that are used to determine the quality of a gig. */
  performanceClusters: Array<GigPerformanceCluster>;
  previewUrl: Maybe<Scalars['URI']['output']>;
  rating: Maybe<GigRating>;
  seller: Seller;
  /** List of AI Models that the Gig is an entry point of. */
  sellerAIModels: Maybe<Array<SellerAiModel>>;
  slug: Scalars['String']['output'];
  /** @deprecated Added for DQA purposes */
  slugDqa: Scalars['String']['output'];
  startingPackagePrice: Maybe<Money>;
  /** @deprecated Added for DQA purposes */
  startingPackagePriceDqa: Money;
  status: Maybe<GigStatus>;
  /** @deprecated Added for DQA purposes */
  statusDqa: GigStatus;
  /** @deprecated Do not use this field! Only exposed for backwards compatibility. */
  studio: Maybe<Studio>;
  /** @deprecated Use category.subCategoryId. */
  subCategoryId: Maybe<Scalars['Int']['output']>;
  /**
   * The subcategory used for tax and invoice purposes.
   * When null, the subCategoryId should be used.
   */
  subCategoryReportId: Maybe<Scalars['Int']['output']>;
  /** The gig's subscription plans. */
  subscriptions: Array<GigSubscription>;
  /** The success score of the Gig */
  successScore: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use localizedTitle.original */
  title: Maybe<Scalars['String']['output']>;
  /**
   * The gig's work process. Sellers can add work process to better describe their Gig's delivery process by
   * splitting the work into milestones and each milestone into steps.
   */
  workProcess: Maybe<GigWorkProcess>;
};


export type GigPackagesArgs = {
  packageIds: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type GigPackagesDqaArgs = {
  packageIds: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type GigRatingArgs = {
  boostingType?: InputMaybe<GigRatingBoostingType>;
};

export type GigAttachment = {
  createdAt: Maybe<Scalars['Timestamp']['output']>;
  downloadUrl: Maybe<Scalars['URI']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Provides url for downloading/playing media content.
   * It's mapped from videoUrls["media_url"] in Filerr's AttachmentDto
   */
  mediaUrl: Maybe<Scalars['URI']['output']>;
  /** @deprecated Use previewUrls */
  previewUrl: Maybe<AttachmentUrl>;
  previewUrls: Array<GigAttachmentUrl>;
  type: AttachmentType;
};


export type GigAttachmentPreviewUrlArgs = {
  transformation: AttachmentTransformation;
};


export type GigAttachmentPreviewUrlsArgs = {
  transformations: Array<GigAttachmentTransformation>;
};

export enum GigAttachmentTransformation {
  GigAttachmentMediumPreview = 'GIG_ATTACHMENT_MEDIUM_PREVIEW',
  GigAttachmentOriginalPreview = 'GIG_ATTACHMENT_ORIGINAL_PREVIEW',
  GigAttachmentSmallPreview = 'GIG_ATTACHMENT_SMALL_PREVIEW'
}

export type GigAttachmentUrl = {
  transformation: Maybe<GigAttachmentTransformation>;
  url: Maybe<Scalars['URI']['output']>;
};

export type GigBuyingReviews = {
  averageValuation: Maybe<Scalars['Float']['output']>;
  communicationValuationAverage: Maybe<Scalars['Float']['output']>;
  recommendValuationAverage: Maybe<Scalars['Float']['output']>;
  serviceValuationAverage: Maybe<Scalars['Float']['output']>;
  totalReviewsCount: Maybe<Scalars['Int']['output']>;
};

export type GigCategory = {
  categoryId: Scalars['Int']['output'];
  nestedCategoryId: Maybe<Scalars['Int']['output']>;
  subCategoryId: Scalars['Int']['output'];
};

export type GigCategoryInput = {
  category: InputMaybe<Scalars['Int']['input']>;
  nestedSubcategory: InputMaybe<Scalars['Int']['input']>;
  subCategory: Scalars['Int']['input'];
};

export type GigCategoryMetadata = {
  id: Scalars['ID']['output'];
  subCategories: Maybe<Array<GigSubCategoryMetadata>>;
};

/** The connection type for GigConnection */
export type GigConnection = {
  /** A list of edges */
  edges: Maybe<Array<GigEdge>>;
  /** A list of nodes */
  nodes: Maybe<Array<Gig>>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection */
  totalCount: Scalars['Int']['output'];
};

export type GigCustomExtra = {
  description: LocalizedText;
  duration: Duration;
  id: Scalars['ID']['output'];
  isFastDelivery: Scalars['Boolean']['output'];
  localizedTitle: LocalizedText;
  price: Money;
  /** @deprecated Use localizedTitle.original */
  shortTitle: Maybe<Scalars['String']['output']>;
  /** @deprecated Use description.original */
  title: Maybe<Scalars['String']['output']>;
};

export type GigEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Gig>;
};

export type GigFaq = {
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type GigGalleryAttachment = GigAttachment & {
  createdAt: Maybe<Scalars['Timestamp']['output']>;
  downloadUrl: Maybe<Scalars['URI']['output']>;
  id: Scalars['ID']['output'];
  isWorkSample: Scalars['Boolean']['output'];
  /**
   * Provides url for downloading/playing media content.
   * It's mapped from videoUrls["media_url"] in Filerr's AttachmentDto
   */
  mediaUrl: Maybe<Scalars['URI']['output']>;
  previewUrl: Maybe<AttachmentUrl>;
  previewUrls: Array<GigAttachmentUrl>;
  type: AttachmentType;
};


export type GigGalleryAttachmentPreviewUrlArgs = {
  transformation: AttachmentTransformation;
};


export type GigGalleryAttachmentPreviewUrlsArgs = {
  transformations: Array<GigAttachmentTransformation>;
};

export type GigImage = GigAttachment & {
  createdAt: Maybe<Scalars['Timestamp']['output']>;
  downloadUrl: Maybe<Scalars['URI']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Provides url for downloading/playing media content.
   * It's mapped from videoUrls["media_url"] in Filerr's AttachmentDto
   */
  mediaUrl: Maybe<Scalars['URI']['output']>;
  /** @deprecated Use previewUrls */
  previewUrl: Maybe<AttachmentUrl>;
  previewUrls: Array<GigAttachmentUrl>;
  type: AttachmentType;
};


export type GigImagePreviewUrlArgs = {
  transformation: AttachmentTransformation;
};


export type GigImagePreviewUrlsArgs = {
  transformations: Array<GigAttachmentTransformation>;
};

export type GigMetadata = {
  /** The catalog metadata. */
  catalogMetadata: CatalogMetadata;
  /** The seller-chosen options for the gig metadata. */
  options: Array<GigMetadataOption>;
};

export type GigMetadataOption = {
  /** The catalog metadata option slug (e.g. "ios"). */
  slug: Scalars['String']['output'];
};

export type GigNestedSubCategoryMetadata = {
  id: Scalars['ID']['output'];
};

export type GigOrderUnit = GigOrderUnitInterface & OrderUnitInterface & {
  billing: Maybe<Billing>;
  description: Maybe<Scalars['String']['output']>;
  /** Unit package duration */
  duration: Duration;
  financialActivity: Maybe<FinancialActivity>;
  /** unit package amount. in milestones, each unit price will be the agreed milestone price */
  price: ExtendedMoney;
  revisions: Maybe<Scalars['Int']['output']>;
  serial: Scalars['Int']['output'];
  /**  DO NOT USE - The only client that should use the url is gig-payment-kimera! */
  startUnitCallbackUrl: Maybe<Scalars['String']['output']>;
  startedAt: Maybe<Scalars['Timestamp']['output']>;
  status: UnitStatus;
  title: Scalars['String']['output'];
  /** Aggregation of package duration + extra items durations + upsells durations */
  totalDuration: Duration;
  /** actual paid amounts: unit package amount +  additional upsell purchases (include fees, tax etc.. ).in milestones, un-started milestone value will be null */
  totalPaidAmount: Maybe<ExtendedMoney>;
  /** Aggregation of unit package price + extra items prices + upsells prices (excluding service fees, tax etc.. ) */
  totalPrice: ExtendedMoney;
  totalReceivedAmount: Maybe<ExtendedMoney>;
  unitId: Maybe<Scalars['String']['output']>;
};

export type GigOrderUnitInterface = {
  billing: Maybe<Billing>;
  financialActivity: Maybe<FinancialActivity>;
  serial: Scalars['Int']['output'];
  startedAt: Maybe<Scalars['Timestamp']['output']>;
  status: UnitStatus;
  totalPaidAmount: Maybe<ExtendedMoney>;
  totalReceivedAmount: Maybe<ExtendedMoney>;
  unitId: Maybe<Scalars['String']['output']>;
};

export type GigPackage = {
  calculators: Maybe<GigPackageCalculators>;
  content: Maybe<Array<Maybe<GigPricingFactor>>>;
  /** @deprecated Use localizedDescription.original */
  description: Maybe<Scalars['String']['output']>;
  duration: Duration;
  id: Scalars['Int']['output'];
  localizedDescription: LocalizedText;
  localizedTitle: LocalizedText;
  price: Money;
  /** @deprecated Use localizedTitle.original */
  title: Scalars['String']['output'];
  type: GigPackageType;
};

export type GigPackageCalculators = {
  price: Maybe<Array<Maybe<PriceCalculator>>>;
  voiceOver: Maybe<VoiceOverCalculator>;
};

export enum GigPackageType {
  Basic = 'BASIC',
  Premium = 'PREMIUM',
  Standard = 'STANDARD'
}

/**
 * Performance clusters are used behind the scenes to calculate the performance of a gig.
 * They contain a name, a type (see GigPerformanceClusterType enum) and a level (currently null), and a rank.
 */
export type GigPerformanceCluster = {
  level: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
  type: GigPerformanceClusterType;
};

/**
 * GigPerformanceClusterType specifies if the cluster had a positive or a negative impact on the gig.
 * UNSPECIFIED is a default value
 */
export enum GigPerformanceClusterType {
  Negative = 'NEGATIVE',
  Positive = 'POSITIVE',
  Unspecified = 'UNSPECIFIED'
}

export type GigPricingFactor = {
  buyerTitle: Maybe<TranslatableContent>;
  /** Pricing factor catalog data - exposed in schema but not implemented at this moment. Meaning if you query for this field you get null */
  catalogData: Maybe<CatalogPricingFactor>;
  duration: Duration;
  id: Scalars['ID']['output'];
  included: Maybe<Scalars['Boolean']['output']>;
  includedModifications: Maybe<Scalars['String']['output']>;
  price: Maybe<Money>;
  /** @deprecated Use buyerTitle to get the translation key */
  title: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  value: Maybe<Scalars['Float']['output']>;
};

export type GigRating = Rating & {
  /** Represents the count of ratings for a gig. */
  count: Scalars['Int']['output'];
  /** Represents the final rating score of a gig, based on all relevant metrics. */
  score: Scalars['Float']['output'];
};

export enum GigRatingBoostingType {
  /** Rating boosting is disabled */
  None = 'NONE',
  /** Use seller role score to boost new gigs */
  SellerRole = 'SELLER_ROLE'
}

/** Fiverr::Gig::Status enum - https://github.com/fiverr/fiverrapis/blob/master/fiverr/gig/status.proto */
export enum GigStatus {
  Approved = 'APPROVED',
  Attention = 'ATTENTION',
  Blocked = 'BLOCKED',
  Deleted = 'DELETED',
  Denied = 'DENIED',
  Draft = 'DRAFT',
  Onhold = 'ONHOLD',
  Overbooked = 'OVERBOOKED',
  Pending = 'PENDING',
  Suspended = 'SUSPENDED',
  Suspic = 'SUSPIC'
}

export type GigSubCategory = {
  id: Scalars['Int']['output'];
  imageUrl: Maybe<Scalars['URI']['output']>;
  subscribed: Scalars['Boolean']['output'];
  subscribedAt: Maybe<Scalars['Timestamp']['output']>;
};

export type GigSubCategoryMetadata = {
  id: Scalars['ID']['output'];
  nestedSubCategories: Maybe<Array<GigNestedSubCategoryMetadata>>;
};

export type GigSubscription = {
  /** The discount percentage for the subscription plan (e.g. 10 = 10% off). */
  discountPercent: Scalars['Int']['output'];
  /** The duration of the subscription plan in months (e.g. 3 = 3 months). */
  durationInMonths: Scalars['Int']['output'];
  /** MongoDB ObjectID */
  id: Scalars['ID']['output'];
};

export type GigVideo = GigAttachment & {
  createdAt: Maybe<Scalars['Timestamp']['output']>;
  downloadUrl: Maybe<Scalars['URI']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Provides url for downloading/playing media content.
   * It's mapped from videoUrls["media_url"] in Filerr's AttachmentDto
   */
  mediaUrl: Maybe<Scalars['URI']['output']>;
  /** @deprecated Use previewUrls */
  previewUrl: Maybe<AttachmentUrl>;
  previewUrls: Array<GigAttachmentUrl>;
  type: AttachmentType;
};


export type GigVideoPreviewUrlArgs = {
  transformation: AttachmentTransformation;
};


export type GigVideoPreviewUrlsArgs = {
  transformations: Array<GigAttachmentTransformation>;
};

export type GigWorkProcess = {
  /** Indiactes if the work process is for display only or purchasable. */
  activePay: Scalars['Boolean']['output'];
  /** The milestones the gig has been split into. */
  milestones: Array<GigWorkProcessMilestone>;
};

export type GigWorkProcessMilestone = {
  /** Catalog data for the milestone, like the milestone's title, description, etc. */
  catalogWorkProcessMilestone: CatalogWorkProcessMilestone;
  /** Indicates whether the milestone include a live video meeting. */
  liveSession: Scalars['Boolean']['output'];
  /**
   * The milestones different packages. For example a milestone could have 3 packages (like in a Gig), each with different
   * price, duration, and revisions, etc.
   */
  packages: Array<GigWorkProcessMilestonePackage>;
  /** The steps the milestone has been splitted into. */
  steps: Array<GigWorkProcessMilestoneStep>;
};

export type GigWorkProcessMilestonePackage = {
  /** The duration of the package in days. Could be null if the package is not purchasable. */
  duration: Maybe<Scalars['Float']['output']>;
  /** The package's unique identifier, could have a value of 1, 2, or 3. */
  packageId: Scalars['Float']['output'];
  /** The price of the package in USD. Could be null if the package is not purchasable. */
  price: Maybe<Scalars['Float']['output']>;
  /** The number of revisions included in the package. Could be null if the package is not purchasable. */
  revisions: Maybe<Scalars['Float']['output']>;
};

export type GigWorkProcessMilestoneStep = {
  /** Catalog data for the milestone step, like the step's title, description, etc. */
  catalogWorkProcessMilestoneStep: CatalogWorkProcessMilestone;
  /** A list of packages that the step is included under (for example, a step might only be included in the 2nd & 3rd packages) */
  packageIds: Array<Scalars['Float']['output']>;
};

export type Goal = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type GoalRequirement = ProjectGoal | UserGoal;

export enum GoalType {
  Business = 'BUSINESS',
  Personal = 'PERSONAL'
}

export type GoalsFilter = {
  goalType: InputMaybe<Array<GoalType>>;
  relatedCategories: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Holds the data related to seller's level system grace period */
export type GracePeriod = {
  /** Date when the grace period ends. */
  endsAt: Scalars['Timestamp']['output'];
  /** Indicates whether the seller is in active grace period or not. */
  isActive: Scalars['Boolean']['output'];
  /** List of reasons why the seller is in grace period. */
  reasons: Array<Scalars['String']['output']>;
  /** Date when the grace period started. */
  startedAt: Scalars['Timestamp']['output'];
};

export type GrowthTask = {
  badges: Array<GrowthTaskBadge>;
  createdAt: Scalars['Timestamp']['output'];
  cta: Maybe<GrowthTaskCta>;
  /**  Template fields flattened */
  icon: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  source: GrowthTaskSource;
  templateId: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: GrowthTaskType;
  user: User;
};

export enum GrowthTaskBadge {
  Pro = 'PRO',
  SellerPlus = 'SELLER_PLUS',
  SellerPlusLocked = 'SELLER_PLUS_LOCKED'
}

export type GrowthTaskConnection = {
  counters: GrowthTaskCounters;
  edges: Array<GrowthTaskEdge>;
  nodes: Array<GrowthTask>;
  pageInfo: PageInfo;
};

export type GrowthTaskCounters = {
  all: Scalars['Int']['output'];
  csm: Scalars['Int']['output'];
};

export type GrowthTaskCta = {
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type GrowthTaskEdge = {
  cursor: Scalars['String']['output'];
  node: GrowthTask;
};

export type GrowthTaskFilters = {
  source: InputMaybe<GrowthTaskSource>;
};

export enum GrowthTaskSource {
  Csm = 'CSM',
  System = 'SYSTEM'
}

export enum GrowthTaskType {
  Earnings = 'EARNINGS',
  NewClients = 'NEW_CLIENTS',
  NumberOfOrders = 'NUMBER_OF_ORDERS',
  Rating = 'RATING',
  ResponseRate = 'RESPONSE_RATE',
  SuccessScore = 'SUCCESS_SCORE'
}

export type HistoryLogItem = {
  tier: LoyaltyProgramTier;
  updatedDate: Scalars['Timestamp']['output'];
};

export type Hosting = {
  id: Scalars['String']['output'];
  requirementId: Maybe<Scalars['String']['output']>;
};

export type HostingOptionValue = {
  id: Scalars['String']['output'];
};

export type HostingOptions = {
  nestedCategoryId: Maybe<Scalars['Int']['output']>;
  options: Array<HostingOptionValue>;
  planType: Maybe<Scalars['String']['output']>;
  platform: Maybe<Scalars['String']['output']>;
  requirementId: Maybe<Scalars['String']['output']>;
};

export type HourlyAgreementStatus = {
  estimatedCompletionTime: Maybe<Scalars['Timestamp']['output']>;
  status: HourlyOrderAgreementStatus;
  statusDueDate: Maybe<Scalars['Timestamp']['output']>;
};

export type HourlyLimitations = {
  price: MoneyRange;
  totalMinutesEstimation: FloatRange;
  unitMaxMinutesAllowed: FloatRange;
};

export type HourlyNeed = {
  /** The type of entity the buyer needs for hourly work (e.g., "freelancer", "agency", "consultant"). */
  entityType: Maybe<NestedString>;
  /** Boolean indicator capturing whether the buyer has an hourly-based service need. */
  hourlyNeed: Maybe<NestedBoolean>;
};

export type HourlyOption = {
  totalMinutesEstimation: Scalars['Float']['output'];
  unitMaxMinutesAllowed: Maybe<Scalars['Float']['output']>;
};

export enum HourlyOrderAgreementStatus {
  Active = 'ACTIVE',
  Ended = 'ENDED',
  EndedToBe = 'ENDED_TO_BE',
  Paused = 'PAUSED',
  PausedToBe = 'PAUSED_TO_BE'
}

export type HourlyOrderInitialFeeUnit = HourlyOrderUnitInterface & OrderUnitInterface & {
  billing: Maybe<Billing>;
  description: Maybe<Scalars['String']['output']>;
  financialActivity: Maybe<FinancialActivity>;
  price: ExtendedMoney;
  serial: Scalars['Int']['output'];
  startedAt: Maybe<Scalars['Timestamp']['output']>;
  status: HourlyOrderUnitStatus;
  title: Scalars['String']['output'];
  totalPaidAmount: Maybe<ExtendedMoney>;
  totalReceivedAmount: Maybe<ExtendedMoney>;
  unitId: Maybe<Scalars['String']['output']>;
};

export enum HourlyOrderStatus {
  Completed = 'COMPLETED',
  /**  according to subscription status */
  Dispute = 'DISPUTE',
  /**  if hourlyAgreementStatus is paused */
  InProgress = 'IN_PROGRESS',
  /**  if currentUnit has open resolution */
  Paused = 'PAUSED',
  Suspended = 'SUSPENDED'
}

export type HourlyOrderUnitInterface = {
  billing: Maybe<Billing>;
  financialActivity: Maybe<FinancialActivity>;
  serial: Scalars['Int']['output'];
  startedAt: Maybe<Scalars['Timestamp']['output']>;
  status: HourlyOrderUnitStatus;
  totalPaidAmount: Maybe<ExtendedMoney>;
  totalReceivedAmount: Maybe<ExtendedMoney>;
  unitId: Maybe<Scalars['String']['output']>;
};

export enum HourlyOrderUnitStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Dispute = 'DISPUTE',
  InReview = 'IN_REVIEW'
}

export type HourlyOrderWorkUnit = HourlyOrderUnitInterface & OrderUnitInterface & {
  approvalMode: ApprovalMode;
  autoCompletionTime: Maybe<Scalars['Timestamp']['output']>;
  billing: Maybe<Billing>;
  chargedDate: Maybe<Scalars['Timestamp']['output']>;
  financialActivity: Maybe<FinancialActivity>;
  report: Report;
  serial: Scalars['Int']['output'];
  startedAt: Maybe<Scalars['Timestamp']['output']>;
  status: HourlyOrderUnitStatus;
  totalPaidAmount: Maybe<ExtendedMoney>;
  totalReceivedAmount: Maybe<ExtendedMoney>;
  /** Technical id used for BQ reporting */
  unitId: Maybe<Scalars['String']['output']>;
};

export type HourlyRate = {
  id: Scalars['ID']['output'];
  priceInCents: Scalars['Int']['output'];
};

export type HourlySpecificDetails = OrderTypeSpecificDetails & {
  canReportHours: Scalars['Boolean']['output'];
  currentRemainingReportableMinutes: Scalars['Int']['output'];
  hourlyAgreementStatus: HourlyAgreementStatus;
  hourlyOrderStatus: HourlyOrderStatus;
  hourlyRate: ExtendedMoney;
  nextChargeDate: Scalars['Timestamp']['output'];
  orderApprovalMode: ApprovalMode;
  orderType: ProductType;
  subscriptionStatus: Scalars['String']['output'];
  totalOrderPaidMinutes: Scalars['Int']['output'];
  totalOrderReportedMinutes: Scalars['Int']['output'];
  /** @deprecated Use totalOrderPaidMinutes */
  totalPaidMinutes: Scalars['Int']['output'];
  /** @deprecated Use totalOrderReportedMinutes */
  totalReportedMinutes: Scalars['Int']['output'];
  unitMaxMinutesAllowed: Maybe<Scalars['Int']['output']>;
};

export type ImagesModel = {
  variant_1: Scalars['String']['output'];
  variant_2: Scalars['String']['output'];
  variant_3: Scalars['String']['output'];
  variant_4: Maybe<Scalars['String']['output']>;
};

export type Industry = {
  aliases: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  requirementId: Maybe<Scalars['String']['output']>;
  /** The industry slug. e.g, "agricultural_consulting" */
  slug: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type IndustryOptions = {
  orderId: Scalars['ID']['output'];
  values: Array<Industry>;
};

export type IndustryTreeNode = {
  children: Array<Maybe<IndustryTreeNode>>;
  industry: Maybe<Industry>;
  visible: Array<IndustryVisibilityGroup>;
};

export enum IndustryVisibilityGroup {
  Buyers = 'BUYERS',
  Internal = 'INTERNAL',
  Sellers = 'SELLERS'
}

/** raven.user.network_presences.InfluenceType enum - https://github.com/fiverr/fiverrapis/blob/master/raven/user/network_presences/enums.proto */
export enum InfluenceType {
  Appreciations = 'APPRECIATIONS',
  Connections = 'CONNECTIONS',
  Followers = 'FOLLOWERS',
  Likes = 'LIKES',
  Posts = 'POSTS',
  Shots = 'SHOTS',
  /** The UNKNOWN is a valid value showing that user did not specify the type of the influenceCount metric. */
  Unknown = 'UNKNOWN',
  Views = 'VIEWS'
}

export type Insights = {
  audiences: Maybe<Audiences>;
  buyerBusiness: Maybe<BuyerBusiness>;
  buyerOnlinePresence: Maybe<BuyerOnlinePresence>;
  buyerPersonalData: Maybe<BuyerPersonalData>;
  buyerPredictions: Maybe<BuyerPredictions>;
  buyerServices: Maybe<BuyerServices>;
  buyerStatistics: Maybe<BuyerStatistics>;
  hourlyNeed: Maybe<HourlyNeed>;
  nextSteps: Maybe<Array<NextStep>>;
  state: Maybe<BuyerState>;
};

export type InspireDelivery = DeliveryItem & Node & {
  buyer: User;
  category: GigCategory;
  currentUserVoted: Scalars['Boolean']['output'];
  deliveredDate: Scalars['Timestamp']['output'];
  description: Maybe<Scalars['String']['output']>;
  gig: Gig;
  goals: Array<InspireGoal>;
  id: Scalars['ID']['output'];
  industries: Array<Industry>;
  keywords: Array<Maybe<Scalars['String']['output']>>;
  /**  The curation-system determined primary delivery attachment file of image type */
  originalDeliveryAttachment: Attachment;
  qualityLevel: DeliveryQualityLevel;
  seller: Seller;
  shortDescription: Maybe<Scalars['String']['output']>;
  totalVotes: Maybe<Scalars['Int']['output']>;
  valid: Scalars['Boolean']['output'];
  votesDiff: Maybe<VotesDiff>;
};

export type InspireDeliveryAssetsSharing = {
  assets: Array<InspireDeliverySharedAsset>;
  id: Scalars['ID']['output'];
};

/** The connection type for InspireDeliveryConnection */
export type InspireDeliveryConnection = {
  /** A list of edges */
  edges: Maybe<Array<InspireDeliveryEdge>>;
  /** A list of nodes */
  nodes: Maybe<Array<InspireDelivery>>;
  /** Identifier of the results */
  pageCtxId: Maybe<Scalars['String']['output']>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection */
  totalCount: Scalars['Int']['output'];
};

export type InspireDeliveryEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<InspireDelivery>;
};

/**  AND-semantics filter, where array values are with OR semantics */
export type InspireDeliveryFilter = {
  categoryIds: InputMaybe<Array<Scalars['Int']['input']>>;
  deliveredDate: InputMaybe<TimeRange>;
  goals: InputMaybe<Array<Scalars['ID']['input']>>;
  industries: InputMaybe<Array<Scalars['ID']['input']>>;
  mimeTypes: InputMaybe<Array<AttachmentType>>;
  nestedSubCategoryIds: InputMaybe<Array<Scalars['Int']['input']>>;
  /**  filter deliveredDate for being in bounds of time range */
  qualityLevels: InputMaybe<Array<DeliveryQualityLevel>>;
  sellerIds: InputMaybe<Array<Scalars['Int']['input']>>;
  /** @deprecated Filtering by AchievementLevel will be removed */
  sellerLevels: InputMaybe<Array<AchievementLevel>>;
  subCategoryIds: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum InspireDeliveryPurpose {
  Business = 'BUSINESS',
  Personal = 'PERSONAL',
  SideProject = 'SIDE_PROJECT',
  Unknown = 'UNKNOWN'
}

export type InspireDeliveryRefinement = Node & {
  goalUnsure: Maybe<Scalars['Boolean']['output']>;
  goals: Array<InspireGoal>;
  id: Scalars['ID']['output'];
  industries: Array<Industry>;
  industryUnsure: Maybe<Scalars['Boolean']['output']>;
  metadata: Array<MetadataEntry>;
  origin: InspireDeliveryRefinementOrigin;
  otherGoal: Scalars['Boolean']['output'];
  otherGoalValue: Maybe<Scalars['String']['output']>;
  otherIndustry: Scalars['Boolean']['output'];
  otherIndustryValue: Maybe<Scalars['String']['output']>;
  purpose: Maybe<InspireDeliveryPurpose>;
  taggedDate: Scalars['Timestamp']['output'];
};

export type InspireDeliveryRefinementInput = {
  goalUnsure: InputMaybe<Scalars['Boolean']['input']>;
  goals: InputMaybe<Array<Scalars['ID']['input']>>;
  industries: InputMaybe<Array<Scalars['ID']['input']>>;
  industryUnsure: InputMaybe<Scalars['Boolean']['input']>;
  metadata: InputMaybe<Array<MetadataEntryInput>>;
  otherGoal: InputMaybe<Scalars['Boolean']['input']>;
  otherGoalValue: InputMaybe<Scalars['String']['input']>;
  otherIndustry: InputMaybe<Scalars['Boolean']['input']>;
  otherIndustryValue: InputMaybe<Scalars['String']['input']>;
  purpose: InputMaybe<InspireDeliveryPurpose>;
};

export enum InspireDeliveryRefinementOrigin {
  Buyer = 'BUYER',
  Seller = 'SELLER'
}

export type InspireDeliverySharedAsset = {
  inspireDelivery: InspireDelivery;
};

export enum InspireDeliverySortBy {
  CuratedDate = 'CURATED_DATE',
  DeliveredDate = 'DELIVERED_DATE'
}

export enum InspireDeliveryTaggedByRole {
  Buyer = 'BUYER',
  Curator = 'CURATOR',
  Seller = 'SELLER'
}

export type InspireGoal = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** External interest ids selected on project created */
export type Interest = Node & {
  id: Scalars['ID']['output'];
};

export type InternalAttachment = BaseGqlEntity & {
  /** The attachment antivirus scan status */
  antivirusResult: AntivirusResult;
  /** The name of the attachment field / sub flow */
  attachmentName: Scalars['String']['output'];
  /** The attachment bucket name */
  bucketName: Maybe<Scalars['String']['output']>;
  /**
   * The attachment content type
   * e.g. image/jpeg, video/mp4, audio/mp3, etc.
   */
  contentType: Scalars['String']['output'];
  /** The attachment BSON identifier */
  createdAt: Scalars['Float']['output'];
  /** A Fiverr domain attachment download url */
  directDownloadUrl: Scalars['String']['output'];
  /** A Fiverr domain attachment download url */
  downloadUrl: Scalars['String']['output'];
  /** The attachment file name */
  fileName: Scalars['String']['output'];
  /** The attachment file path */
  filePath: Maybe<Scalars['String']['output']>;
  /** The attachment file size */
  fileSize: Scalars['Float']['output'];
  /** The entity identifier */
  id: Scalars['ID']['output'];
  /** URL for playing video / audio attachments */
  mediaUrl: Maybe<Scalars['String']['output']>;
  /** Additional information about the attachment */
  metadata: Maybe<InternalAttachmentMetadata>;
  /** The owner id of the attachment creator */
  ownerId: Maybe<Scalars['String']['output']>;
  /** URL to original PDF file */
  pdfOpenUrl: Maybe<Scalars['String']['output']>;
  /** All preview URLs for the passed transformations */
  previewUrl: Array<PreviewUrl>;
  /** The identifier of the object the attachment relates to */
  relatedObjId: Scalars['String']['output'];
  /** The type of the object the attachment relates to */
  relatedObjType: Scalars['String']['output'];
  /**
   * The attachment status
   * e.g. active, deleted, archived, restore_in_progress
   */
  status: Scalars['String']['output'];
  /** watermarked URL for playing video / audio attachments */
  watermarkedMediaUrl: Maybe<Scalars['String']['output']>;
  /** All preview URLs for the passed transformations with watermark */
  watermarkedPreviewUrl: Array<PreviewUrl>;
};


export type InternalAttachmentDownloadUrlArgs = {
  isSender: InputMaybe<Scalars['Boolean']['input']>;
  orderId: InputMaybe<Scalars['String']['input']>;
  userId: InputMaybe<Scalars['String']['input']>;
};


export type InternalAttachmentPreviewUrlArgs = {
  expiration: InputMaybe<Scalars['Float']['input']>;
  forceSignedUrl: InputMaybe<Scalars['Boolean']['input']>;
  transformations: Array<TransformationParametersInput>;
  urlSuffix: InputMaybe<Scalars['String']['input']>;
};


export type InternalAttachmentWatermarkedMediaUrlArgs = {
  expiration: InputMaybe<Scalars['Float']['input']>;
  forceSignedUrl: InputMaybe<Scalars['Boolean']['input']>;
};


export type InternalAttachmentWatermarkedPreviewUrlArgs = {
  expiration: InputMaybe<Scalars['Float']['input']>;
  forceSignedUrl: InputMaybe<Scalars['Boolean']['input']>;
  transformations: Array<TransformationParametersInput>;
  urlSuffix: InputMaybe<Scalars['String']['input']>;
};

export type InternalAttachmentByIdNotFound = {
  /** The id of the attachment that was used to search for an attachment and was not found */
  id: Scalars['ID']['output'];
  /** Whether or not the attachment was found (always true) */
  notFound: Scalars['Boolean']['output'];
};

export type InternalAttachmentByRelatedObjectNotFound = {
  /** Whether or not the attachment was found (always true) */
  notFound: Scalars['Boolean']['output'];
  /** The RelatedObject, <id, type> pair, that was used to search for attachments and was not found */
  relatedObject: RelatedObject;
};

export type InternalAttachmentMetadata = {
  duration: Maybe<Scalars['Float']['output']>;
  height: Maybe<Scalars['Float']['output']>;
  width: Maybe<Scalars['Float']['output']>;
};

export enum Interval {
  Month = 'MONTH',
  Week = 'WEEK'
}

export type IntervalTrendingEntry = {
  period: TimestampRange;
  subCategories: Array<GigSubCategory>;
};

export type IntroVideo = {
  attachment: Maybe<SellerIntroVideoAttachment>;
  /**
   * Intro video URL
   * @deprecated Use attachment instead
   */
  url: Maybe<Scalars['URI']['output']>;
};

export enum IntroVideoAttachmentTransformation {
  None = 'NONE',
  TCaseStudyCardDark = 'T_CASE_STUDY_CARD_DARK',
  TIntroVideoCard = 'T_INTRO_VIDEO_CARD',
  TPortfolioProjectCard = 'T_PORTFOLIO_PROJECT_CARD'
}

export type IntroVideoPreviewUrl = {
  /** Transformation key for the preview URL */
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type InvalidCertifiedTestimonialField = {
  field: Scalars['String']['output'];
  reason: CertifiedTestimonialFieldValidationReason;
};

/** implementing types are: OrderItem,PackageItem or Tip */
export type Item = {
  id: Maybe<Scalars['Int']['output']>;
  price: Maybe<ExtendedMoney>;
  quantity: Scalars['Int']['output'];
  title: Maybe<Scalars['String']['output']>;
};

export type ItemBuyableData = {
  id: Maybe<Scalars['String']['output']>;
  quantity: Maybe<Scalars['Int']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type JobDescription = {
  aboutProject: Maybe<Scalars['String']['output']>;
  bonusConsiderations: Maybe<Scalars['String']['output']>;
  company: Maybe<Scalars['String']['output']>;
  deliverables: Maybe<Array<Scalars['String']['output']>>;
  engagementModel: Maybe<Scalars['String']['output']>;
  industry: Maybe<Scalars['String']['output']>;
  jobTitle: Maybe<Scalars['String']['output']>;
  jobType: Maybe<Scalars['String']['output']>;
  keyResponsibilities: Maybe<Array<Scalars['String']['output']>>;
  paymentCompensation: Maybe<Scalars['String']['output']>;
  references: Maybe<Array<Scalars['String']['output']>>;
  requirementsQualifications: Maybe<Array<Scalars['String']['output']>>;
  roleOverview: Maybe<Scalars['String']['output']>;
  timeline: Maybe<Scalars['String']['output']>;
  toolsPlatforms: Maybe<Array<Scalars['String']['output']>>;
  workplaceLogistics: Maybe<Scalars['String']['output']>;
};

export type KeyPointsInvalidInput = {
  keyPoints: Maybe<Array<Scalars['String']['output']>>;
};

export type Kickstart = KickstartEligible | KickstartEnrolled;

export type KickstartEligible = {
  tier: KickstartTier;
};

export type KickstartEnrolled = {
  enrollment: Enrollment;
  /** Seller id */
  id: Scalars['ID']['output'];
};

export enum KickstartTier {
  Basic = 'BASIC'
}

/** Source - https://github.com/fiverr/fiverrapis/blob/master/fiverr/language_codes/codes.proto */
export enum LanguageCode {
  Aa = 'AA',
  Ab = 'AB',
  Ae = 'AE',
  Af = 'AF',
  Ak = 'AK',
  Am = 'AM',
  An = 'AN',
  Ar = 'AR',
  As = 'AS',
  Av = 'AV',
  Ay = 'AY',
  Az = 'AZ',
  Ba = 'BA',
  Be = 'BE',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Br = 'BR',
  Bs = 'BS',
  Ca = 'CA',
  Ce = 'CE',
  Ch = 'CH',
  Co = 'CO',
  Cr = 'CR',
  Cs = 'CS',
  Cv = 'CV',
  Cy = 'CY',
  Da = 'DA',
  De = 'DE',
  Ee = 'EE',
  El = 'EL',
  En = 'EN',
  Eo = 'EO',
  Es = 'ES',
  Et = 'ET',
  Eu = 'EU',
  Fa = 'FA',
  Ff = 'FF',
  Fi = 'FI',
  Fj = 'FJ',
  Fo = 'FO',
  Fr = 'FR',
  Fy = 'FY',
  Ga = 'GA',
  Gd = 'GD',
  Gl = 'GL',
  Gn = 'GN',
  Gu = 'GU',
  Gv = 'GV',
  Ha = 'HA',
  He = 'HE',
  Hi = 'HI',
  Ho = 'HO',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Hy = 'HY',
  Hz = 'HZ',
  Ia = 'IA',
  Id = 'ID',
  Ig = 'IG',
  Ii = 'II',
  Ik = 'IK',
  Io = 'IO',
  Is = 'IS',
  It = 'IT',
  Iu = 'IU',
  Ja = 'JA',
  Jp = 'JP',
  Jv = 'JV',
  Jw = 'JW',
  Ka = 'KA',
  Kg = 'KG',
  Ki = 'KI',
  Kj = 'KJ',
  Kk = 'KK',
  Kl = 'KL',
  Km = 'KM',
  Kn = 'KN',
  Ko = 'KO',
  Kr = 'KR',
  Ks = 'KS',
  Ku = 'KU',
  Kv = 'KV',
  Kw = 'KW',
  Ky = 'KY',
  La = 'LA',
  Lb = 'LB',
  Lg = 'LG',
  Li = 'LI',
  Ln = 'LN',
  Lo = 'LO',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Mg = 'MG',
  Mh = 'MH',
  Mi = 'MI',
  Mk = 'MK',
  Ml = 'ML',
  Mn = 'MN',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  My = 'MY',
  Na = 'NA',
  Nb = 'NB',
  Nd = 'ND',
  Ne = 'NE',
  Ng = 'NG',
  Nl = 'NL',
  Nn = 'NN',
  No = 'NO',
  Nr = 'NR',
  Nv = 'NV',
  Ny = 'NY',
  Oc = 'OC',
  Oj = 'OJ',
  Om = 'OM',
  Or = 'OR',
  Os = 'OS',
  Pa = 'PA',
  Pi = 'PI',
  Pl = 'PL',
  Ps = 'PS',
  Pt = 'PT',
  Qu = 'QU',
  Rm = 'RM',
  Rn = 'RN',
  Ro = 'RO',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Si = 'SI',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sq = 'SQ',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Su = 'SU',
  Sv = 'SV',
  Sw = 'SW',
  Ta = 'TA',
  Te = 'TE',
  Tg = 'TG',
  Th = 'TH',
  Ti = 'TI',
  Tk = 'TK',
  Tl = 'TL',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Ts = 'TS',
  Tt = 'TT',
  Tw = 'TW',
  Ty = 'TY',
  Ug = 'UG',
  Uk = 'UK',
  Ur = 'UR',
  Uz = 'UZ',
  Ve = 'VE',
  Vi = 'VI',
  Vo = 'VO',
  Wa = 'WA',
  Wo = 'WO',
  Xh = 'XH',
  Yi = 'YI',
  Yo = 'YO',
  Za = 'ZA',
  Zh = 'ZH',
  Zu = 'ZU'
}

export type LanguagePreference = {
  code: LanguageCode;
  communicationPreferences: Array<CommunicationPreference>;
};

/** Source - https://github.com/fiverr/fiverrapis/blob/master/fiverr/user/language_proficiency_level.proto */
export enum LanguageProficiencyLevel {
  Basic = 'BASIC',
  Conversational = 'CONVERSATIONAL',
  Fluent = 'FLUENT',
  NativeOrBilingual = 'NATIVE_OR_BILINGUAL'
}

export type LastCampaign = {
  id: Maybe<Scalars['String']['output']>;
  sentAt: Maybe<Scalars['Timestamp']['output']>;
  type: Maybe<FollowUpCampaignType>;
};

export type LastOrder = {
  amount: Maybe<Scalars['Int']['output']>;
  createdAt: Maybe<Scalars['Timestamp']['output']>;
  id: Scalars['ID']['output'];
  title: Maybe<Scalars['String']['output']>;
};

export enum LastOrderCreatedFromOptions {
  Days_30 = 'DAYS_30',
  Days_60 = 'DAYS_60',
  Days_90 = 'DAYS_90',
  Days_180 = 'DAYS_180',
  Months_12 = 'MONTHS_12'
}

export type LeafGoal = Goal & {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  relatedCategories: Array<GigCategory>;
  tags: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LifeEvent = {
  /** The date when the life event occurred. */
  eventDate: Maybe<Scalars['String']['output']>;
  /** The name or description of the life event (e.g., "wedding", "graduation", "new job"). */
  eventName: Scalars['String']['output'];
};

/**  Resembles fiverr.locale.ComputedLocale.proto values */
export enum Locale {
  DeAt = 'DE_AT',
  DeDe = 'DE_DE',
  EnAu = 'EN_AU',
  EnCa = 'EN_CA',
  EnGb = 'EN_GB',
  EnUs = 'EN_US',
  EsEs = 'ES_ES',
  EsMx = 'ES_MX',
  FrCa = 'FR_CA',
  FrFr = 'FR_FR',
  ItIt = 'IT_IT',
  NlNl = 'NL_NL',
  PtBr = 'PT_BR',
  PtPt = 'PT_PT',
  Unspecified = 'UNSPECIFIED'
}

export type Localization = {
  currency: Currency;
  locale: FiverrLocale;
  timezone: Maybe<Scalars['String']['output']>;
  utcOffsetInMinutes: Scalars['Int']['output'];
};

export type LocalizedGigAttachment = GigAttachment & {
  createdAt: Maybe<Scalars['Timestamp']['output']>;
  downloadUrl: Maybe<Scalars['URI']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Provides url for downloading/playing media content.
   * It's mapped from videoUrls["media_url"] in Filerr's AttachmentDto
   */
  mediaUrl: Maybe<Scalars['URI']['output']>;
  /** @deprecated Use previewUrls */
  previewUrl: Maybe<AttachmentUrl>;
  previewUrls: Array<GigAttachmentUrl>;
  type: AttachmentType;
};


export type LocalizedGigAttachmentPreviewUrlArgs = {
  transformation: AttachmentTransformation;
};


export type LocalizedGigAttachmentPreviewUrlsArgs = {
  transformations: Array<GigAttachmentTransformation>;
};

export type LocalizedText = {
  localized: Maybe<Scalars['String']['output']>;
  original: Maybe<Scalars['String']['output']>;
};

export enum LoyaltyBenefitType {
  Consultation = 'CONSULTATION',
  CreditsFromFirstEligibleOrder = 'CREDITS_FROM_FIRST_ELIGIBLE_ORDER',
  CreditFromDeposit = 'CREDIT_FROM_DEPOSIT',
  FirstHourlyOrder = 'FIRST_HOURLY_ORDER',
  MatchingService = 'MATCHING_SERVICE',
  NewTeamMember = 'NEW_TEAM_MEMBER',
  OrderRewards = 'ORDER_REWARDS',
  ProjectPlanning = 'PROJECT_PLANNING',
  PurchaseCredit = 'PURCHASE_CREDIT'
}

export type LoyaltyInfo = {
  giftCardRequesters: Maybe<Array<Scalars['String']['output']>>;
  lastYearEarnedCredits: Scalars['Float']['output'];
  loyaltyTier: LoyaltyProgramTier;
  pointsAmount: Scalars['Float']['output'];
  pointsRewards: PointsRewards;
  usedEarnReferences: Array<UsedEarnReference>;
  yearlySpentInCents: Scalars['Float']['output'];
};

export type LoyaltyProgramStatus = {
  availableCreditsInCents: Maybe<Scalars['Int']['output']>;
  contextId: Maybe<Scalars['String']['output']>;
  contextType: Maybe<ContextType>;
  currentYearlySpendInCents: Maybe<Scalars['Int']['output']>;
  historyLog: Maybe<Array<HistoryLogItem>>;
  id: Scalars['ID']['output'];
  programType: Maybe<LoyaltyProgramType>;
  tier: Maybe<LoyaltyProgramTier>;
  totalCreditsInCents: Maybe<Scalars['Int']['output']>;
};

export type LoyaltyProgramStatusConnection = {
  edges: Maybe<Array<LoyaltyProgramStatusEdge>>;
  pageInfo: PageInfo;
  totalCount: Maybe<Scalars['Float']['output']>;
};

export type LoyaltyProgramStatusEdge = {
  cursor: Scalars['String']['output'];
  node: LoyaltyProgramStatus;
};

export enum LoyaltyProgramTier {
  Diamond = 'DIAMOND',
  Gold = 'GOLD',
  Platinum = 'PLATINUM',
  Silver = 'SILVER'
}

export enum LoyaltyProgramType {
  ProBuyersSpend = 'PRO_BUYERS_SPEND'
}

export type ManualVetting = Metric & {
  /** Timestamp indicating when the manual vetting evaluation was conducted */
  evaluatedAt: Scalars['Timestamp']['output'];
  /**
   * Indicates whether the seller has not successfully pass the manual vetting for promotion to the next level.
   * e.g True if the seller's manual vetting is rejected to be TRS
   */
  isBelowMinThreshold: Scalars['Boolean']['output'];
  /** Indicates whether the seller's manual vetting for demotion has been approved, allowing demotion to a lower level. */
  isDemotionApproved: Maybe<Scalars['Boolean']['output']>;
  /**
   * Indicates whether the seller fails to pass the current level standards and should be manually evaluated for demotion but still hasn't received one.
   * e.g True if the seller is in the process of being manually vetted for not being TRS level any more but a final decision has not yet been made.
   */
  isDemotionPending: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the seller's manual vetting for demotion has been rejected, so the seller should remain in the current level. */
  isDemotionRejected: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the seller's manual vetting for promotion has been approved, allowing promotion to a higher level. */
  isPromotionApproved: Maybe<Scalars['Boolean']['output']>;
  /**
   * Indicates whether the seller is eligible for manual vetting evaluation for promotion but still hasn't received one.
   * e.g True if the seller is in the process of being manually vetted for TRS promotion but a final decision has not yet been made.
   */
  isPromotionPending: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the seller's manual vetting is rejected to promote to the next level. */
  isRejected: Maybe<Scalars['Boolean']['output']>;
  /**
   * Indicates whether the seller has successfully passed manual vetting for promotion to the next level.
   * e.g True if the seller's manual vetting is approved to be TRS
   */
  isSatisfiedForNextLevel: Scalars['Boolean']['output'];
  /** Specifies the rationale behind the outcomes of the manual vetting process */
  reason: Maybe<Scalars['String']['output']>;
};

export type MarketplaceOrganization = BaseOrganization & Node & {
  businessInfo: Maybe<BusinessInfo>;
  id: Scalars['ID']['output'];
};

export type MatchCandidate = {
  createdAt: Scalars['Timestamp']['output'];
  customOffers: Array<CustomOffer>;
  firstMessage: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  matchedAt: Maybe<Scalars['Timestamp']['output']>;
  seller: Seller;
  status: MatchCandidateStatus;
  updatedAt: Maybe<Scalars['Timestamp']['output']>;
};

export enum MatchCandidateFilter {
  /** No filter applied */
  AllCandidates = 'ALL_CANDIDATES',
  /** Match candidates with closed status */
  ClosedStatus = 'CLOSED_STATUS',
  /** Match candidates with matched status */
  MatchedStatus = 'MATCHED_STATUS',
  /** Match candidates with queued status */
  QueuedStatus = 'QUEUED_STATUS',
  /** Match candidates that were previously matched regardless their current status */
  WasMatched = 'WAS_MATCHED'
}

export enum MatchCandidateStatus {
  Closed = 'CLOSED',
  Matched = 'MATCHED',
  Queued = 'QUEUED'
}

export type MatchCandidatesFilters = {
  createdByFlows: InputMaybe<Array<DmMatchCandidateCreationFlow>>;
};

export type MatchCandidatesMetrics = {
  activeCount: Scalars['Int']['output'];
  createdByBuyerFlowCount: Scalars['Int']['output'];
};

export type MeetingInvitation = Node & {
  /** The context in which the invitation was created */
  context: MessagingContext;
  /** Identifies the time the meeting invitation was created at */
  createdAt: Scalars['Timestamp']['output'];
  /** Meeting invitation id. */
  id: Scalars['ID']['output'];
  /** The participant who created the meeting invitation */
  initiator: MessagingParticipant;
  meeting: VideoMeeting;
  participants: Array<MessagingParticipant>;
  status: MeetingInvitationStatus;
  /** Identifies the time in which the meeting invitation had its last changes */
  updatedAt: Scalars['Timestamp']['output'];
};

/** Meeting invitation statuses */
export enum MeetingInvitationStatus {
  Accepted = 'ACCEPTED',
  Canceled = 'CANCELED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

export type Merchant = StudioMerchant | UserMerchant;

export type Message = {
  id: Scalars['ID']['output'];
};

export type MessagingContext = ConversationMessagingContext | OrderMessagingContext;

export type MessagingParticipant = UserMessagingParticipant;

export type MetadataEntry = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  otherValue: Scalars['Boolean']['output'];
  values: Array<MetadataEntryValue>;
};

export type MetadataEntryInput = {
  id: Scalars['ID']['input'];
  otherValue: Scalars['Boolean']['input'];
  values: Array<Scalars['ID']['input']>;
};

export type MetadataEntryValue = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type MetadataFieldValue = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type MetadataQuestion = {
  answers: Array<Scalars['String']['output']>;
  question: Maybe<Scalars['String']['output']>;
};

export type Metric = {
  /** Represents whether the metric is below the minimum threshold */
  isBelowMinThreshold: Maybe<Scalars['Boolean']['output']>;
  /** Represents whether the metric is satisfied for next level */
  isSatisfiedForNextLevel: Maybe<Scalars['Boolean']['output']>;
};

/** Holds all metrics we take into account when calculating seller level */
export type Metrics = {
  /** Total number of successfully completed orders by the seller */
  completedOrdersAmount: Maybe<NumericMetric>;
  /** Number of unique/distinct buyers a seller has interacted with */
  distinctBuyersAmount: Maybe<NumericMetric>;
  /**
   * Represents the outcome of a manual evaluation process for a seller's TRS status,
   * null means the seller hasn't been evaluated manually
   */
  manualVettingForTrs: Maybe<ManualVetting>;
  /** Rating given to the seller based on buyers feedback */
  rating: Maybe<NumericMetric>;
  /** seller response rate, based on first message/ interaction with buyer */
  responseRate: Maybe<NumericMetric>;
  /** A calculated performance score based on various performance metrics, quality bucket and DS model */
  successScore: Maybe<NumericMetric>;
  /** Total earnings of the seller */
  totalEarnings: Maybe<NumericMetric>;
};

export type Milestone = {
  description: Maybe<Scalars['String']['output']>;
  duration: Duration;
  price: Money;
  revisions: Maybe<Scalars['Int']['output']>;
  serial: Scalars['Int']['output'];
  status: MilestoneStatus;
  title: Scalars['String']['output'];
};

export enum MilestoneStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Delivered = 'DELIVERED',
  InProgress = 'IN_PROGRESS',
  Rejected = 'REJECTED',
  Unknown = 'UNKNOWN'
}

export type MobileCategoriesSettings = {
  /** Indicates whether to force update categories tree */
  forceUpdate: Scalars['Boolean']['output'];
  /** Categories last update time represent as unix epoch time in seconds */
  lastUpdateTime: Scalars['Timestamp']['output'];
};

export type MobileCounters = {
  /** Number of unread inbox conversations */
  unreadInboxConversations: Scalars['Int']['output'];
  /** Number of unread orders */
  unreadOrders: Scalars['Int']['output'];
  /** Number of unread pinned flashes that are not order related */
  unreadPinnedFlashes: Scalars['Int']['output'];
};

export type MobileCurrencySettings = {
  /** Array of all available currencies */
  availableCurrencies: Array<Currency>;
  /** The exchange rate between 1 USD to 1 user's currency */
  exchangeRate: Scalars['Float']['output'];
};

export type MobileCustomExtraPriceRanges = {
  /** Custom-extra price range for level 5 user */
  levelFive: MoneyAmountRangeType;
  /** Custom-extra price range for level 1 user */
  levelOne: MoneyAmountRangeType;
  /** Custom-extra price range for level 2 user */
  levelTwo: MoneyAmountRangeType;
  /** Custom-extra price range for level 0 user */
  levelZero: MoneyAmountRangeType;
  /** Custom-extra price range for no level user */
  noLevel: MoneyAmountRangeType;
};

export type MobileCustomExtraSettings = {
  /** Custom-extra price ranges per level in cents */
  priceRanges: MobileCustomExtraPriceRanges;
};

export type MobileCustomOfferSettings = {
  /** pro user custom-offer offering price range in USD cents */
  proUserPriceRange: MoneyAmountRangeType;
  /** regular user custom-offer offering price range in USD cents */
  regularUserPriceRange: MoneyAmountRangeType;
  /** studio user custom-offer offering price range in USD cents */
  studioUserPriceRange: MoneyAmountRangeType;
};

export type MobileFeatureFlags = {
  /** Indicates whether the clients should expose display name field */
  exposeDisplayName: Scalars['Boolean']['output'];
  /** Indicates whether the clients should change the inspire feed logic. controlled by a rollout */
  inspireShuffleAlgo: Scalars['Boolean']['output'];
  /** Indicates whether the clients should kill the forter sdk. controlled by a rollout */
  killForter: Scalars['Boolean']['output'];
  /** Indicates whether the clients should show unified inbox whats new */
  shouldShowUnifiedInboxWhatsNew: Scalars['Boolean']['output'];
  /** Indicates whether the clients should show new seller metrics field */
  showNewSellerMetrics: Scalars['Boolean']['output'];
};

export type MobileSettings = {
  /** catalog last update time represent as unix epoch time in seconds */
  catalogLastUpdateTimestamp: Scalars['Timestamp']['output'];
  /** cms catalog last update time represent as unix epoch time in seconds */
  cmsCatalogLastUpdateTimestamp: Scalars['Timestamp']['output'];
  /** Available search-cms-entries array */
  cmsEntries: Array<SearchCmsEntry>;
  /** deep links last update time represent as unix epoch time in seconds */
  deeplinkRoutesLastUpdateTimestamp: Scalars['Timestamp']['output'];
  /** Indicates whether the user has custom-offers with some active status */
  hasActiveCustomOffers: Scalars['Boolean']['output'];
  /** Indicates whether the user has orders with some active status */
  hasActiveOrders: Scalars['Boolean']['output'];
  /** Indicates whether the user/guest is cpra eligible */
  isCpraEligible: Scalars['Boolean']['output'];
  /** Array of user's last viewed SCs */
  lastViewedSubCategories: Array<UserLastViewedSubcategories>;
  /** Array of user's last viewed SCs */
  lastViewedSubCats: Array<Scalars['Int']['output']>;
  /** Max file uplad size in GB */
  maxFileUploadSizeInGb: Scalars['Float']['output'];
  /** Categories settings for mobile app */
  mobileCategoriesSettings: MobileCategoriesSettings;
  /** Currency settings for mobile app */
  mobileCurrencySettings: MobileCurrencySettings;
  /** Custom-extra settings for mobile app */
  mobileCustomExtraSettings: MobileCustomExtraSettings;
  /** Custom-offer settings for mobile app */
  mobileCustomOffersSettings: MobileCustomOfferSettings;
  /** Indicates whether to enable/disable certain of features in mobile app */
  mobileFeatureFlags: MobileFeatureFlags;
  /** Taxes info for mobile app use */
  mobileTaxesInfo: Array<MobileTaxesInfo>;
  /** Payments token polling time in seconds. */
  paymentTokenPollingTime: Scalars['Int']['output'];
  /** Threshold according to the rating of the order, whether to display a tip or not */
  positiveReviewTipThreshold: Scalars['Float']['output'];
  /** Fiverr's fee text */
  processingFeeText: Scalars['String']['output'];
  /** Indicates whether we should display tax note to the user/guest based on his location */
  shouldShowVatFeesBanner: Scalars['Boolean']['output'];
  /** Indicates whether to show update popup */
  showUpdateFeedbackPopup: Scalars['Boolean']['output'];
  /** Threshold according to the price of the order, whether to display a tip in percentages or dollars */
  tipPercentageThresholdInUSD: Scalars['Int']['output'];
  /** top-filters last update time represent as unix epoch time in seconds */
  topFiltersLastUpdateTimestamp: Scalars['Timestamp']['output'];
  /** Array of trusted messages viewed SCs */
  trustedMessagesSubCats: Array<Scalars['Int']['output']>;
  /** Min version and description to show whats new data, null if irrelevant to user's os or app version */
  whatsNewData: Maybe<WhatsNewData>;
};

export type MobileTaxesInfo = {
  /** The relevant tax's country */
  countryCode: Scalars['String']['output'];
  /** Indicates the minimum price to apply the tax from */
  minPriceToApply: Scalars['MoneyAmount']['output'];
  /** The relevant tax's country */
  taxCode: Scalars['String']['output'];
};

export type ModerateAgencyInput = {
  id: Scalars['ID']['input'];
};

export type ModerateAgencyResult = Agency | AgencyAlreadyInStatus | AgencyNotFound | KeyPointsInvalidInput;

export type ModerateCertifiedTestimonialInput = {
  id: Scalars['ID']['input'];
  reason: InputMaybe<Scalars['String']['input']>;
  status: CertifiedTestimonialStatusInput;
};

export type Money = {
  amount: Scalars['MoneyAmount']['output'];
  /** @deprecated Use amount+currency USD to describe amount in USD */
  amountInUsd: Scalars['MoneyAmount']['output'];
  currency: Currency;
};

export type MoneyAmountRangeType = {
  max: Scalars['MoneyAmount']['output'];
  min: Scalars['MoneyAmount']['output'];
};

export type MoneyRange = {
  max: Maybe<Money>;
  min: Maybe<Money>;
};

export type Mutation = {
  activateAgency: ActivateAgencyResult;
  closeUserProjectGoal: Maybe<CloseUserProjectGoalResult>;
  completePromotion: Promotion;
  createAgency: Agency;
  createFollowUpCampaign: CreateFollowUpCampaignResult;
  createPromotion: CreatePromotionResult;
  deactivateAgency: DeactivateAgencyResult;
  moderateAgency: ModerateAgencyResult;
  moderateCertifiedTestimonial: CertifiedTestimonialMutationResult;
  refineInspireDelivery: Maybe<InspireDeliveryRefinement>;
  requestCertifiedTestimonial: CertifiedTestimonialMutationResult;
  shareInspireDelivery: Maybe<ShareDeliveryResult>;
  shareOrderDelivery: Maybe<ShareDeliveryResult>;
  submitCertifiedTestimonial: CertifiedTestimonialMutationResult;
  updateAgency: Agency;
  /** Subscribe/Unsubscribe from subcategory */
  updateTopicSubscription: TopicSubscriptionResult;
  /** Vote for delivery */
  voteDelivery: VoteResult;
};


export type MutationActivateAgencyArgs = {
  activateAgencyInput: ActivateAgencyInput;
};


export type MutationCloseUserProjectGoalArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCompletePromotionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateAgencyArgs = {
  createAgencyInput: CreateAgencyInput;
};


export type MutationCreateFollowUpCampaignArgs = {
  input: FollowUpCampaignInput;
};


export type MutationCreatePromotionArgs = {
  input: PromotionInput;
};


export type MutationDeactivateAgencyArgs = {
  deactivateAgencyInput: DeactivateAgencyInput;
};


export type MutationModerateAgencyArgs = {
  moderateAgencyInput: ModerateAgencyInput;
};


export type MutationModerateCertifiedTestimonialArgs = {
  input: ModerateCertifiedTestimonialInput;
};


export type MutationRefineInspireDeliveryArgs = {
  edits: InspireDeliveryRefinementInput;
  id: Scalars['String']['input'];
  origin: InspireDeliveryRefinementOrigin;
};


export type MutationRequestCertifiedTestimonialArgs = {
  input: RequestCertifiedTestimonialInput;
};


export type MutationShareInspireDeliveryArgs = {
  input: ShareInspireDeliveryInput;
};


export type MutationShareOrderDeliveryArgs = {
  input: ShareOrderDeliveryInput;
};


export type MutationSubmitCertifiedTestimonialArgs = {
  input: SubmitCertifiedTestimonialInput;
};


export type MutationUpdateAgencyArgs = {
  updateAgencyInput: UpdateAgencyInput;
};


export type MutationUpdateTopicSubscriptionArgs = {
  topicSubscription: InputMaybe<TopicSubscriptionInput>;
};


export type MutationVoteDeliveryArgs = {
  deliveryVote: DeliveryVoteInput;
};

export type NestedBoolean = {
  value: Scalars['Boolean']['output'];
};

export type NestedMultiString = {
  value: Array<Scalars['String']['output']>;
};

export type NestedString = {
  value: Scalars['String']['output'];
};

export type NetworkPresence = {
  /** Number of posts, likes, views etc. */
  influenceCount: Maybe<Scalars['Int']['output']>;
  /** Type of the influenceCount metric. */
  influenceType: Maybe<InfluenceType>;
  /** User profile URL on the platform. */
  url: Maybe<Scalars['String']['output']>;
};

export enum NextServiceCertainty {
  HighlyLikely = 'HIGHLY_LIKELY',
  Likely = 'LIKELY',
  Possible = 'POSSIBLE',
  Unlikely = 'UNLIKELY'
}

export enum NextServiceUrgency {
  Immediate = 'IMMEDIATE',
  LongTerm = 'LONG_TERM',
  Moderate = 'MODERATE'
}

export type NextStep = {
  certaintyLevel: Maybe<NextServiceCertainty>;
  explanation: Scalars['String']['output'];
  name: Scalars['String']['output'];
  searchTerm: Scalars['String']['output'];
  subCategoryId: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  urgencyLevel: Maybe<NextServiceUrgency>;
};

/** An object with an ID. */
export type Node = {
  /** ID of the object. */
  id: Scalars['ID']['output'];
};

export type NotableClient = {
  company: Company;
  /** The description of the interaction with the user */
  description: Maybe<Scalars['String']['output']>;
  /** The date when the interaction with the client ended */
  endedAt: Maybe<Scalars['Timestamp']['output']>;
  id: Scalars['ID']['output'];
  /** The date when the interaction with the client started */
  startedAt: Maybe<Scalars['Timestamp']['output']>;
};

export type NumericMetric = Metric & {
  isBelowMinThreshold: Maybe<Scalars['Boolean']['output']>;
  isSatisfiedForNextLevel: Maybe<Scalars['Boolean']['output']>;
  /** Represents the max value of a metric */
  max: Maybe<Scalars['Float']['output']>;
  /** Represents the minimum value of a metric */
  min: Maybe<Scalars['Float']['output']>;
  /** Represents the threshold required to maintain the current level. */
  thresholdForCurrentLevel: Maybe<Scalars['Float']['output']>;
  /** Represents the threshold required to qualify for the next level. */
  thresholdForNextLevel: Maybe<Scalars['Float']['output']>;
  /** Represents the value of the metric */
  value: Maybe<Scalars['Float']['output']>;
};

/**
 * A numeric benefit is a benefit that has a numeric value.
 * For example, a level two seller has 10 gigs, while a TRS has 30 gigs.
 */
export type NumericSellerBenefit = {
  /** A list containing all relevant seller achievements, and the numeric value of this benefit for each achievement. */
  achievementsCriteria: Array<SellerNumericBenefitAchievementCriterion>;
  /**
   * The numeric value of this benefit based on the seller's current level or vetting.
   * If the seller is not eligible for this benefit, the value is null.
   */
  value: Maybe<Scalars['Float']['output']>;
};

/** Represents social platform where the seller is present. */
export type OnlinePresence = NetworkPresence & {
  influenceCount: Maybe<Scalars['Int']['output']>;
  influenceType: Maybe<InfluenceType>;
  platform: OnlinePresencePlatform;
  url: Maybe<Scalars['String']['output']>;
};

/** Source: https://github.com/fiverr/seller_profile_chimera/blob/master/models/pro_seller/config/online_presence_networks.yml */
export enum OnlinePresencePlatform {
  Ello = 'ELLO',
  Facebook = 'FACEBOOK',
  GooglePlus = 'GOOGLE_PLUS',
  Instagram = 'INSTAGRAM',
  Linkedin = 'LINKEDIN',
  Pinterest = 'PINTEREST',
  Reddit = 'REDDIT',
  Snapchat = 'SNAPCHAT',
  Stumbleupon = 'STUMBLEUPON',
  Taringa = 'TARINGA',
  Twitter = 'TWITTER',
  Videohive = 'VIDEOHIVE',
  Vkontakte = 'VKONTAKTE',
  Weheartit = 'WEHEARTIT'
}

export type OptionForCustomOffer = {
  gig: CustomOfferGig;
  isSubscriptionEligible: Scalars['Boolean']['output'];
};

export type OptionsForCustomOffer = {
  hourlyLimitations: HourlyLimitations;
  hourlyOrderInitiationFee: Money;
  learnMoreLink: Scalars['String']['output'];
  milestoneMinPrice: Money;
  options: Maybe<Array<OptionForCustomOffer>>;
  roles: Maybe<Array<RoleOptionForCustomOffer>>;
  softwareReselling: Maybe<Array<SoftwareResellingOptionForCustomOffer>>;
};

/** Should be order from federation */
export type Order = Node & {
  amount: Money;
  amountInUsd: Money;
  autoCompleteTime: Maybe<Scalars['Timestamp']['output']>;
  /**
   * The extras available for this order. not available for hourly orders.
   * Warning: Don't use this field when querying multiple orders.
   * This field increases response time.
   */
  availableExtras: Maybe<OrderExtras>;
  /** @deprecated Use project instead */
  businessProject: Maybe<BusinessProject>;
  buyer: Maybe<Customer>;
  /** total amount the buyer paid ( initial purchase &  upsells), include fees and taxes */
  buyerTotalPaidAmount: ExtendedMoney;
  completedAt: Maybe<Scalars['Timestamp']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  currentActiveUnit: Scalars['Int']['output'];
  deliveryTime: Maybe<Scalars['Timestamp']['output']>;
  description: Maybe<Scalars['String']['output']>;
  detailedStatus: DetailedOrderStatus;
  dueDate: Maybe<Scalars['Timestamp']['output']>;
  encryptedId: Scalars['String']['output'];
  generatedOrderData: Maybe<GeneratedOrderData>;
  gig: Maybe<Gig>;
  goal: Maybe<Goal>;
  hosting: Maybe<Hosting>;
  /** Encoded order id. */
  id: Scalars['ID']['output'];
  industry: Maybe<Industry>;
  isAutoCompleted: Scalars['Boolean']['output'];
  isEmbeddedOrder: Scalars['Boolean']['output'];
  isFastDelivery: Scalars['Boolean']['output'];
  /**
   * For mobile app use only! Indicates whether the order's gig was a fiverr choice gig when the order has created
   * @deprecated For mobile-app use only
   */
  isFiverrChoice: Maybe<Scalars['Boolean']['output']>;
  isGeneratedOrder: Scalars['Boolean']['output'];
  isLogoMaker: Scalars['Boolean']['output'];
  /**
   * Indicates whether the order is a milestone order
   * @deprecated For mobile-app use only
   */
  isMilestone: Scalars['Boolean']['output'];
  isPro: Scalars['Boolean']['output'];
  isReselling: Scalars['Boolean']['output'];
  isRevisedGeneratedOrder: Scalars['Boolean']['output'];
  isSelfService: Scalars['Boolean']['output'];
  isStudio: Scalars['Boolean']['output'];
  isSubscription: Scalars['Boolean']['output'];
  isTeamPurchase: Scalars['Boolean']['output'];
  loyaltyRewards: Maybe<AccumulatedRewards>;
  /** For mobile app use only! Wether the user marked the order as unread */
  markedUnread: Scalars['Boolean']['output'];
  midRatings: Array<OrderRating>;
  /**
   * Milestone of the order (if order is a milestones order)
   * @deprecated For mobile-app use only
   */
  milestones: Maybe<Array<Milestone>>;
  /** For mobile app use only! The number of unread updates in the order chat */
  orderChatUpdatesCount: Maybe<Scalars['Int']['output']>;
  orderSystemType: OrderSystemType;
  orderTypeSpecificDetails: Maybe<OrderTypeSpecificDetails>;
  /** For mobile app use only! The number of unread updates in the order timeline */
  orderUpdatesCount: Maybe<Scalars['Int']['output']>;
  productSnapshot: ProductSnapshot;
  /** Product type of the order (e.g., GIG, OFFERING) */
  productType: Maybe<ProductType>;
  project: Maybe<Project>;
  /** For mobile app use only! Indicates whether the order was created from promoted ad */
  promotedAd: Maybe<Scalars['Boolean']['output']>;
  purchases: Array<Purchase>;
  rating: Maybe<OrderRating>;
  recurringData: Maybe<RecurringData>;
  selectedPackage: PackageType;
  seller: Maybe<Merchant>;
  status: OrderStatus;
  /** For mobile app use only! Localized status to be shown as a badge on an order */
  statusTitle: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  /** @deprecated Use unitsPaginated */
  units: Array<OrderUnit>;
  unitsPaginated: OrderUnitConnection;
  userProjectGoal: Maybe<UserProjectGoal>;
};


/** Should be order from federation */
export type OrderMidRatingsArgs = {
  allowHidden?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Should be order from federation */
export type OrderRatingArgs = {
  allowHidden?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Should be order from federation */
export type OrderUnitsPaginatedArgs = {
  unitSearchParams: InputMaybe<OrderUnitSearchParams>;
};

/** The connection type for OrderConnection */
export type OrderConnection = Connection & {
  /** A list of edges */
  edges: Maybe<Array<OrderEdge>>;
  /** A list of nodes */
  nodes: Maybe<Array<Maybe<Order>>>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection */
  totalCount: Scalars['Int']['output'];
};

export type OrderDeliveryAssetsSharing = {
  assets: Array<OrderDeliverySharedAsset>;
  gig: Gig;
  id: Scalars['ID']['output'];
  seller: Seller;
};

export type OrderDeliverySharedAsset = {
  attachment: AssetsSharingAttachment;
};

export type OrderEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Order>;
};

export enum OrderEntitledForCredit {
  AlreadyUsed = 'ALREADY_USED',
  EachProSeller = 'EACH_PRO_SELLER',
  EveryOrder = 'EVERY_ORDER',
  FirstOrderOverAmount = 'FIRST_ORDER_OVER_AMOUNT'
}

export type OrderExtras = {
  calculators: Array<ExtrasCalculator>;
  items: Array<ExtrasOrderItem>;
  /** The package extra item available for upsell. Only available for seller. */
  packageItem: Maybe<PackageExtraItem>;
  /** The quantity of the gig package purchased for this order */
  purchasedPackageQuantity: Scalars['Int']['output'];
};

export type OrderFacets = {
  /** Members of the same business as the current user which ordered an order. */
  businessMemberFacets: Array<BusinessMemberFacet>;
  statusFacets: Array<OrderStatusFacet>;
};

export type OrderItem = Buyable & Deliverable & Item & {
  buyableData: Maybe<ItemBuyableData>;
  duration: Duration;
  extraFast: Scalars['Boolean']['output'];
  id: Maybe<Scalars['Int']['output']>;
  localizedTitle: Maybe<Scalars['String']['output']>;
  price: Maybe<ExtendedMoney>;
  quantity: Scalars['Int']['output'];
  requiresDelivery: Scalars['Boolean']['output'];
  title: Maybe<Scalars['String']['output']>;
};

export type OrderMessagingContext = {
  order: Maybe<Order>;
};

export type OrderRating = Rating & {
  /** Represents the details of the public buying review associated with the order. */
  buyingReview: BuyingReview;
  /** Represents the list of rating components which contribute to the rating score. */
  components: Array<RatingComponent>;
  /** Represents the final rating score of an order, based on all relevant metrics. */
  score: Scalars['Float']['output'];
  /** Represents the details of the seller response associated with the order. */
  sellerResponse: Maybe<SellerResponse>;
  /** Represents the details of the selling review associated with the order. */
  sellingReview: Maybe<SellingReview>;
};

export type OrderReports = {
  /** Order ID */
  orderId: Scalars['String']['output'];
  /** List of reports associated with the order ID */
  reports: Array<Report>;
  /** Identifies the total paid minutes for reports */
  totalPaidMinutes: Scalars['Int']['output'];
  /** Identifies the total reported minutes for reports */
  totalReportedMinutes: Scalars['Int']['output'];
};

export type OrderSearchRequest = {
  buyerIds: InputMaybe<Array<Scalars['String']['input']>>;
  canceledAt: InputMaybe<DateQuery>;
  completedAt: InputMaybe<DateQuery>;
  createdAt: InputMaybe<DateQuery>;
  deliveryTime: InputMaybe<DateQuery>;
  organizationId: InputMaybe<Scalars['String']['input']>;
  productId: InputMaybe<Scalars['String']['input']>;
  productIds: InputMaybe<Array<Scalars['String']['input']>>;
  productType: InputMaybe<ProductType>;
  projectIds: InputMaybe<Array<Scalars['String']['input']>>;
  sellerIds: InputMaybe<Array<Scalars['String']['input']>>;
  statuses: InputMaybe<Array<OrderStatusInput>>;
};

export type OrderStatistics = {
  /** Average order amount across all the buyer's orders. */
  avgOrderAmount: Maybe<Scalars['Float']['output']>;
  /** Average tip amount given by the buyer across their orders. */
  avgTipAmount: Maybe<Scalars['Float']['output']>;
  /** The type or category of buyer. */
  buyerType: Maybe<Scalars['String']['output']>;
  /** Date when the buyer placed their first order (First Time Buyer date). */
  firstTimeBuyerDate: Maybe<Scalars['DateTime']['output']>;
  /** Indicates whether the buyer is currently active. */
  isActiveBuyer: Maybe<Scalars['Int']['output']>;
  /** Date of the buyer's most recent order. */
  lastOrderDate: Maybe<Scalars['DateTime']['output']>;
  /** The maximum amount of a child order placed by the buyer. */
  maxChildOrderAmount: Maybe<Scalars['Float']['output']>;
  /** The maximum order amount the buyer has placed. */
  maxOrderAmount: Maybe<Scalars['Float']['output']>;
  /** Number of orders where the buyer provided a tip. */
  ordersWithTips: Maybe<Scalars['Int']['output']>;
  /** Number of distinct sub-categories the buyer has ordered from. */
  subCategoryCount: Maybe<Scalars['Int']['output']>;
  /** Total number of orders canceled by the buyer. */
  totalCanceledOrdersBuyers: Maybe<Scalars['Int']['output']>;
  /** Total number of child orders associated with the buyer. */
  totalChildOrders: Maybe<Scalars['Int']['output']>;
  /** Total number of orders completed by the buyer. */
  totalCompleteOrdersBuyers: Maybe<Scalars['Int']['output']>;
  /** Total number of orders completed by the buyer in the last 60 days. */
  totalCompletedOrders60Days: Maybe<Scalars['Int']['output']>;
  /** Total number of orders completed by the buyer in the last 180 days. */
  totalCompletedOrders180Days: Maybe<Scalars['Int']['output']>;
  /** Total lifetime GOA (Gross Order Amount) for the buyer. */
  totalLifetimeGoa: Maybe<Scalars['Float']['output']>;
  /** Total number of NEO orders placed by the buyer. */
  totalNeoOrders: Maybe<Scalars['Int']['output']>;
  /** Total number of orders placed by the buyer. */
  totalOrders: Maybe<Scalars['Int']['output']>;
  /** Total number of orders placed by the buyer over their lifetime. */
  totalOrdersLifetime: Maybe<Scalars['Int']['output']>;
  /** Total number of parent orders placed by the buyer over their lifetime. */
  totalParentOrdersLifetime: Maybe<Scalars['Int']['output']>;
  /** Total amount of tips given by the buyer. */
  totalTipsAmount: Maybe<Scalars['Float']['output']>;
};

/** The status of the order */
export enum OrderStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Delivered = 'DELIVERED',
  Dispute = 'DISPUTE',
  Incomplete = 'INCOMPLETE',
  Inprogress = 'INPROGRESS',
  InProgress = 'IN_PROGRESS',
  Late = 'LATE',
  Rejected = 'REJECTED',
  Verylate = 'VERYLATE'
}

export type OrderStatusData = {
  status: OrderStatusOutput;
  value: Scalars['Int']['output'];
};

export type OrderStatusFacet = {
  id: OrdersStatusFilter;
  /** The human name of the filter */
  title: Scalars['String']['output'];
  /**
   * The number of orders in the status filter.
   *  Would be null for Business type since it is currently unssuported.
   */
  value: Maybe<Scalars['Int']['output']>;
};

export enum OrderStatusInput {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Delivered = 'DELIVERED',
  Dispute = 'DISPUTE',
  Incomplete = 'INCOMPLETE',
  InProgress = 'IN_PROGRESS',
  Late = 'LATE',
  Rejected = 'REJECTED',
  Verylate = 'VERYLATE'
}

export enum OrderStatusOutput {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Delivered = 'DELIVERED',
  Dispute = 'DISPUTE',
  Incomplete = 'INCOMPLETE',
  InProgress = 'IN_PROGRESS',
  Late = 'LATE',
  Rejected = 'REJECTED',
  Verylate = 'VERYLATE'
}

export type OrderStatusesFacets = {
  statusesFacets: Array<OrderStatusData>;
};

export enum OrderSystemType {
  NewSystem = 'NEW_SYSTEM',
  OldSystem = 'OLD_SYSTEM'
}

export type OrderTypeSpecificDetails = {
  orderType: Maybe<ProductType>;
};

export type OrderUnit = {
  description: Maybe<Scalars['String']['output']>;
  /** Unit package duration */
  duration: Duration;
  /** unit package amount. in milestones, each unit price will be the agreed milestone price */
  price: ExtendedMoney;
  revisions: Maybe<Scalars['Int']['output']>;
  serial: Scalars['Int']['output'];
  /**  DO NOT USE - The only client that should use the url is gig-payment-kimera! */
  startUnitCallbackUrl: Maybe<Scalars['String']['output']>;
  startedAt: Maybe<Scalars['Timestamp']['output']>;
  status: UnitStatus;
  title: Scalars['String']['output'];
  /** Aggregation of package duration + extra items durations + upsells durations */
  totalDuration: Duration;
  /** actual paid amounts: unit package amount +  additional upsell purchases (include fees, tax etc.. ).in milestones, un-started milestone value will be null */
  totalPaidAmount: Maybe<ExtendedMoney>;
  /** Aggregation of unit package price + extra items prices + upsells prices (excluding service fees, tax etc.. ) */
  totalPrice: ExtendedMoney;
  /** The amount the seller received : the unit amount + additional upsell purchases - any refunds. */
  totalReceivedAmount: Maybe<ExtendedMoney>;
};

export type OrderUnitConnection = Connection & {
  /** A list of edges */
  edges: Maybe<Array<OrderUnitEdge>>;
  /** A list of nodes */
  nodes: Maybe<Array<Maybe<OrderUnitInterface>>>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection */
  totalCount: Scalars['Int']['output'];
};

export type OrderUnitEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<OrderUnitInterface>;
};

export type OrderUnitFiltering = {
  reportIds: InputMaybe<Array<Scalars['String']['input']>>;
  statuses: InputMaybe<Array<Scalars['String']['input']>>;
  types: InputMaybe<Array<OrderUnitType>>;
};

export type OrderUnitInterface = {
  billing: Maybe<Billing>;
  financialActivity: Maybe<FinancialActivity>;
  serial: Scalars['Int']['output'];
  startedAt: Maybe<Scalars['Timestamp']['output']>;
  totalPaidAmount: Maybe<ExtendedMoney>;
  totalReceivedAmount: Maybe<ExtendedMoney>;
  unitId: Maybe<Scalars['String']['output']>;
};

export type OrderUnitPagination = {
  after: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
};

export type OrderUnitSearchParams = {
  orderUnitFiltering: InputMaybe<OrderUnitFiltering>;
  orderUnitPagination: InputMaybe<OrderUnitPagination>;
  orderUnitSorting: InputMaybe<OrderUnitSorting>;
};

export enum OrderUnitSortBy {
  Serial = 'SERIAL',
  StartedAt = 'STARTED_AT'
}

export type OrderUnitSorting = {
  sortBy: OrderUnitSortBy;
  sortOrder: SortOrderUnit;
};

export enum OrderUnitType {
  Gig = 'GIG',
  HourlyInitialFee = 'HOURLY_INITIAL_FEE',
  HourlyWork = 'HOURLY_WORK'
}

export enum OrdersSortBy {
  CreatedAt = 'CREATED_AT',
  DeliveryDate = 'DELIVERY_DATE'
}

export enum OrdersStatusFilter {
  Active = 'ACTIVE',
  All = 'ALL',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Delivered = 'DELIVERED',
  InProgress = 'IN_PROGRESS',
  InRevision = 'IN_REVISION',
  Late = 'LATE',
  MissingDetails = 'MISSING_DETAILS',
  New = 'NEW',
  PastOrders = 'PAST_ORDERS',
  Priority = 'PRIORITY',
  RequiresAttention = 'REQUIRES_ATTENTION',
  Review = 'REVIEW',
  Upcoming = 'UPCOMING',
  Updates = 'UPDATES'
}

export enum OrdersViewerType {
  Business = 'BUSINESS',
  Buyer = 'BUYER',
  Seller = 'SELLER'
}

export type Organization = Node & {
  id: Scalars['ID']['output'];
};

export enum OwnerType {
  Business = 'BUSINESS',
  User = 'USER'
}

export type PackageExtraItem = {
  duration: Scalars['Int']['output'];
  id: Scalars['Long']['output'];
  price: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type PackageItem = Buyable & Deliverable & Item & {
  buyableData: Maybe<ItemBuyableData>;
  description: Maybe<Scalars['String']['output']>;
  duration: Duration;
  extraFast: Scalars['Boolean']['output'];
  id: Maybe<Scalars['Int']['output']>;
  items: Array<OrderItem>;
  price: Maybe<ExtendedMoney>;
  quantity: Scalars['Int']['output'];
  requiresDelivery: Scalars['Boolean']['output'];
  title: Maybe<Scalars['String']['output']>;
};

/** The type of package of a gig */
export enum PackageType {
  Basic = 'BASIC',
  CustomOffer = 'CUSTOM_OFFER',
  Premium = 'PREMIUM',
  Standard = 'STANDARD'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']['output']>;
};

export type Pagination = {
  after: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
};

export type PaginationInput = {
  after: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  skip: InputMaybe<Scalars['Int']['input']>;
};

export type PartnersCouponBenefit = {
  couponCode: Scalars['String']['output'];
  expirationDate: Scalars['Timestamp']['output'];
  startDate: Scalars['Timestamp']['output'];
  status: PromoCodeStatus;
};

export type PaymentMilestone = {
  /** The description of the payment milestone, decided by the seller. */
  description: Maybe<Scalars['String']['output']>;
  /** The time, in days, it will take to complete the milestone. */
  duration: Scalars['Int']['output'];
  /** A unique identifier for the Custom Pricing Factor. A 24 character hexadecimal string. */
  id: Scalars['String']['output'];
  /**
   * The price (in USD) of the payment milestone.
   * Example: price of 50 means $50 (5000 cents).
   */
  price: Scalars['Int']['output'];
  /** Offered number of revisions. */
  revisions: Scalars['Int']['output'];
  /** The sequence number of the milestone (which is it in the order of milestones). */
  sequenceNumber: Scalars['Int']['output'];
  /** The title of the payment milestone, decided by the seller. */
  title: Scalars['String']['output'];
};

export type Platform = {
  isEligible: Scalars['Boolean']['output'];
  name: EmbedPlatformName;
};

export enum PointsEarnReferenceType {
  Deposit = 'DEPOSIT',
  FirstHourlyOrder = 'FIRST_HOURLY_ORDER',
  FirstSilverOrder = 'FIRST_SILVER_ORDER',
  Order = 'ORDER',
  Referral = 'REFERRAL',
  System = 'SYSTEM',
  TeamMemberJoined = 'TEAM_MEMBER_JOINED'
}

export type PointsEvent = {
  context: Context;
  createdAt: Scalars['DateTime']['output'];
  depositId: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  expiry: Maybe<Scalars['DateTime']['output']>;
  externalId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  orderId: Maybe<Scalars['String']['output']>;
  pointsRedemption: Maybe<PointsRedemption>;
  redemptionId: Maybe<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
  reverted: Maybe<Scalars['Boolean']['output']>;
  type: PointsEventType;
  user: Maybe<User>;
  value: Scalars['Float']['output'];
};

export type PointsEventConnection = {
  edges: Maybe<Array<PointsEventEdge>>;
  pageInfo: PageInfo;
  totalCount: Maybe<Scalars['Float']['output']>;
};

export type PointsEventEdge = {
  cursor: Scalars['String']['output'];
  node: PointsEvent;
};

export enum PointsEventType {
  Earn = 'EARN',
  Expire = 'EXPIRE',
  Redeem = 'REDEEM',
  Remove = 'REMOVE'
}

export enum PointsRedeemReferenceType {
  Donation = 'DONATION',
  FiverrCredits = 'FIVERR_CREDITS',
  GiftCard = 'GIFT_CARD'
}

export type PointsRedemption = {
  context: Context;
  expiry: Maybe<Scalars['DateTime']['output']>;
  externalId: Maybe<Scalars['String']['output']>;
  externalUrl: Maybe<Scalars['String']['output']>;
  pinCode: Maybe<Scalars['Int']['output']>;
  status: Maybe<PointsRedemptionStatus>;
  type: PointsRedeemReferenceType;
  value: Scalars['Float']['output'];
};

export enum PointsRedemptionStatus {
  Expired = 'EXPIRED',
  New = 'NEW',
  PartiallyUsed = 'PARTIALLY_USED',
  Used = 'USED'
}

export type PointsReward = {
  amount: Scalars['Int']['output'];
  pointsEventId: Maybe<Scalars['String']['output']>;
};

export type PointsRewardEntry = {
  rewardConfig: RewardConfig;
  rewardType: PointsRedeemReferenceType;
};

export type PointsRewards = {
  entries: Array<PointsRewardEntry>;
};

export enum PortfolioAttachmentTransformation {
  None = 'NONE',
  TCaseStudyCard = 'T_CASE_STUDY_CARD',
  TCaseStudyCardDark = 'T_CASE_STUDY_CARD_DARK',
  TPortfolioProjectCard = 'T_PORTFOLIO_PROJECT_CARD',
  TPortfolioProjectGrid = 'T_PORTFOLIO_PROJECT_GRID',
  TPortfolioProjectLarge = 'T_PORTFOLIO_PROJECT_LARGE',
  TPortfolioProjectSmall = 'T_PORTFOLIO_PROJECT_SMALL'
}

/** The reasons for portfolio project moderation rejection */
export enum PortfolioModerationReason {
  ContainsPaymentMethod = 'CONTAINS_PAYMENT_METHOD',
  InappropriateContent = 'INAPPROPRIATE_CONTENT',
  IntellectualPropertyViolation = 'INTELLECTUAL_PROPERTY_VIOLATION',
  NonOriginalContent = 'NON_ORIGINAL_CONTENT',
  ObjectionableContent = 'OBJECTIONABLE_CONTENT',
  ProhibitedServices = 'PROHIBITED_SERVICES',
  UnauthorizedUsage = 'UNAUTHORIZED_USAGE',
  Unspecified = 'UNSPECIFIED'
}

/** The moderation status of a portfolio project */
export enum PortfolioModerationStatus {
  Approved = 'APPROVED',
  Denied = 'DENIED',
  Pending = 'PENDING',
  Unspecified = 'UNSPECIFIED'
}

export type PortfolioPreviewUrl = {
  /** Transformation key for the preview URL */
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Seller's portfolio project. */
export type PortfolioProject = {
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  items: Maybe<PortfolioProjectItemConnection>;
  /** @deprecated Use items */
  projectItems: Array<PortfolioProjectItem>;
  title: Maybe<Scalars['String']['output']>;
};


/** Seller's portfolio project. */
export type PortfolioProjectItemsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for PortfolioProject to support pagination. */
export type PortfolioProjectConnection = {
  /** A list of edges. */
  edges: Maybe<Array<PortfolioProjectEdge>>;
  /** A list of nodes. */
  nodes: Maybe<Array<PortfolioProject>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a PortfolioProjectConnection. */
export type PortfolioProjectEdge = {
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge. */
  node: Maybe<PortfolioProject>;
};

export type PortfolioProjectField = {
  /** The attachment ID when the field type is PROJECT_ITEM */
  attachmentId: Maybe<Scalars['String']['output']>;
  /** The type of portfolio project field that violated moderation rules */
  type: PortfolioProjectFieldType;
};

/** The type of portfolio project field that violated moderation rules */
export enum PortfolioProjectFieldType {
  Description = 'DESCRIPTION',
  ProjectItem = 'PROJECT_ITEM',
  Title = 'TITLE'
}

export type PortfolioProjectInternalProjectDetails = {
  /** The user name of the buyer */
  buyerUserName: Maybe<Scalars['String']['output']>;
  /** The delivery ID of the order */
  deliveryId: Maybe<Scalars['Int']['output']>;
  /** The nested sub category of the related gig */
  nestedSubCategoryId: Maybe<Scalars['Int']['output']>;
  /** The order rating */
  rating: Maybe<Scalars['Float']['output']>;
};

/** Contains one of the attachements for the portfolio project item. */
export type PortfolioProjectItem = {
  attachment: Maybe<Attachment>;
  id: Scalars['ID']['output'];
};

/** The connection type for PortfolioItemProject to support pagination. */
export type PortfolioProjectItemConnection = {
  /** A list of edges. */
  edges: Maybe<Array<PortfolioProjectItemEdge>>;
  /** A list of nodes. */
  nodes: Maybe<Array<PortfolioProjectItem>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a PortfolioProjectItemConnection. */
export type PortfolioProjectItemEdge = {
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge. */
  node: Maybe<PortfolioProjectItem>;
};

export type PortfolioProjectModeration = {
  /** The reasons for portfolio project moderation rejection */
  reasons: Maybe<Array<PortfolioModerationReason>>;
  status: Maybe<PortfolioModerationStatus>;
  /** The fields in the portfolio project that cause the moderation rejection */
  violatedFields: Maybe<Array<PortfolioProjectField>>;
};

export type PortfolioProjectRoleCatalog = {
  /** Metadata associated with the project */
  metadata: Array<CatalogMetadataValue>;
  /**
   * Metadata IDs associated with the project
   * @deprecated use metadata
   */
  metadataIds: Array<Scalars['String']['output']>;
  /**
   * IDs of catalog roles associated with the project
   * @deprecated use roles
   */
  roleIds: Array<Scalars['String']['output']>;
  /** Roles associated with the project */
  roles: Array<CatalogRole>;
  /** Seller roles associated with the project */
  sellerRoles: Array<SellerRole>;
  /**
   * Service IDs associated with the project
   * @deprecated use services
   */
  serviceIds: Array<Scalars['String']['output']>;
  /** Services associated with the project */
  services: Array<CatalogService>;
};

export enum PortfolioProjectSource {
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

export type PreviewUrl = {
  /** Key used to map the transformation to the url (identical to the key in the input) */
  key: Scalars['String']['output'];
  /** A Cloudinary url with the transformation applied */
  url: Scalars['String']['output'];
};

export type PriceCalculator = {
  additionalAmountStep: Maybe<Scalars['Int']['output']>;
  additionalBuyable: Maybe<GigPricingFactor>;
  additionalPriceStep: Maybe<Money>;
  includedAmount: Maybe<Scalars['Int']['output']>;
  includedBuyable: Maybe<GigPricingFactor>;
  type: Maybe<Scalars['String']['output']>;
};

export type PricingFactor = {
  /** The SQL id of gig_items in gigs table. */
  buyableId: Scalars['Int']['output'];
  /** Title for custom extras, set by the seller. */
  buyableTitle: Maybe<Scalars['String']['output']>;
  /** Slug representation of the pricing factor. */
  buyableType: Scalars['String']['output'];
  /** Amount of days the additional pricing factor adds to delivery. */
  duration: Scalars['Int']['output'];
  /** A unique identifier for the Custom Pricing Factor. A 24 character hexadecimal string. */
  id: Scalars['String']['output'];
  /** Is the pricing factor included in the Custom Package price. */
  included: Scalars['Boolean']['output'];
  /**
   * Offered number of revisions for the pricing factor.
   * Set to 'null' if the type of the pricing factor is not 'modifications'.
   */
  includedModifications: Maybe<Scalars['String']['output']>;
  /**
   * The price (in USD) of the payment milestone.
   * Example: price of 50 means $50 (5000 cents).
   */
  price: Scalars['Float']['output'];
  /**
   * Corresponding amount of the pricing factor.
   * Example: word_count: 100
   * Set to 'null' if the type of the pricing factor is 'modifications'.
   */
  value: Maybe<Scalars['Float']['output']>;
};

export enum PrivacyType {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type ProductSnapshot = {
  categoryId: Scalars['Int']['output'];
  categoryName: Maybe<Scalars['String']['output']>;
  categoryReportId: Maybe<Scalars['Int']['output']>;
  categoryReportName: Maybe<Scalars['String']['output']>;
  subCategoryId: Scalars['Int']['output'];
  subCategoryName: Maybe<Scalars['String']['output']>;
  subCategoryReportId: Maybe<Scalars['Int']['output']>;
  subCategoryReportName: Maybe<Scalars['String']['output']>;
};

/** The type of order */
export enum ProductType {
  Gig = 'GIG',
  Hourly = 'HOURLY',
  Offering = 'OFFERING'
}

/** Represents professional social platform where the seller is present. */
export type ProfessionalPresence = NetworkPresence & {
  influenceCount: Maybe<Scalars['Int']['output']>;
  influenceType: Maybe<InfluenceType>;
  platform: ProfessionalPresencePlatform;
  url: Maybe<Scalars['String']['output']>;
};

/** Source: https://github.com/fiverr/seller_profile_chimera/blob/master/models/pro_seller/config/professional_presence_networks.yml */
export enum ProfessionalPresencePlatform {
  Audioboom = 'AUDIOBOOM',
  Audiojungle = 'AUDIOJUNGLE',
  Bandcamp = 'BANDCAMP',
  Behance = 'BEHANCE',
  Blogger = 'BLOGGER',
  Buzzfeed = 'BUZZFEED',
  Carbonmade = 'CARBONMADE',
  Cargocollective = 'CARGOCOLLECTIVE',
  Codecanyon = 'CODECANYON',
  Coroflot = 'COROFLOT',
  Deviantart = 'DEVIANTART',
  Digg = 'DIGG',
  Dribbble = 'DRIBBBLE',
  Emaze = 'EMAZE',
  Flickr = 'FLICKR',
  Ghost = 'GHOST',
  Github = 'GITHUB',
  Houzz = 'HOUZZ',
  Istockphoto = 'ISTOCKPHOTO',
  Medium = 'MEDIUM',
  Mixcloud = 'MIXCLOUD',
  Musically = 'MUSICALLY',
  Myspace = 'MYSPACE',
  Periscope = 'PERISCOPE',
  Photodune = 'PHOTODUNE',
  Photoshelter = 'PHOTOSHELTER',
  Playbuzz = 'PLAYBUZZ',
  Prezi = 'PREZI',
  Px500 = 'PX500',
  Shutterstock = 'SHUTTERSTOCK',
  Skyrock = 'SKYROCK',
  Slidely = 'SLIDELY',
  Slideshare = 'SLIDESHARE',
  Soundcloud = 'SOUNDCLOUD',
  Stackexchange = 'STACKEXCHANGE',
  Stackoverflow = 'STACKOVERFLOW',
  Templatemonster = 'TEMPLATEMONSTER',
  Themeforest = 'THEMEFOREST',
  Tumblr = 'TUMBLR',
  Videohive = 'VIDEOHIVE',
  Vimeo = 'VIMEO',
  Vine = 'VINE',
  Wordpress = 'WORDPRESS',
  Youtube = 'YOUTUBE'
}

export type ProficientLanguage = {
  code: LanguageCode;
  level: LanguageProficiencyLevel;
};

export type ProfileCompletion = {
  buyingExperiencePercentage: Maybe<Scalars['Int']['output']>;
  communicationPreferencesPercentage: Scalars['Int']['output'];
  goalsPercentage: Scalars['Int']['output'];
  percentage: Scalars['Int']['output'];
  profileDetailsPercentage: Maybe<Scalars['Int']['output']>;
};

export type ProgramTransitionAvailability = {
  isAvailable: Scalars['Boolean']['output'];
};

export type Project = Node & {
  /** Optional project brief */
  brief: Maybe<Scalars['String']['output']>;
  /** Collection of business member who made any orders in this project */
  businessBuyers: Array<BusinessMember>;
  /** The project context id value */
  contextId: Scalars['String']['output'];
  /** The project context type */
  contextType: Scalars['String']['output'];
  /** Optional project description */
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The project name specified when created */
  name: Scalars['String']['output'];
  /** Create date of a project */
  openedAt: Scalars['Timestamp']['output'];
  /** Provides project orders that match specified filter */
  orders: OrderConnection;
  /** Collection of project members */
  projectMembers: Array<BusinessProjectMember>;
  /** Selected categories with metadata questions selected on business project creation */
  selectedCategories: Array<BusinessProjectSelectedCategory>;
  /** Project status */
  status: ProjectStatus;
  /** Actual project type enumeration */
  type: ProjectType;
  /** Update date of a project */
  updatedAt: Scalars['Timestamp']['output'];
};


export type ProjectOrdersArgs = {
  after: InputMaybe<Scalars['ID']['input']>;
  filter: InputMaybe<ProjectOrdersFilters>;
  first: Scalars['Int']['input'];
  sorting: InputMaybe<ProjectOrderSorting>;
};

export type ProjectConnection = Connection & {
  /** A list of edges */
  edges: Array<ProjectEdge>;
  /** Collection of projects */
  nodes: Array<Project>;
  /** Pagination information */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection */
  totalCount: Scalars['Int']['output'];
};

export enum ProjectDuration {
  OneToSevenDays = 'ONE_TO_SEVEN_DAYS',
  OneToThreeMonths = 'ONE_TO_THREE_MONTHS',
  SevenToThirtyDays = 'SEVEN_TO_THIRTY_DAYS',
  SixPlusMonths = 'SIX_PLUS_MONTHS',
  ThreeToSixMonths = 'THREE_TO_SIX_MONTHS'
}

export type ProjectEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Project;
};

export type ProjectGoal = Goal & {
  alias: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentBusinessGoals: Array<BusinessGoal>;
  requirementId: Maybe<Scalars['String']['output']>;
  services: Array<ProjectService>;
  shortDescription: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProjectGoalOptions = {
  main: Array<ProjectGoal>;
  orderId: Scalars['ID']['output'];
  other: Array<ProjectGoal>;
  subCategoryId: Maybe<Scalars['Int']['output']>;
};

export enum ProjectMembershipFilter {
  Member = 'MEMBER',
  VisibleNonMember = 'VISIBLE_NON_MEMBER'
}

export type ProjectOrderSorting = {
  sortBy: ProjectOrdersSortBy;
  sortOrder: SortOrder;
};

export type ProjectOrdersFilters = {
  buyerIds: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt: InputMaybe<DateQuery>;
  statuses: InputMaybe<Array<OrderStatusInput>>;
};

export enum ProjectOrdersSortBy {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

/** Privilege types */
export enum ProjectPrivilegeFilter {
  /**  Projects which the user can join */
  BusinessProjectJoin = 'BUSINESS_PROJECT_JOIN',
  /**  Projects which the user can view their details */
  BusinessProjectView = 'BUSINESS_PROJECT_VIEW',
  /**  Private/personal projects which the user can view listed (see limited details) */
  OrganizationViewPrivateProjectsList = 'ORGANIZATION_VIEW_PRIVATE_PROJECTS_LIST',
  /**  Public projects which the user can view listed (with limited details) */
  OrganizationViewPublicProjectsList = 'ORGANIZATION_VIEW_PUBLIC_PROJECTS_LIST'
}

export type ProjectService = {
  cardMediaUrl: Maybe<Scalars['URI']['output']>;
  category: GigCategory;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  shortDescription: Scalars['String']['output'];
};

export type ProjectSorting = {
  sortBy: ProjectsSortBy;
  sortOrder: SortOrder;
};

export enum ProjectSourceFilter {
  All = 'ALL',
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

export enum ProjectStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Deleted = 'DELETED'
}

export enum ProjectStatusFilter {
  All = 'ALL',
  PublicVisible = 'PUBLIC_VISIBLE'
}

export enum ProjectStatusInput {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export enum ProjectType {
  Personal = 'PERSONAL',
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type ProjectsFilters = {
  isMember: InputMaybe<Scalars['Boolean']['input']>;
  privileges: InputMaybe<Array<ProjectPrivilegeFilter>>;
  /** Filter by project statuses */
  statuses: InputMaybe<Array<ProjectStatus>>;
  types: InputMaybe<Array<ProjectType>>;
};

export enum ProjectsSortBy {
  Name = 'NAME',
  RecentlyCreated = 'RECENTLY_CREATED',
  RecentlyUpdated = 'RECENTLY_UPDATED',
  RecentlyViewed = 'RECENTLY_VIEWED'
}

export enum PromoCodeStatus {
  Claimed = 'CLAIMED',
  Expired = 'EXPIRED',
  Invalid = 'INVALID',
  Other = 'OTHER',
  Valid = 'VALID'
}

export type Promotion = {
  discountPercentage: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Minimum order (payment) amount in USD for promotion to be applied */
  minOrderAmount: Scalars['MoneyAmount']['output'];
  name: Scalars['String']['output'];
  selectedGigs: Array<Gig>;
  status: PromotionStatus;
  timeRange: PromotionTimeRange;
  usageAmount: Scalars['Int']['output'];
};

export type PromotionConnection = {
  edges: Maybe<Array<PromotionEdge>>;
  nodes: Maybe<Array<Promotion>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PromotionEdge = {
  cursor: Scalars['String']['output'];
  node: Promotion;
};

export type PromotionGigInUse = {
  usedGigs: Array<Gig>;
};

export type PromotionInput = {
  discountPercentage: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  selectedGigsIds: Array<Scalars['String']['input']>;
  timeRange: PromotionTimeRangeInput;
};

export type PromotionInvalidInput = {
  type: PromotionInvalidInputType;
};

export enum PromotionInvalidInputType {
  EndDateBeforeStart = 'END_DATE_BEFORE_START',
  EndDateInThePast = 'END_DATE_IN_THE_PAST',
  InvalidDiscountPercentage = 'INVALID_DISCOUNT_PERCENTAGE',
  LongTimeRange = 'LONG_TIME_RANGE',
  NoGigSelected = 'NO_GIG_SELECTED',
  SellerIsNotEnrolledForPromotion = 'SELLER_IS_NOT_ENROLLED_FOR_PROMOTION',
  UnknownGigSelected = 'UNKNOWN_GIG_SELECTED'
}

export type PromotionQuota = {
  availableGigs: Scalars['Int']['output'];
  remaining: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  used: Scalars['Int']['output'];
};

export type PromotionQuotaReached = {
  maxPromotions: Maybe<Scalars['Int']['output']>;
};

export enum PromotionStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

export type PromotionTimeRange = {
  end: Scalars['Timestamp']['output'];
  start: Scalars['Timestamp']['output'];
};

export type PromotionTimeRangeInput = {
  end: Scalars['Timestamp']['input'];
  start: Scalars['Timestamp']['input'];
};

export type PromotionUsageQuota = {
  remaining: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  used: Scalars['Int']['output'];
};

export type PromotionUsageQuotaReached = {
  maxUsages: Maybe<Scalars['Int']['output']>;
};

export type Purchase = {
  billing: Billing;
  createdAt: Scalars['Timestamp']['output'];
  financialActivity: Maybe<FinancialActivity>;
  items: Array<Item>;
  type: PurchaseType;
  unitSerial: Scalars['Int']['output'];
};

export enum PurchaseType {
  ExtendedDuration = 'EXTENDED_DURATION',
  Tip = 'TIP',
  Unit = 'UNIT',
  Upsell = 'UPSELL'
}

/** queries.graphqls */
export type Query = {
  agenciesBySellerIds: Array<Agency>;
  agenciesBySlugs: Array<Agency>;
  /** For mobile app use only! */
  allocatedExperiments: Maybe<AllocatedExperiments>;
  /** Another query description */
  anotherQuery: Array<Scalars['String']['output']>;
  assetsSharingById: Maybe<AssetsSharing>;
  /** Fetch attachments by their IDs */
  attachmentsByIds: Array<AttachmentsByIdsResponseUnion>;
  /** Fetch attachments by their related objects */
  attachmentsByRelatedObjects: Array<AttachmentsByRelatedObjectsResponseUnion>;
  /** List of Briefs by Ids */
  briefsByIds: BriefConnection;
  /** Get business info by context ID and context type */
  businessInfo: Maybe<BusinessInfo>;
  /** Provides business organization for a given user */
  businessOrganizationOnContext: Maybe<BusinessOrganization>;
  businessOrganizationsByIds: Array<BusinessOrganization>;
  /** Provides a business projects details by ids max amount projectIds to request 10 */
  businessProjectsByIdsOnContext: Array<BusinessProject>;
  buyersByIds: Maybe<Array<Buyer>>;
  buyersByUsernames: Maybe<Array<Buyer>>;
  catalogCategories: Array<CatalogCategory>;
  /** Find a paginated connection of certified testimonials by a search criteria */
  certifiedTestimonials: CertifiedTestimonialConnection;
  /** Find a list of certified testimonials by IDs */
  certifiedTestimonialsByIds: Array<CertifiedTestimonial>;
  collectionBySlug: Maybe<Collection>;
  /** Look up a list of collections by owner */
  collections: CollectionConnection;
  /** Get count of collections by resource id */
  collectionsCountByResourceId: Maybe<Scalars['Int']['output']>;
  /** Dummy query - do not use */
  companyProfiledDummyQuery: Maybe<CompanyProfile>;
  /** For mobile app use only! Look up a list of conversations */
  conversations: ConversationConnection;
  countSearchOrders: Scalars['Int']['output'];
  /** For mobile app use only! */
  currentUser: CurrentUser;
  /** List of CustomOffers by custom package ids */
  customOffersByCustomPackageIds: Maybe<Array<CustomOffer>>;
  /** List of CustomOffers by ids */
  customOffersByIds: Maybe<Array<CustomOffer>>;
  customPackagesByIds: Array<CustomPackage>;
  /** List of Dynamic Matching Briefs by Context */
  dmBriefsByContext: DmBriefConnection;
  /** List of Dynamic Matching Briefs by Ids */
  dmBriefsByIds: Array<DmBrief>;
  /** List of Dynamic Matching Brief Match Candidates */
  dmMatchCandidatesByIds: Array<DmMatchCandidate>;
  /** List of Dynamic Matching Brief Match Candidates */
  dmMatchCandidatesBySellerId: DmMatchCandidateConnection;
  /** Dummy query - do not use */
  dummySellerWorkExperienceQuery: Maybe<Seller>;
  /** @deprecated For EOY campaign use only! */
  eoyUser: EoyUser;
  /** List of Orders search */
  externalSearchOrders: OrderConnection;
  findAllLoyaltyProgramStatus: LoyaltyProgramStatusConnection;
  findAllPointsEvent: PointsEventConnection;
  findAllRewardedAction: RewardedActionConnection;
  findAllUsedBenefit: UsedBenefitConnection;
  /** Get dynamic matching custom offers by related brief id */
  findDMCustomOffersByBriefId: CustomOfferConnection;
  /** Get dynamic matching custom offers by seller id  */
  findDMCustomOffersBySellerId: Maybe<CustomOfferConnection>;
  findLoyaltyProgramStatusById: Maybe<LoyaltyProgramStatus>;
  findLoyaltyProgramStatusByTeamIds: LoyaltyProgramStatusConnection;
  findLoyaltyProgramStatusByUserIds: LoyaltyProgramStatusConnection;
  findPointsEventById: Maybe<PointsEvent>;
  findPointsEventByTeamIds: PointsEventConnection;
  findPointsEventByUserIds: PointsEventConnection;
  findPointsEventsByOrganization: PointsEventConnection;
  findPointsRedemptions: Array<PointsRedemption>;
  findRewardedActionById: Maybe<RewardedAction>;
  findRewardedActionByTeamIds: RewardedActionConnection;
  findRewardedActionByUserIds: RewardedActionConnection;
  findRewardedActionForHourlyUnit: Maybe<RewardedAction>;
  findRewardedActionsByExternalIds: RewardedActionConnection;
  findTotalPointsEarnedByParentId: Maybe<TotalPointsEarnedByParentId>;
  findUsedBenefitById: Maybe<UsedBenefit>;
  findUsedBenefitByTeamIds: UsedBenefitConnection;
  findUsedBenefitByUserIds: UsedBenefitConnection;
  getBackgroundCheckByOrganizationRequsteeIdAndRequester: Maybe<Array<ExtendedBackgroundCheck>>;
  getBackgroundChecksByRequesterAndRequesteeIds: Maybe<Array<BackgroundCheck>>;
  getBackgroundChecksByRequesterId: Maybe<Array<BackgroundCheck>>;
  getBuyerEngagementBadge: Maybe<EngagementBadgeInfo>;
  getContentPageDataValue: ContentPageData;
  getDataModelById: DataModel;
  getDataModelByQuery: DataModelList;
  getDataModelBySlug: DataModel;
  /** Get duplicate brief data for creating a copy */
  getDuplicateBriefData: BriefData;
  getExpertSourcingReportById: Maybe<ExpertSourcingReport>;
  getExpertSourcingReportDataByRequestId: Maybe<ExpertSourcingReportData>;
  getExpertSourcingReportsByDomainExpert: ExpertSourcingReportConnection;
  getExpertSourcingRequests: ExpertSourcingRequestConnection;
  getExpertSourcingRequestsByBuyerId: ExpertSourcingRequestConnection;
  getLoyaltyInfo: Maybe<LoyaltyInfo>;
  getPartnersCouponBenefit: Maybe<PartnersCouponBenefit>;
  getTeamMembersInvitations: Array<TeamMemberInvitation>;
  getTiersThresholds: TiersThresholds;
  getWorkforceClassificationByRequesterAndRequesteeIds: Maybe<Array<ExtendedWorkforceClassification>>;
  getWorkforceClassificationByRequesterId: Maybe<Array<ExtendedWorkforceClassification>>;
  getWorkforceClassificationByRequesterIdAndRequesteeIdAndOrganizationId: Maybe<Array<ExtendedWorkforceClassification>>;
  /** Gig by id and package id - only for payment flow */
  gigForPayment: Gig;
  /** List of gigs by ids */
  gigs: Maybe<Array<Gig>>;
  gigsActiveOrdersInQueue: Scalars['Int']['output'];
  /** @deprecated Added for DQA purposes */
  gigsByIdsDqa: Array<Gig>;
  /** Get a list of gigs quality scores by Gigs IDs. */
  gigsQualityScores: Array<Gig>;
  gigsUserIdAndSlug: Array<Gig>;
  /** Get growth tasks for the current user */
  growthTasks: GrowthTaskConnection;
  /** Query for fetching CMS industries tree. */
  industriesTree: Array<IndustryTreeNode>;
  /**
   * Provides a list of only curated and public deliveries.
   * Pagination spec: https://relay.dev/graphql/connections.htm#sec-Forward-pagination-arguments
   */
  inspireDeliveries: InspireDeliveryConnection;
  /** Provides deliveries by IDs. */
  inspireDeliveriesByIds: Array<InspireDelivery>;
  /** Fetches DeliveryRefinement state by origin and InspireDelivery ID. */
  inspireDeliveryRefinement: InspireDeliveryRefinement;
  /**
   * Provides a list of SCs with image urls, where each id listed should have at least one
   * curated and public delivery in that subcategory.
   */
  inspireDeliverySubcategories: Maybe<Array<GigSubCategory>>;
  /**
   * Provides a list of SC ids, where each id listed should have at least one
   * curated and public delivery in that subcategory. Deprecated: use inspireDeliverySubcategories query instead.
   */
  inspireDeliverySubcategoryIds: Array<Scalars['ID']['output']>;
  /** Query for fetching CMS goal buckets containg other buckets or leaf goals. */
  inspireGoalBuckets: Array<BucketGoal>;
  /** Query for fetching CMS goals. */
  inspireGoals: Array<Goal>;
  kickstart: Maybe<Kickstart>;
  lastUserProjectGoal: Maybe<UserProjectGoal>;
  /**
   * Query for fetching CMS Logo-maker industries tree.
   * @deprecated Use industriesTree instead
   */
  logoMakerIndustriesTree: Array<IndustryTreeNode>;
  meetingInvitation: MeetingInvitation;
  /** For mobile app use only! */
  mobileCounters: MobileCounters;
  mobileOrderFacets: Array<OrderStatusFacet>;
  /** For mobile app use only! */
  mobileSettings: Maybe<MobileSettings>;
  /**
   * For mobile app use only!
   * @deprecated For mobile app use only!
   */
  orderFacets: OrderFacets;
  orderRequirements: Maybe<TaggingOrderRequirements>;
  orderStatusesFacets: OrderStatusesFacets;
  /**
   * For mobile app use only! Look up a list of orders
   * @deprecated This query is for mobile-app only and should be deprecated. Please don't use it
   */
  orders: OrderConnection;
  /** List of Orders By Ids */
  ordersByEncryptedIds: OrderConnection;
  /** List of Orders By Ids */
  ordersByIds: OrderConnection;
  organizationMembersByIds: Array<BusinessMember>;
  organizationMembersByOrganizationId: Array<BusinessMember>;
  ownedCollectionBySlug: Maybe<Collection>;
  projectGoalById: Maybe<ProjectGoal>;
  projectGoals: Array<ProjectGoal>;
  /** Provides projects that match specified filter for the context user */
  projects: ProjectConnection;
  /** Returns projects list with specified identifiers */
  projectsByIds: Array<Project>;
  /** For mobile app use only! Get array of logged-in user/guest recently viewed gigs */
  recentlyViewedGigs: Maybe<RecentlyViewedGigs>;
  /** For mobile app use only! Get array of recommended gigs by gigId */
  recommendedGigsByContent: Maybe<RecommendedGigsByContent>;
  reportsByIds: ReportsSummary;
  /** Get resources for the current user */
  resources: ResourceConnection;
  /** List of Orders search */
  searchOrders: OrderConnection;
  /** Search for clients associated with the team account that current user belongs to */
  searchTeamAccountsClients: TeamAccountClientsConnection;
  searchTeamMembershipsByUserIdAndTeamId: Array<TeamMember>;
  sellerEligibleOptionsForCustomOffer: OptionsForCustomOffer;
  /** List of CustomOffers by userId */
  sellerEligibleOptionsForCustomOfferByUserId: OptionsForCustomOffer;
  sellerPlus: Maybe<SellerPlus>;
  sellerProgramCategories: Array<SellerProgramCategoryMetadata>;
  sellerProgramEnrollments: Array<SellerEnrolledProgram>;
  /** Fetches a list of seller roles by their IDs. */
  sellerRolesByIds: Array<SellerRole>;
  /** Look up a list of sellers */
  sellersByIds: Array<Seller>;
  sellersByUsernames: Array<Seller>;
  sellersDataByIds: Array<Seller>;
  sellersDataByUsernames: Array<Seller>;
  /** Fetches a list of sellers embed by their IDs. */
  sellersEmbedByIds: Array<Seller>;
  /** Get a list of sellers by Seller IDs. */
  sellersQualityByIds: Array<Seller>;
  /** Fetches a list of sellers by their IDs with all their seller roles. */
  sellersWithSellerRolesByIds: Array<Seller>;
  /** Fetches a list of sellers by their usernames with all their seller roles. */
  sellersWithSellerRolesByUsername: Array<Seller>;
  serviceTree: Array<ServiceTreeNode>;
  /** Query description */
  someQuery: Array<Scalars['String']['output']>;
  stub: Maybe<Buyer>;
  /**
   * Query for fetching Zubin category metadata structure used for Inspire.
   * Returns only nested SC metadata values if NSC is provided in input and if it's defined on Zubin side.
   */
  subcategoryMetadata: Array<CategoryMetadata>;
  teamAccountClientsByIds: Array<TeamAccountClient>;
  teamAccountClientsByUserIds: Array<TeamAccountClient>;
  teamAccountsBySlugs: Array<TeamAccount>;
  trendingDeliveries: Array<InspireDelivery>;
  trendingSubcategoriesByTimeInterval: Array<IntervalTrendingEntry>;
  userProjectGoalById: Maybe<UserProjectGoal>;
};


/** queries.graphqls */
export type QueryAgenciesBySellerIdsArgs = {
  sellerIds: Array<Scalars['ID']['input']>;
};


/** queries.graphqls */
export type QueryAgenciesBySlugsArgs = {
  agencySlugs: Array<Scalars['String']['input']>;
};


/** queries.graphqls */
export type QueryAnotherQueryArgs = {
  isTrue: Scalars['Boolean']['input'];
};


/** queries.graphqls */
export type QueryAssetsSharingByIdArgs = {
  id: Scalars['ID']['input'];
};


/** queries.graphqls */
export type QueryAttachmentsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** queries.graphqls */
export type QueryAttachmentsByRelatedObjectsArgs = {
  relatedObjects: Array<RelatedObjectInput>;
};


/** queries.graphqls */
export type QueryBriefsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** queries.graphqls */
export type QueryBusinessInfoArgs = {
  contextId: Scalars['ID']['input'];
  contextType: BusinessContextType;
};


/** queries.graphqls */
export type QueryBusinessOrganizationsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** queries.graphqls */
export type QueryBusinessProjectsByIdsOnContextArgs = {
  projectIds: Array<Scalars['ID']['input']>;
};


/** queries.graphqls */
export type QueryBuyersByIdsArgs = {
  ids: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** queries.graphqls */
export type QueryBuyersByUsernamesArgs = {
  usernames: InputMaybe<Array<Scalars['String']['input']>>;
};


/** queries.graphqls */
export type QueryCatalogCategoriesArgs = {
  categoryIds: Array<Scalars['Int']['input']>;
};


/** queries.graphqls */
export type QueryCertifiedTestimonialsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<CertifiedTestimonialsFilter>;
  first?: Scalars['Int']['input'];
};


/** queries.graphqls */
export type QueryCertifiedTestimonialsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** queries.graphqls */
export type QueryCollectionBySlugArgs = {
  slug: Scalars['String']['input'];
  username: InputMaybe<Scalars['String']['input']>;
};


/** queries.graphqls */
export type QueryCollectionsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ownerType?: InputMaybe<OwnerType>;
  ownerTypes: InputMaybe<Array<OwnerType>>;
  sorting?: InputMaybe<CollectionSorting>;
};


/** queries.graphqls */
export type QueryCollectionsCountByResourceIdArgs = {
  resourceId: Scalars['String']['input'];
};


/** queries.graphqls */
export type QueryConversationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ConversationType>;
};


/** queries.graphqls */
export type QueryCountSearchOrdersArgs = {
  searchParams: InputMaybe<OrderSearchRequest>;
};


/** queries.graphqls */
export type QueryCustomOffersByCustomPackageIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** queries.graphqls */
export type QueryCustomOffersByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** queries.graphqls */
export type QueryCustomPackagesByIdsArgs = {
  customPackageIds: Array<Scalars['String']['input']>;
};


/** queries.graphqls */
export type QueryDmBriefsByContextArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  contextId: Scalars['String']['input'];
  contextType: BriefContextType;
  first: Scalars['Int']['input'];
  statuses: InputMaybe<Array<DmBriefStatus>>;
};


/** queries.graphqls */
export type QueryDmBriefsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** queries.graphqls */
export type QueryDmMatchCandidatesByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** queries.graphqls */
export type QueryDmMatchCandidatesBySellerIdArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  createdAfterDaysAgo: InputMaybe<Scalars['Int']['input']>;
  first: Scalars['Int']['input'];
  sellerId: Scalars['ID']['input'];
  statuses: InputMaybe<Array<DmMatchCandidateStatus>>;
};


/** queries.graphqls */
export type QueryEoyUserArgs = {
  id: InputMaybe<Scalars['ID']['input']>;
  username: InputMaybe<Scalars['String']['input']>;
};


/** queries.graphqls */
export type QueryExternalSearchOrdersArgs = {
  pagination: InputMaybe<Pagination>;
  searchParams: InputMaybe<OrderSearchRequest>;
  sorting: InputMaybe<Sorting>;
  unitSearchParams: InputMaybe<OrderUnitSearchParams>;
};


/** queries.graphqls */
export type QueryFindAllLoyaltyProgramStatusArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
};


/** queries.graphqls */
export type QueryFindAllPointsEventArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
};


/** queries.graphqls */
export type QueryFindAllRewardedActionArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
};


/** queries.graphqls */
export type QueryFindAllUsedBenefitArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
};


/** queries.graphqls */
export type QueryFindDmCustomOffersByBriefIdArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  statuses: InputMaybe<Array<CustomOfferStatus>>;
};


/** queries.graphqls */
export type QueryFindDmCustomOffersBySellerIdArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  sellerId: Scalars['String']['input'];
  statuses: InputMaybe<Array<CustomOfferStatus>>;
};


/** queries.graphqls */
export type QueryFindLoyaltyProgramStatusByIdArgs = {
  id: Scalars['ID']['input'];
};


/** queries.graphqls */
export type QueryFindLoyaltyProgramStatusByTeamIdsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  teamIds: Array<Scalars['String']['input']>;
};


/** queries.graphqls */
export type QueryFindLoyaltyProgramStatusByUserIdsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  userIds: Array<Scalars['Int']['input']>;
};


/** queries.graphqls */
export type QueryFindPointsEventByIdArgs = {
  id: Scalars['ID']['input'];
};


/** queries.graphqls */
export type QueryFindPointsEventByTeamIdsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  teamIds: Array<Scalars['String']['input']>;
};


/** queries.graphqls */
export type QueryFindPointsEventByUserIdsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  userIds: Array<Scalars['Int']['input']>;
};


/** queries.graphqls */
export type QueryFindPointsEventsByOrganizationArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
};


/** queries.graphqls */
export type QueryFindPointsRedemptionsArgs = {
  externalId: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<PointsRedemptionStatus>>;
  type: InputMaybe<Array<PointsRedeemReferenceType>>;
};


/** queries.graphqls */
export type QueryFindRewardedActionByIdArgs = {
  id: Scalars['ID']['input'];
};


/** queries.graphqls */
export type QueryFindRewardedActionByTeamIdsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  teamIds: Array<Scalars['String']['input']>;
};


/** queries.graphqls */
export type QueryFindRewardedActionByUserIdsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  userIds: Array<Scalars['Int']['input']>;
};


/** queries.graphqls */
export type QueryFindRewardedActionForHourlyUnitArgs = {
  orderId: Scalars['Float']['input'];
  orderUnitSerial: Scalars['Float']['input'];
};


/** queries.graphqls */
export type QueryFindRewardedActionsByExternalIdsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  externalIds: Array<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
};


/** queries.graphqls */
export type QueryFindTotalPointsEarnedByParentIdArgs = {
  parentId: Scalars['Float']['input'];
};


/** queries.graphqls */
export type QueryFindUsedBenefitByIdArgs = {
  id: Scalars['ID']['input'];
};


/** queries.graphqls */
export type QueryFindUsedBenefitByTeamIdsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  teamIds: Array<Scalars['String']['input']>;
};


/** queries.graphqls */
export type QueryFindUsedBenefitByUserIdsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  userIds: Array<Scalars['Int']['input']>;
};


/** queries.graphqls */
export type QueryGetBackgroundCheckByOrganizationRequsteeIdAndRequesterArgs = {
  organizationId: InputMaybe<Scalars['String']['input']>;
  requesteeId: InputMaybe<Scalars['Float']['input']>;
  requesterId: InputMaybe<Scalars['Float']['input']>;
};


/** queries.graphqls */
export type QueryGetBackgroundChecksByRequesterAndRequesteeIdsArgs = {
  requesteeId: Scalars['Float']['input'];
  requesterId: Scalars['Float']['input'];
};


/** queries.graphqls */
export type QueryGetBackgroundChecksByRequesterIdArgs = {
  requesterId: Scalars['Float']['input'];
};


/** queries.graphqls */
export type QueryGetBuyerEngagementBadgeArgs = {
  teamId: Scalars['String']['input'];
};


/** queries.graphqls */
export type QueryGetContentPageDataValueArgs = {
  hashKey: Scalars['String']['input'];
  pageSlug: Scalars['String']['input'];
};


/** queries.graphqls */
export type QueryGetDataModelByIdArgs = {
  builderModel: Scalars['String']['input'];
  fields: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  locale?: Scalars['String']['input'];
  noCache: InputMaybe<Scalars['Boolean']['input']>;
};


/** queries.graphqls */
export type QueryGetDataModelByQueryArgs = {
  builderModel: Scalars['String']['input'];
  fields: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  locale?: Scalars['String']['input'];
  noCache: InputMaybe<Scalars['Boolean']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  queryField: Scalars['String']['input'];
  queryFieldValue: Scalars['String']['input'];
};


/** queries.graphqls */
export type QueryGetDataModelBySlugArgs = {
  builderModel: Scalars['String']['input'];
  fields: InputMaybe<Scalars['String']['input']>;
  locale?: Scalars['String']['input'];
  noCache: InputMaybe<Scalars['Boolean']['input']>;
  slug: Scalars['String']['input'];
};


/** queries.graphqls */
export type QueryGetDuplicateBriefDataArgs = {
  id: Scalars['ID']['input'];
};


/** queries.graphqls */
export type QueryGetExpertSourcingReportByIdArgs = {
  id: Scalars['String']['input'];
};


/** queries.graphqls */
export type QueryGetExpertSourcingReportDataByRequestIdArgs = {
  requestId: Scalars['String']['input'];
};


/** queries.graphqls */
export type QueryGetExpertSourcingReportsByDomainExpertArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  mail: Scalars['String']['input'];
};


/** queries.graphqls */
export type QueryGetExpertSourcingRequestsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  statuses: InputMaybe<Array<ExpertSourcingRequestStatus>>;
};


/** queries.graphqls */
export type QueryGetExpertSourcingRequestsByBuyerIdArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  buyerId: Scalars['Int']['input'];
  first: InputMaybe<Scalars['Int']['input']>;
  statuses: InputMaybe<Array<ExpertSourcingRequestStatus>>;
};


/** queries.graphqls */
export type QueryGetLoyaltyInfoArgs = {
  organizationId: Scalars['String']['input'];
};


/** queries.graphqls */
export type QueryGetWorkforceClassificationByRequesterAndRequesteeIdsArgs = {
  requesteeId: Scalars['Float']['input'];
  requesterId: Scalars['Float']['input'];
};


/** queries.graphqls */
export type QueryGetWorkforceClassificationByRequesterIdArgs = {
  requesterId: Scalars['Float']['input'];
};


/** queries.graphqls */
export type QueryGetWorkforceClassificationByRequesterIdAndRequesteeIdAndOrganizationIdArgs = {
  organizationId: InputMaybe<Scalars['String']['input']>;
  requesteeId: InputMaybe<Scalars['Float']['input']>;
  requesterId: InputMaybe<Scalars['Float']['input']>;
};


/** queries.graphqls */
export type QueryGigForPaymentArgs = {
  id: Scalars['ID']['input'];
};


/** queries.graphqls */
export type QueryGigsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** queries.graphqls */
export type QueryGigsActiveOrdersInQueueArgs = {
  gigId: Scalars['Int']['input'];
};


/** queries.graphqls */
export type QueryGigsByIdsDqaArgs = {
  gigIds: Array<Scalars['Int']['input']>;
};


/** queries.graphqls */
export type QueryGigsQualityScoresArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** queries.graphqls */
export type QueryGigsUserIdAndSlugArgs = {
  slug: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


/** queries.graphqls */
export type QueryGrowthTasksArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  filters: InputMaybe<GrowthTaskFilters>;
  first?: Scalars['Int']['input'];
};


/** queries.graphqls */
export type QueryIndustriesTreeArgs = {
  locale: InputMaybe<Locale>;
};


/** queries.graphqls */
export type QueryInspireDeliveriesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  filters: InputMaybe<InspireDeliveryFilter>;
  filtrationAlgorithm: InputMaybe<DeliveriesFiltrationAlgorithm>;
  first: InputMaybe<Scalars['Int']['input']>;
  seed: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
};


/** queries.graphqls */
export type QueryInspireDeliveriesByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** queries.graphqls */
export type QueryInspireDeliveryRefinementArgs = {
  id: Scalars['ID']['input'];
  origin: InspireDeliveryRefinementOrigin;
};


/** queries.graphqls */
export type QueryInspireDeliverySubcategoriesArgs = {
  filters: InputMaybe<SubcategoryFilter>;
};


/** queries.graphqls */
export type QueryInspireDeliverySubcategoryIdsArgs = {
  filters: InputMaybe<SubcategoryFilter>;
};


/** queries.graphqls */
export type QueryInspireGoalBucketsArgs = {
  filters: InputMaybe<GoalsFilter>;
};


/** queries.graphqls */
export type QueryInspireGoalsArgs = {
  excludeFilters: InputMaybe<GoalsFilter>;
  filters: InputMaybe<GoalsFilter>;
  includeBuckets: InputMaybe<Scalars['Boolean']['input']>;
};


/** queries.graphqls */
export type QueryLogoMakerIndustriesTreeArgs = {
  locale: InputMaybe<Locale>;
};


/** queries.graphqls */
export type QueryMeetingInvitationArgs = {
  id: Scalars['String']['input'];
};


/** queries.graphqls */
export type QueryOrderFacetsArgs = {
  businessMembers?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** queries.graphqls */
export type QueryOrderRequirementsArgs = {
  orderId: Scalars['ID']['input'];
};


/** queries.graphqls */
export type QueryOrderStatusesFacetsArgs = {
  statuses?: InputMaybe<Array<OrderStatusInput>>;
};


/** queries.graphqls */
export type QueryOrdersArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  buyers?: InputMaybe<Array<Scalars['String']['input']>>;
  filter?: InputMaybe<OrdersStatusFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sellers?: InputMaybe<Array<Scalars['String']['input']>>;
  sortBy?: InputMaybe<OrdersSortBy>;
  sortOrder: InputMaybe<SortOrder>;
  type?: InputMaybe<OrdersViewerType>;
};


/** queries.graphqls */
export type QueryOrdersByEncryptedIdsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  encryptedIds: Array<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  unitSearchParams: InputMaybe<OrderUnitSearchParams>;
};


/** queries.graphqls */
export type QueryOrdersByIdsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  unitSearchParams: InputMaybe<OrderUnitSearchParams>;
};


/** queries.graphqls */
export type QueryOrganizationMembersByIdsArgs = {
  memberIds: Array<Scalars['ID']['input']>;
};


/** queries.graphqls */
export type QueryOrganizationMembersByOrganizationIdArgs = {
  organizationId: Scalars['ID']['input'];
  status: InputMaybe<Scalars['String']['input']>;
};


/** queries.graphqls */
export type QueryOwnedCollectionBySlugArgs = {
  slug: Scalars['String']['input'];
};


/** queries.graphqls */
export type QueryProjectGoalByIdArgs = {
  id: Scalars['ID']['input'];
  locale: InputMaybe<Locale>;
};


/** queries.graphqls */
export type QueryProjectGoalsArgs = {
  excludeFilters: InputMaybe<GoalsFilter>;
  filters: InputMaybe<GoalsFilter>;
  locale: InputMaybe<Locale>;
};


/** queries.graphqls */
export type QueryProjectsArgs = {
  after: InputMaybe<Scalars['ID']['input']>;
  filter: InputMaybe<ProjectsFilters>;
  first: Scalars['Int']['input'];
  locale: InputMaybe<Locale>;
  sorting: InputMaybe<ProjectSorting>;
};


/** queries.graphqls */
export type QueryProjectsByIdsArgs = {
  locale: InputMaybe<Locale>;
  projectIds: Array<Scalars['ID']['input']>;
};


/** queries.graphqls */
export type QueryRecentlyViewedGigsArgs = {
  limit?: Scalars['Int']['input'];
};


/** queries.graphqls */
export type QueryRecommendedGigsByContentArgs = {
  gigId: Scalars['Int']['input'];
  limit?: Scalars['Int']['input'];
};


/** queries.graphqls */
export type QueryReportsByIdsArgs = {
  reportIds: Array<Scalars['String']['input']>;
};


/** queries.graphqls */
export type QueryResourcesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
};


/** queries.graphqls */
export type QuerySearchOrdersArgs = {
  pagination: InputMaybe<Pagination>;
  searchParams: InputMaybe<OrderSearchRequest>;
  sorting: InputMaybe<Sorting>;
  unitSearchParams: InputMaybe<OrderUnitSearchParams>;
};


/** queries.graphqls */
export type QuerySearchTeamAccountsClientsArgs = {
  pagination: InputMaybe<PaginationInput>;
  searchParams: InputMaybe<SearchTeamAccountClientsInput>;
  sorting: InputMaybe<SortingInput>;
};


/** queries.graphqls */
export type QuerySearchTeamMembershipsByUserIdAndTeamIdArgs = {
  records: Array<SearchUserTeamMembershipInput>;
};


/** queries.graphqls */
export type QuerySellerEligibleOptionsForCustomOfferByUserIdArgs = {
  userId: Scalars['ID']['input'];
};


/** queries.graphqls */
export type QuerySellerProgramCategoriesArgs = {
  categories: InputMaybe<Array<SellerProgramCategory>>;
};


/** queries.graphqls */
export type QuerySellerProgramEnrollmentsArgs = {
  categories: InputMaybe<Array<SellerProgramCategory>>;
};


/** queries.graphqls */
export type QuerySellerRolesByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
  locale: InputMaybe<FiverrLocale>;
};


/** queries.graphqls */
export type QuerySellersByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** queries.graphqls */
export type QuerySellersByUsernamesArgs = {
  usernames: Array<Scalars['String']['input']>;
};


/** queries.graphqls */
export type QuerySellersDataByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** queries.graphqls */
export type QuerySellersDataByUsernamesArgs = {
  usernames: Array<Scalars['ID']['input']>;
};


/** queries.graphqls */
export type QuerySellersEmbedByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** queries.graphqls */
export type QuerySellersQualityByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** queries.graphqls */
export type QuerySellersWithSellerRolesByIdsArgs = {
  locale: InputMaybe<FiverrLocale>;
  sellerIds: Array<Scalars['ID']['input']>;
};


/** queries.graphqls */
export type QuerySellersWithSellerRolesByUsernameArgs = {
  locale: InputMaybe<FiverrLocale>;
  usernames: Array<Scalars['ID']['input']>;
};


/** queries.graphqls */
export type QuerySomeQueryArgs = {
  message: Scalars['String']['input'];
};


/** queries.graphqls */
export type QuerySubcategoryMetadataArgs = {
  nestedSubcategoryId: InputMaybe<Scalars['Int']['input']>;
  subcategoryId: Scalars['Int']['input'];
};


/** queries.graphqls */
export type QueryTeamAccountClientsByIdsArgs = {
  clientIds: Array<Scalars['ID']['input']>;
};


/** queries.graphqls */
export type QueryTeamAccountClientsByUserIdsArgs = {
  clientUserIds: Array<Scalars['ID']['input']>;
  teamId: InputMaybe<Scalars['String']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
};


/** queries.graphqls */
export type QueryTeamAccountsBySlugsArgs = {
  slugs: Array<Scalars['String']['input']>;
};


/** queries.graphqls */
export type QueryTrendingDeliveriesArgs = {
  filter: InputMaybe<TrendingDeliveriesFilter>;
};


/** queries.graphqls */
export type QueryTrendingSubcategoriesByTimeIntervalArgs = {
  filter: InputMaybe<TrendingSubCategoriesFilter>;
  interval: InputMaybe<Interval>;
};


/** queries.graphqls */
export type QueryUserProjectGoalByIdArgs = {
  id: Scalars['ID']['input'];
};

export type QuestionAnswerPair = {
  answer: Maybe<Scalars['String']['output']>;
  question: Scalars['String']['output'];
};

export type Rating = {
  score: Maybe<Scalars['Float']['output']>;
};

export type RatingComponent = {
  key: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  translation: Scalars['String']['output'];
};

export type RecentlyViewedGigs = {
  /** Array of recomemended gigs */
  recommendedGigs: Array<RecommendedGig>;
};

export type RecommendedGig = {
  /** The recommended gig object */
  gig: Gig;
};

export type RecommendedGigsByContent = {
  /** Array of recomemended gigs */
  recommendedGigs: Array<RecommendedGig>;
};

export type RecurringData = {
  currentSerial: Scalars['Int']['output'];
  discountPercentage: Scalars['Float']['output'];
  firstDiscountedSerial: Maybe<Scalars['Int']['output']>;
  numberOfCycles: Scalars['Int']['output'];
  repeatEveryAmount: Scalars['Int']['output'];
  repeatEveryTimeUnit: RepeatEveryTimeUnit;
};

export type Refund = {
  grossAmount: ExtendedMoney;
  serviceFee: ExtendedMoney;
  tax: ExtendedMoney;
};

/** IDs of regional eligibility groups corresponding to various legislation e.g. DSA */
export enum RegionalGroup {
  EuropeanUnionPrivateBuyer = 'EUROPEAN_UNION_PRIVATE_BUYER'
}

export type RelatedObject = {
  /** The id of the related object (e.g. message_id, gig_id, etc.) */
  id: Scalars['String']['output'];
  /** The type of the related object (e.g. message, gig, etc.) */
  type: Scalars['String']['output'];
};

export type RelatedObjectInput = {
  /** The id of the related object (e.g. message_id, gig_id, etc.) */
  id: Scalars['String']['input'];
  /** The type of the related object (e.g. message, gig, etc.) */
  type: Scalars['String']['input'];
};

export enum RepeatEveryTimeUnit {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type Report = Node & {
  attachmentCount: Maybe<Scalars['Int']['output']>;
  createdBy: Scalars['String']['output'];
  endDate: Scalars['Timestamp']['output'];
  estimatedPrice: ExtendedMoney;
  id: Scalars['ID']['output'];
  loyaltyRewards: Maybe<RewardedAction>;
  orderId: Scalars['String']['output'];
  orderUnitSerial: Maybe<Scalars['Int']['output']>;
  startDate: Scalars['Timestamp']['output'];
  state: ReportState;
  tasks: Array<Task>;
  tasksPaginated: TaskConnection;
  totalPaidMinutes: Maybe<Scalars['Int']['output']>;
  totalReportedMinutes: Scalars['Int']['output'];
};


export type ReportTasksPaginatedArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  taskSearchParams: InputMaybe<TaskSearchParams>;
};

export enum ReportState {
  ReportingDisabled = 'REPORTING_DISABLED',
  ReportingInProgress = 'REPORTING_IN_PROGRESS'
}

export type ReportsSummary = {
  /** A map of order IDs to lists of report details */
  nodes: Array<OrderReports>;
};

export type RequestCertifiedTestimonialClientInput = {
  company: InputMaybe<Scalars['String']['input']>;
  email: Scalars['Email']['input'];
  name: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

/**  Mutation Input Types */
export type RequestCertifiedTestimonialInput = {
  client: RequestCertifiedTestimonialClientInput;
  message: Scalars['String']['input'];
  project: RequestCertifiedTestimonialProjectInput;
};

export type RequestCertifiedTestimonialProjectInput = {
  date: Scalars['Timestamp']['input'];
  name: Scalars['String']['input'];
};

export type RequestPaymentData = {
  _id: Scalars['String']['output'];
  createdAt: Scalars['Timestamp']['output'];
  currency: Maybe<Scalars['String']['output']>;
  paymentMethod: Scalars['String']['output'];
  paymentStatus: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  updatedAt: Scalars['Timestamp']['output'];
};

export type Resource = {
  badges: Array<ResourceBadge>;
  createdAt: Scalars['Timestamp']['output'];
  durationSec: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  source: ResourceSource;
  templateId: Scalars['ID']['output'];
  thumbnail: Scalars['String']['output'];
  title: Scalars['String']['output'];
  /**  Template fields flattened */
  type: ResourceType;
  url: Scalars['String']['output'];
  user: User;
};

export enum ResourceBadge {
  Pro = 'PRO',
  SellerPlus = 'SELLER_PLUS',
  SellerPlusLocked = 'SELLER_PLUS_LOCKED'
}

export type ResourceConnection = {
  edges: Array<ResourceEdge>;
  nodes: Array<Resource>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ResourceEdge = {
  cursor: Scalars['String']['output'];
  node: Resource;
};

export type ResourceFilters = {
  type: InputMaybe<ResourceType>;
};

export enum ResourceSource {
  Csm = 'CSM',
  System = 'SYSTEM'
}

export enum ResourceType {
  Article = 'ARTICLE',
  Webinar = 'WEBINAR'
}

export enum RewardActionType {
  Deposit = 'DEPOSIT',
  Order = 'ORDER',
  Referral = 'REFERRAL'
}

export type RewardConfig = {
  conversionRate: Scalars['Float']['output'];
  maximumPoints: Maybe<Scalars['Float']['output']>;
  minimumPoints: Scalars['Float']['output'];
  roundConvertedValue: Maybe<RoundValue>;
  validLoyaltyPrograms: Array<LoyaltyProgramTier>;
};

export type RewardedAction = {
  actionDate: Maybe<Scalars['Timestamp']['output']>;
  actionId: Maybe<Scalars['String']['output']>;
  contextId: Maybe<Scalars['String']['output']>;
  contextType: Maybe<ContextType>;
  createdAt: Maybe<Scalars['Timestamp']['output']>;
  externalId: Maybe<Scalars['String']['output']>;
  hourlyUnitId: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  parentOrderId: Maybe<Scalars['Int']['output']>;
  rewards: Rewards;
  status: Maybe<RewardedActionStatus>;
  type: Maybe<RewardActionType>;
  userId: Maybe<Scalars['String']['output']>;
};

export type RewardedActionConnection = {
  edges: Maybe<Array<RewardedActionEdge>>;
  pageInfo: PageInfo;
  totalCount: Maybe<Scalars['Float']['output']>;
};

export type RewardedActionEdge = {
  cursor: Scalars['String']['output'];
  node: RewardedAction;
};

export enum RewardedActionStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED'
}

export type Rewards = {
  credit_rewards: Array<CreditReward>;
  points_rewards: Array<PointsReward>;
};

export enum RoleCatalogType {
  MetadataValue = 'METADATA_VALUE',
  Role = 'ROLE',
  Service = 'SERVICE'
}

export type RoleOptionForCustomOffer = {
  gig: CustomOfferGig;
  roleId: Scalars['String']['output'];
  roleName: Scalars['String']['output'];
};

export enum RoundValue {
  RoundDown = 'ROUND_DOWN'
}

export type SearchCmsEntry = {
  /** Cms entry object */
  cmsEntry: CmsEntry;
  /** The cms entry name (facebook, twitch etc.) */
  name: Scalars['String']['output'];
};

export type SearchTeamAccountClientsInput = {
  assignedTo: InputMaybe<Array<Scalars['ID']['input']>>;
  quickSearch: InputMaybe<Scalars['String']['input']>;
  statuses: InputMaybe<Array<TeamAccountClientSearchStatus>>;
  tags: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SearchUserTeamMembershipInput = {
  teamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type Seller = Node & {
  achievementLevel: Maybe<AchievementLevel>;
  /** The history of the seller's levels */
  achievementLogs: Array<AchievementLog>;
  /** Sellers active educations degrees */
  activeEducations: Array<SellerEducation>;
  activeStructuredSkills: Array<SellerStructuredSkill>;
  /** Agency associated with a seller */
  agency: Maybe<Agency>;
  /** Number of all approved seller's gigs (include certified gigs) */
  allApprovedGigsCount: Scalars['Int']['output'];
  /** Number of all seller's gigs */
  approvedGigsCount: Scalars['Int']['output'];
  /** Seller benefits are the benefits that a seller can get from being a certain level or having a certain vetting. */
  benefits: Maybe<SellerBenefits>;
  /** Sellers certifications */
  certifications: Array<SellerCertification>;
  /** Number of completed orders by seller */
  completedOrdersCount: Scalars['Int']['output'];
  consultations: SellerConsultations;
  /** List of completed courses (with pagination support) */
  courses: Maybe<CourseConnection>;
  /** Seller's self-description */
  description: Maybe<Scalars['String']['output']>;
  dmPreferences: Maybe<DmSellerPreferences>;
  embed: Maybe<EmbedPlatform>;
  /** metrics and quality metadata used in order to calculate seller level */
  evaluationMetricsMetadata: EvaluationMetricsMetadata;
  /** Unique set of seller's gig categories */
  gigCategories: Array<GigCategory>;
  gigs: GigConnection;
  /** If seller has loyalty score for any gig category */
  hasLoyaltyScores: Maybe<Scalars['Boolean']['output']>;
  /** If any of seller's gigs is rising talent */
  hasRisingTalentGigs: Maybe<Scalars['Boolean']['output']>;
  hourlyRate: Maybe<HourlyRate>;
  id: Scalars['ID']['output'];
  /** Seller's intro video */
  introVideo: Maybe<IntroVideo>;
  /** An indication if the Seller is an entry point to at least one AI Model. */
  isAI: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the seller is in active state on Fiverr */
  isActive: Scalars['Boolean']['output'];
  /** Indicates if the seller is highly responsive */
  isHighlyResponsive: Scalars['Boolean']['output'];
  /** Indicates if the seller is currently on active vacation */
  isOnVacation: Scalars['Boolean']['output'];
  /** Indicates if the seller is a vetted pro */
  isPro: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the seller identifies him self as an agency */
  isSelfIdentifiedAsAgency: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the seller in Seller Plus was verified by ID verification or manually by CSM */
  isVerified: Scalars['Boolean']['output'];
  kickstart: Maybe<Kickstart>;
  /** Min price of seller's gigs packages */
  minPackagePrice: Maybe<Money>;
  /** List of seller's notable clients */
  notableClients: Array<NotableClient>;
  /** Seller's expert title */
  oneLinerTitle: Maybe<Scalars['String']['output']>;
  onlinePresences: Array<OnlinePresence>;
  /** Team Account owned by the seller */
  ownedTeamAccount: Maybe<TeamAccount>;
  paginatedGigs: Maybe<GigConnection>;
  /** Seller's personal websites URLs */
  personalWebsites: Maybe<Array<Scalars['String']['output']>>;
  /**
   * List of portfolio items (with pagination support)
   * @deprecated Use portfolios instead
   */
  portfolio: Maybe<PortfolioProjectConnection>;
  portfolios: Maybe<SellerPortfolioProjectConnection>;
  /** Ids of the gig sub categories in which seller has pro badge */
  proSubCategories: Array<GigCategory>;
  professionalPresences: Array<ProfessionalPresence>;
  /** Background cover image of the seller's profile */
  profileBackgroundImage: Maybe<Attachment>;
  rating: Maybe<SellerRating>;
  /** IDs of regional groups where the seller is not eligible to operate */
  regionalGroupRestrictions: Array<RegionalGroup>;
  /** Seller's response time */
  responseTime: Maybe<Duration>;
  /** Seller's consultation scheduling settings */
  schedulingSettings: Maybe<SellerSchedulingSettings>;
  /** Seller's self-declared role */
  selfDeclaredRole: Maybe<Scalars['String']['output']>;
  /** List of AI Models that the Seller is an entry point of. */
  sellerAIModels: Maybe<Array<SellerAiModel>>;
  sellerLevel: Maybe<SellerLevel>;
  sellerPlus: Maybe<SellerPlus>;
  sellerProgramCategories: Array<SellerProgramCategoryMetadata>;
  sellerProgramEnrollments: Array<SellerEnrolledProgram>;
  /** Details about the seller relating to 'Seller Referrals' feature */
  sellerReferralsDetails: Maybe<SellerReferralsDetails>;
  /** An unordered list of roles that the seller has. */
  sellerRoles: Array<SellerRole>;
  softwareReselling: Maybe<Array<SoftwareReseller>>;
  /** Seller's status */
  status: Maybe<SellerStatus>;
  testimonials: Array<CertifiedTestimonial>;
  testimonialsEligible: Scalars['Boolean']['output'];
  user: User;
  /** Total review valuations */
  userBuyingReviews: Maybe<UserBuyingReviews>;
  /** Sellerֿֿ's vacation data */
  vacation: Maybe<Vacation>;
  workExperiences: WorkExperienceConnection;
};


export type SellerCoursesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
};


export type SellerGigsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
};


export type SellerPaginatedGigsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
};


export type SellerPortfolioArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
};


export type SellerPortfoliosArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  projectIds: InputMaybe<Array<Scalars['String']['input']>>;
  projectSourceFilter?: InputMaybe<ProjectSourceFilter>;
  projectStatusFilter?: InputMaybe<ProjectStatusFilter>;
  roleIds: InputMaybe<Array<Scalars['String']['input']>>;
  sellerRoleIds: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SellerSellerProgramCategoriesArgs = {
  categories: InputMaybe<Array<SellerProgramCategory>>;
};


export type SellerSellerProgramEnrollmentsArgs = {
  categories: InputMaybe<Array<SellerProgramCategory>>;
};


export type SellerTestimonialsArgs = {
  statuses: InputMaybe<Array<CertifiedTestimonialStatus>>;
};


export type SellerWorkExperiencesArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
};

export type SellerAiModel = {
  id: Scalars['ID']['output'];
};

/**
 * Represents a seller achievement criterion.
 * For example, a benefit can be granted to all levels starting from level two.
 * Also, a benefit can be granted to all levels starting from level one and having a certain vetting (like PRO).
 * Vetting can be null, which means that the benefit is granted to all sellers starting from the given level, regardless of their vetting.
 * excludeLevels is a list of levels that should be excluded from this criterion, even if they meet the fromLevel requirement.
 */
export type SellerBenefitAchievementCriterion = {
  excludeLevels: Maybe<Array<SellerLevel>>;
  fromLevel: Maybe<SellerLevel>;
  vetting: Maybe<SellerVetting>;
};

/**
 * Seller benefits are the benefits that a seller can get from being a certain level or having a certain vetting.
 * Each benefit is represented by a field in the SellerBenefits type.
 * A benefit can be numeric (e.g. number of gigs) or binary (e.g. seller plus standard).
 */
export type SellerBenefits = {
  aiModel: NumericSellerBenefit;
  aiModelEntry: NumericSellerBenefit;
  consultations: BinarySellerBenefit;
  coupons: NumericSellerBenefit;
  earlyPayout: BinarySellerBenefit;
  externalReviews: BinarySellerBenefit;
  fastCustomerSupportSla: BinarySellerBenefit;
  followUpMessages: NumericSellerBenefit;
  gigsAIFeedback: BinarySellerBenefit;
  highlightedReviews: BinarySellerBenefit;
  hourly: BinarySellerBenefit;
  increasedEarningsShareBasic: BinarySellerBenefit;
  introVideo: BinarySellerBenefit;
  keywordResearch: BinarySellerBenefit;
  manualDemotion: BinarySellerBenefit;
  maxSubscriptionConsecutiveDebts: NumericSellerBenefit;
  milestones: BinarySellerBenefit;
  negativeKeywords: BinarySellerBenefit;
  notableClients: BinarySellerBenefit;
  numberOfGigs: NumericSellerBenefit;
  personalAssistant: NumericSellerBenefit;
  personalAssistantEntry: NumericSellerBenefit;
  personalAssistantFree: NumericSellerBenefit;
  portfolio: BinarySellerBenefit;
  promotedGigs: BinarySellerBenefit;
  promotions: NumericSellerBenefit;
  requestToOrder: BinarySellerBenefit;
  sellerPlusBasic: BinarySellerBenefit;
  sellerPlusPremium: BinarySellerBenefit;
  sellerPlusStandard: BinarySellerBenefit;
  shorterClearanceTime: NumericSellerBenefit;
  subscriptions: BinarySellerBenefit;
  suggestedReply: BinarySellerBenefit;
  teamAccountBasic: BinarySellerBenefit;
  teamAccountPremium: BinarySellerBenefit;
  teamAccountSeats: NumericSellerBenefit;
  teamAccountStandard: BinarySellerBenefit;
};

/** Represents a binary benefit's value for a specific achievement criterion. */
export type SellerBinaryBenefitAchievementCriterion = SellerBenefitAchievementCriterion & {
  excludeLevels: Maybe<Array<SellerLevel>>;
  fromLevel: Maybe<SellerLevel>;
  vetting: Maybe<SellerVetting>;
};

export type SellerCertification = {
  /** Name of the certification */
  certificationName: Scalars['String']['output'];
  /** Name of school who gave the certification */
  receivedFrom: Scalars['String']['output'];
  /** Year of graduation */
  year: Scalars['Int']['output'];
};

export type SellerConsultations = {
  freeConsultationsEligible: Scalars['Boolean']['output'];
};

export type SellerEducation = {
  /** Country of the school */
  countryCode: CountryCode;
  /** Name of degree */
  degree: Scalars['String']['output'];
  /** Title of the degree */
  degreeTitle: DegreeTitle;
  /** Name of school/ institute/ college */
  school: Scalars['String']['output'];
  /** Year of graduation */
  toYear: Scalars['Int']['output'];
};

export type SellerEnrolledProgram = {
  billingInterval: SellerProgramBillingInterval;
  billingPeriod: BillingPeriod;
  category: SellerProgramCategory;
  currency: Currency;
  enrolledAt: Scalars['Timestamp']['output'];
  futureCancelAt: Maybe<Scalars['Timestamp']['output']>;
  /**
   * This field requires an additional query to an external service.
   * Fetching `nextBillingDate` may incur extra overhead, so use it carefully.
   */
  nextBillingDate: Maybe<Scalars['Timestamp']['output']>;
  paymentType: SellerProgramPaymentType;
  priceInCents: Scalars['Int']['output'];
  programType: SellerProgramType;
  requestedProgram: Maybe<SellerProgram>;
  tier: Tier;
};

export type SellerIntroVideoAttachment = {
  contentType: Maybe<Scalars['String']['output']>;
  filerrAttachmentId: Maybe<Scalars['String']['output']>;
  /** Intro video URL */
  mediaUrl: Maybe<Scalars['URI']['output']>;
  metadata: Maybe<SellerIntroVideoAttachmentMetadata>;
  previewUrls: Maybe<Array<IntroVideoPreviewUrl>>;
};


export type SellerIntroVideoAttachmentPreviewUrlsArgs = {
  transformations: Array<IntroVideoAttachmentTransformation>;
};

export type SellerIntroVideoAttachmentMetadata = {
  height: Maybe<Scalars['Float']['output']>;
  width: Maybe<Scalars['Float']['output']>;
};

export enum SellerLevel {
  BadActor = 'BAD_ACTOR',
  LevelOne = 'LEVEL_ONE',
  LevelTrs = 'LEVEL_TRS',
  LevelTwo = 'LEVEL_TWO',
  LowQuality = 'LOW_QUALITY',
  NewSeller = 'NEW_SELLER',
  NoLevel = 'NO_LEVEL'
}

/** Represents a numeric benefit's value for a specific achievement criterion. */
export type SellerNumericBenefitAchievementCriterion = SellerBenefitAchievementCriterion & {
  excludeLevels: Maybe<Array<SellerLevel>>;
  fromLevel: Maybe<SellerLevel>;
  /** The numeric value of this benefit for the given achievement criterion. */
  value: Scalars['Float']['output'];
  vetting: Maybe<SellerVetting>;
};

export type SellerPlus = SellerPlusEligible | SellerPlusEnrolled;

export type SellerPlusEligible = {
  tier: Tier;
};

export type SellerPlusEnrolled = {
  allowedBuyers: AllowedBuyerConnection;
  availableGigsForFollowUpCampaign: Array<Gig>;
  availableGigsForPromotion: Array<Gig>;
  couponQuota: CouponQuota;
  couponSummary: CouponSummary;
  coupons: CouponConnection;
  enrollment: Enrollment;
  followUpCampaigns: FollowUpCampaignConnection;
  followUpCampaignsByIds: Array<FollowUpCampaign>;
  followUpMessagesQuota: FollowUpMessagesQuota;
  /** Seller id */
  id: Scalars['ID']['output'];
  promotionQuota: PromotionQuota;
  promotionUsageQuota: PromotionUsageQuota;
  promotions: PromotionConnection;
  promotionsByIds: Array<Promotion>;
};


export type SellerPlusEnrolledAllowedBuyersArgs = {
  after: InputMaybe<Scalars['ID']['input']>;
  filter: InputMaybe<AllowedBuyersFilter>;
  first?: Scalars['Int']['input'];
  sort: InputMaybe<AllowedBuyersSort>;
};


export type SellerPlusEnrolledCouponsArgs = {
  after: InputMaybe<Scalars['ID']['input']>;
  first?: Scalars['Int']['input'];
};


export type SellerPlusEnrolledFollowUpCampaignsArgs = {
  after: InputMaybe<Scalars['ID']['input']>;
  first?: Scalars['Int']['input'];
  sort: InputMaybe<FollowUpCampaignsSort>;
};


export type SellerPlusEnrolledFollowUpCampaignsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type SellerPlusEnrolledPromotionsArgs = {
  after: InputMaybe<Scalars['ID']['input']>;
  first?: Scalars['Int']['input'];
  statuses: InputMaybe<Array<PromotionStatus>>;
};


export type SellerPlusEnrolledPromotionsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type SellerPortfolioAttachment = {
  contentType: Maybe<Scalars['String']['output']>;
  filerrAttachmentId: Maybe<Scalars['String']['output']>;
  mediaUrl: Maybe<Scalars['String']['output']>;
  metadata: Maybe<SellerPortfolioAttachmentMetadata>;
  pdfOpenUrl: Maybe<Scalars['String']['output']>;
  previewUrl: Maybe<Scalars['String']['output']>;
  previewUrls: Maybe<Array<PortfolioPreviewUrl>>;
};


export type SellerPortfolioAttachmentPreviewUrlArgs = {
  transformation: PortfolioAttachmentTransformation;
};


export type SellerPortfolioAttachmentPreviewUrlsArgs = {
  transformations: Array<PortfolioAttachmentTransformation>;
};

export type SellerPortfolioAttachmentMetadata = {
  height: Maybe<Scalars['Float']['output']>;
  width: Maybe<Scalars['Float']['output']>;
};

export type SellerPortfolioProject = {
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  /** Duration of the project */
  duration: Maybe<ProjectDuration>;
  id: Scalars['ID']['output'];
  /** Industry ids associated with the project */
  industryIds: Array<Scalars['String']['output']>;
  /** The internal project details */
  internalProjectDetails: Maybe<PortfolioProjectInternalProjectDetails>;
  /** Is the project experiential */
  isExperiential: Scalars['Boolean']['output'];
  items: Maybe<SellerPortfolioProjectItemConnection>;
  linkedGigIds: Array<Scalars['Float']['output']>;
  moderation: Maybe<PortfolioProjectModeration>;
  /** Fields associated with role catalog data */
  portfolioProjectRoleCatalog: PortfolioProjectRoleCatalog;
  /** Use amount and currency USD to describe amount in USD */
  price: Maybe<Money>;
  /** @deprecated Use items instead */
  projectItems: Array<SellerPortfolioProjectItem>;
  /** Start date of the project */
  projectStartedAt: Maybe<Scalars['Timestamp']['output']>;
  /** Sort ID of the project */
  sortId: Scalars['Int']['output'];
  /** The source of the project */
  source: PortfolioProjectSource;
  /** Sub category IDs associated with the project */
  subCategoryIds: Array<Scalars['Int']['output']>;
  title: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type SellerPortfolioProjectItemsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
};

export type SellerPortfolioProjectConnection = {
  edges: Maybe<Array<SellerPortfolioProjectEdge>>;
  nodes: Maybe<Array<SellerPortfolioProject>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SellerPortfolioProjectEdge = {
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<SellerPortfolioProject>;
};

export type SellerPortfolioProjectItem = {
  attachment: Maybe<SellerPortfolioAttachment>;
  id: Scalars['ID']['output'];
};

export type SellerPortfolioProjectItemConnection = {
  edges: Maybe<Array<SellerPortfolioProjectItemEdge>>;
  nodes: Maybe<Array<SellerPortfolioProjectItem>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SellerPortfolioProjectItemEdge = {
  cursor: Maybe<Scalars['String']['output']>;
  node: Maybe<SellerPortfolioProjectItem>;
};

export type SellerProgram = {
  billingInterval: SellerProgramBillingInterval;
  billingPeriod: BillingPeriod;
  currency: Currency;
  isEligible: Scalars['Boolean']['output'];
  paymentType: SellerProgramPaymentType;
  permission: SellerProgramPermission;
  priceInCents: Scalars['Int']['output'];
  /**
   * Transition availability for this program.
   * Null when seller has no active enrollment in this category.
   */
  programTransitionAvailability: Maybe<ProgramTransitionAvailability>;
  programType: SellerProgramType;
  tier: Tier;
};

export enum SellerProgramBillingInterval {
  Day = 'DAY',
  Month = 'MONTH',
  OneTime = 'ONE_TIME',
  Week = 'WEEK',
  Year = 'YEAR'
}

export enum SellerProgramCategory {
  AiModel = 'AI_MODEL',
  IncreasedEarningsShare = 'INCREASED_EARNINGS_SHARE',
  Kickstart = 'KICKSTART',
  PersonalAssistant = 'PERSONAL_ASSISTANT',
  SellerPlus = 'SELLER_PLUS',
  TeamAccount = 'TEAM_ACCOUNT'
}

/** Holds metadata about a Seller Program Category, beyond the enum label. */
export type SellerProgramCategoryMetadata = {
  category: SellerProgramCategory;
  isExclusive: Scalars['Boolean']['output'];
  programs: Array<SellerProgram>;
  tiers: Array<Tier>;
};

export enum SellerProgramPaymentType {
  Product = 'PRODUCT',
  Subscription = 'SUBSCRIPTION'
}

export type SellerProgramPermission = {
  isPermitted: Scalars['Boolean']['output'];
  reason: Maybe<SellerProgramPermissionReason>;
};

export enum SellerProgramPermissionReason {
  Agency = 'AGENCY',
  TeamMember = 'TEAM_MEMBER',
  Unknown = 'UNKNOWN'
}

export enum SellerProgramType {
  AiModel = 'AI_MODEL',
  IncreasedEarningsShareBasic = 'INCREASED_EARNINGS_SHARE_BASIC',
  KickstartBasic = 'KICKSTART_BASIC',
  PersonalAssistant = 'PERSONAL_ASSISTANT',
  SellerPlus = 'SELLER_PLUS',
  SellerPlusBasic = 'SELLER_PLUS_BASIC',
  SellerPlusPremium = 'SELLER_PLUS_PREMIUM',
  SellerPlusPremiumAnnual = 'SELLER_PLUS_PREMIUM_ANNUAL',
  SellerPlusPremiumSemiAnnual = 'SELLER_PLUS_PREMIUM_SEMI_ANNUAL',
  SellerPlusStandard = 'SELLER_PLUS_STANDARD',
  SellerPlusStandardAnnual = 'SELLER_PLUS_STANDARD_ANNUAL',
  SellerPlusStandardSemiAnnual = 'SELLER_PLUS_STANDARD_SEMI_ANNUAL',
  TeamAccountBasic = 'TEAM_ACCOUNT_BASIC',
  TeamAccountPremium = 'TEAM_ACCOUNT_PREMIUM',
  TeamAccountStandard = 'TEAM_ACCOUNT_STANDARD'
}

export type SellerRating = Rating & {
  /** Represents the count of ratings for a seller. */
  count: Scalars['Int']['output'];
  /** Represents the final rating score of a seller, based on all relevant metrics. */
  score: Scalars['Float']['output'];
};

export type SellerReferralsDetails = {
  /** Does the amount of completed orders based on referrals meet the threshold */
  completedOrderCondition: Maybe<Scalars['Boolean']['output']>;
  /**
   * Does the seller meet conditions for seller referrals badge
   * completedOrderCondition && referredByMeCondition
   */
  isBadgeEligible: Maybe<Scalars['Boolean']['output']>;
  /** Does the amount of referrals made by the seller meet the threshold */
  referredByMeCondition: Maybe<Scalars['Boolean']['output']>;
  /** How many orders the seller has completed based on referrals */
  successfulReferrals: Maybe<Scalars['Int']['output']>;
};

export type SellerResponse = {
  /** Represents the comment left by the seller as a response to the buying review. */
  comment: Scalars['String']['output'];
  /** Represents the time when the seller response was created. */
  createdAt: Scalars['Timestamp']['output'];
};

export type SellerRole = Node & {
  /**
   * The automation Gig that is associated with the seller role.
   * Null for DRAFT seller roles.
   */
  automationGig: Maybe<Gig>;
  /**
   * A user-generated description of the seller role clean of any HTML tags.
   * Can be null for DRAFT seller roles.
   * EXAMPLE: <p>hello</p> -> hello
   */
  cleanDescription: Maybe<Scalars['String']['output']>;
  /**
   * The number of completed orders for the seller role.
   * This does not take into account orders from Logo Maker, late extras and such.
   */
  completedOrdersCount: Scalars['Int']['output'];
  /**
   * A user-generated description of the seller role.
   * Can be null for DRAFT seller roles.
   */
  description: Maybe<Scalars['String']['output']>;
  /** The position of the array determines the order of the FAQs. */
  faq: Array<SellerRoleFaq>;
  /** Non-automation Gigs that are associated with the seller role. */
  gigs: Array<Gig>;
  /**
   * The highest price of the seller role.
   * Can be null for DRAFT seller roles.
   */
  highestPrice: Maybe<Scalars['Float']['output']>;
  /** A v4 UUID of the metadata value (e.g. "612e47cf-0196-45cd-9fb6-aa479a235af6"). */
  id: Scalars['ID']['output'];
  /** An indication if the Seller Role is an entry point to at least one AI Model. */
  isAI: Maybe<Scalars['Boolean']['output']>;
  /** Specifies whether the seller role is a pro role. */
  pro: Scalars['Boolean']['output'];
  /** The seller role metadata values that the seller is proficient in. */
  proficient: Array<CatalogMetadataValue>;
  /** Rating data for the seller role. */
  rating: Maybe<SellerRoleRating>;
  /** The catalog role that the seller role is based on. */
  role: CatalogRole;
  /**
   * The seller that the seller role belongs to.
   * A seller role must belong to a seller.
   */
  seller: Seller;
  /** List of AI Models that the Seller Role is an entry point of. */
  sellerAIModels: Maybe<Array<SellerAiModel>>;
  /** The services that the seller role offers. */
  services: Array<CatalogService>;
  /** The seller role metadata values and services IDs that the seller is specialized in. */
  specializations: Array<CatalogRoleSpecialization>;
  /** Can be null for DRAFT seller roles. */
  startingDate: Maybe<SellerRoleStartingDate>;
  /**
   * The starting price of the seller role.
   * Can be null for DRAFT seller roles.
   */
  startingPrice: Maybe<Scalars['Float']['output']>;
  /** The status of the seller role. A seller role can only have one status at a time. */
  status: SellerRoleStatus;
  /** The success score of the Seller Role */
  successScore: Maybe<Scalars['Int']['output']>;
  /** An unordered list of variations of the seller role. */
  variations: Array<SellerRoleVariation>;
};

export type SellerRoleFaq = {
  /** The answer to the frequently asked question. */
  answer: Scalars['String']['output'];
  /** The frequently asked question. */
  question: Scalars['String']['output'];
};

export type SellerRoleRating = Rating & {
  /** Represents the count of ratings for a seller role. */
  count: Scalars['Int']['output'];
  /** Represents the rating score of a seller role. */
  score: Scalars['Float']['output'];
};

export type SellerRoleStartingDate = {
  /** The month of the starting date. */
  month: Scalars['Int']['output'];
  /** The year of the starting date. */
  year: Scalars['Int']['output'];
};

export enum SellerRoleStatus {
  Approved = 'APPROVED',
  Attention = 'ATTENTION',
  Blocked = 'BLOCKED',
  Deleted = 'DELETED',
  Denied = 'DENIED',
  Draft = 'DRAFT',
  OnHold = 'ON_HOLD',
  Pending = 'PENDING',
  Suspended = 'SUSPENDED',
  Unspecified = 'UNSPECIFIED'
}

export type SellerRoleVariation = {
  /** The UUID of the seller role. */
  id: Scalars['ID']['output'];
  /** The name of the variation. */
  name: CatalogTextualEntity;
  /** The catalog entity that the variation is based on. */
  type: RoleCatalogType;
};

export type SellerSchedulingSettings = {
  accountId: Scalars['ID']['output'];
  /** Seller's timezone */
  timezone: Scalars['String']['output'];
};

export enum SellerStatus {
  Gigger = 'GIGGER',
  Onboarded = 'ONBOARDED',
  PreOnboarded = 'PRE_ONBOARDED',
  Seller = 'SELLER'
}

/** Seller's structured skill. */
export type SellerStructuredSkill = {
  id: Scalars['ID']['output'];
  level: SellerStructuredSkillLevel;
  /** Human readable structured skill name, e.g. "2D drawing" */
  name: Scalars['String']['output'];
  /** Profession alias for the structured skill name, e.g. "2D artist" */
  professionAlias: Scalars['String']['output'];
  type: SellerStructuredSkillType;
  verified: Scalars['Boolean']['output'];
};

/** raven.user.skills.Level enum - https://github.com/fiverr/fiverrapis/blob/master/raven/user/skills/enums.proto */
export enum SellerStructuredSkillLevel {
  Beginner = 'BEGINNER',
  Intermediate = 'INTERMEDIATE',
  Pro = 'PRO'
}

/** fiverr.skill.SkillType enum - https://github.com/fiverr/fiverrapis/blob/master/fiverr/skill/type.proto */
export enum SellerStructuredSkillType {
  Discipline = 'DISCIPLINE',
  Service = 'SERVICE',
  Soft = 'SOFT',
  Tool = 'TOOL'
}

export enum SellerVetting {
  Agency = 'AGENCY',
  AiModel = 'AI_MODEL',
  Certified = 'CERTIFIED',
  Kickstart = 'KICKSTART',
  PersonalAssistant = 'PERSONAL_ASSISTANT',
  Pro = 'PRO',
  SellerPlusBasic = 'SELLER_PLUS_BASIC',
  SellerPlusPremium = 'SELLER_PLUS_PREMIUM',
  SellerPlusStandard = 'SELLER_PLUS_STANDARD',
  TeamAccountBasic = 'TEAM_ACCOUNT_BASIC',
  TeamAccountPremium = 'TEAM_ACCOUNT_PREMIUM',
  TeamAccountStandard = 'TEAM_ACCOUNT_STANDARD'
}

export type SellingReview = Node & {
  /**
   * Represents the comment left by the seller. A seller leaves this comment as a part
   * of their feedback after buyer submits their review.
   */
  comment: Scalars['String']['output'];
  /** Represents the time when the selling review was created. */
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  /** Represents the list of valuations left by the seller. */
  valuations: Array<SellingReviewValuation>;
};

/** Represents a seller's response to a review question. */
export type SellingReviewValuation = {
  /** A key which indicates the review question being asked. */
  questionKey: Scalars['String']['output'];
  /** A value (1..5, inclusive) given by the buyer as an answer to the review question. */
  value: Scalars['Int']['output'];
};

export type Service = {
  id: Scalars['Int']['output'];
  /** Name of the service */
  name: Scalars['String']['output'];
  /** Type of the service */
  type: ServiceType;
};

export type ServiceTreeNode = {
  /** Children of the service tree node */
  children: Array<ServiceTreeNode>;
  /** Root of the service tree node */
  service: Service;
};

export enum ServiceType {
  AgencyType = 'AGENCY_TYPE',
  Category = 'CATEGORY',
  Service = 'SERVICE',
  ServiceSubCategory = 'SERVICE_SUB_CATEGORY'
}

export type ShareDeliveryResult = {
  assetsSharingId: Scalars['ID']['output'];
  shareLink: Scalars['String']['output'];
};

export type ShareInspireDeliveryInput = {
  inspireDeliveryIds: Array<Scalars['ID']['input']>;
};

export type ShareOrderDeliveryInput = {
  attachmentsIds: Array<Scalars['ID']['input']>;
  deliveryId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
};

export type SocialProvider = {
  /** The provider type (google, facebook, apple) */
  name: SocialProviderName;
};

/** The types of the social providers */
export enum SocialProviderName {
  Apple = 'APPLE',
  Facebook = 'FACEBOOK',
  Google = 'GOOGLE'
}

export type SoftwareReseller = {
  gig: Maybe<Gig>;
  id: Scalars['ID']['output'];
  onboardingCompleted: Maybe<Scalars['Boolean']['output']>;
  program: Maybe<SoftwareResellingProgram>;
  status: Maybe<SoftwareResellerStatus>;
};

export enum SoftwareResellerStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

export type SoftwareResellingOptionForCustomOffer = {
  gig: CustomOfferGig;
  program: Maybe<SoftwareResellingProgram>;
};

export type SoftwareResellingProgram = {
  id: Scalars['ID']['output'];
  slug: Maybe<Scalars['String']['output']>;
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SortOrderUnit {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Sorting team account clients by specific field */
export enum SortTeamAccountClientsBy {
  LatestActivity = 'LATEST_ACTIVITY',
  Name = 'NAME'
}

export type Sorting = {
  sortBy: InputMaybe<Scalars['String']['input']>;
  sortOrder: InputMaybe<SortOrder>;
  useDefaultSort: InputMaybe<Scalars['Boolean']['input']>;
};

export type SortingInput = {
  sortBy: SortTeamAccountClientsBy;
  sortOrder: SortOrder;
};

export type StatusHistory = {
  previousStatus: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  timestamp: Scalars['Timestamp']['output'];
  updatedBy: Maybe<Scalars['String']['output']>;
};

export type Studio = Node & {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  profileImageUrl: Maybe<Scalars['URI']['output']>;
};

export type StudioMerchant = {
  /** The studio this studio user belongs to */
  studio: Maybe<Studio>;
  /** The user this studio user belongs to */
  user: Maybe<User>;
};

export type SubcategoryFilter = {
  mimeTypes: InputMaybe<Array<AttachmentType>>;
};

export type SubmitCertifiedTestimonialClientInput = {
  company: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

export type SubmitCertifiedTestimonialInput = {
  client: SubmitCertifiedTestimonialClientInput;
  id: Scalars['ID']['input'];
  project: SubmitCertifiedTestimonialProjectInput;
  text: Scalars['String']['input'];
};

export type SubmitCertifiedTestimonialProjectInput = {
  name: Scalars['String']['input'];
};

export type TaggingOrderRequirements = {
  goal: DefaultProjectGoal;
  hosting: Maybe<HostingOptions>;
  industry: DefaultIndustry;
  orderId: Scalars['ID']['output'];
};

export type Task = {
  attachments: Maybe<Array<TaskAttachment>>;
  createdAt: Scalars['Timestamp']['output'];
  description: Scalars['String']['output'];
  estimatedPrice: ExtendedMoney;
  id: Scalars['ID']['output'];
  reportedMinutes: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Timestamp']['output'];
};

export type TaskAttachment = {
  contentType: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Timestamp']['output'];
  downloadUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileSizeBytes: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  mediaUrl: Maybe<Scalars['String']['output']>;
  metadata: Maybe<TaskAttachmentMetadata>;
  previewUrl: Maybe<Scalars['String']['output']>;
  type: AttachmentType;
};


export type TaskAttachmentPreviewUrlArgs = {
  transformation: TaskAttachmentTransformation;
};

export type TaskAttachmentMetadata = {
  height: Maybe<Scalars['Float']['output']>;
  width: Maybe<Scalars['Float']['output']>;
};

export enum TaskAttachmentTransformation {
  None = 'NONE',
  TTaskAttachmentGrid = 'T_TASK_ATTACHMENT_GRID',
  TTaskAttachmentLarge = 'T_TASK_ATTACHMENT_LARGE',
  TTaskAttachmentSmall = 'T_TASK_ATTACHMENT_SMALL'
}

/** The connection type for TaskConnection */
export type TaskConnection = {
  /** A list of edges */
  edges: Maybe<Array<TaskEdge>>;
  /** A list of nodes */
  nodes: Maybe<Array<Task>>;
  /** Information to aid in pagination */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection */
  totalCount: Scalars['Int']['output'];
};

export type TaskEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Task>;
};

export type TaskFiltering = {
  taskIds: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TaskPagination = {
  after: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
};

export type TaskSearchParams = {
  filters: InputMaybe<TaskFiltering>;
  pagination: InputMaybe<TaskPagination>;
  sorting: InputMaybe<TaskSorting>;
};

export enum TaskSortBy {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export enum TaskSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type TaskSorting = {
  sortBy: TaskSortBy;
  sortOrder: TaskSortOrder;
};

export enum Tax {
  AeVat = 'AE_VAT',
  AuGst = 'AU_GST',
  CaGst = 'CA_GST',
  CaHst = 'CA_HST',
  CaQst = 'CA_QST',
  Gst = 'GST',
  IlVat = 'IL_VAT',
  IlWithholding = 'IL_WITHHOLDING',
  IndiaGst = 'INDIA_GST',
  IndiaSection194 = 'INDIA_SECTION194',
  InGst = 'IN_GST',
  MxVat = 'MX_VAT',
  NgVat = 'NG_VAT',
  NzGst = 'NZ_GST',
  RuVat = 'RU_VAT',
  SalesTax = 'SALES_TAX',
  UsSales = 'US_SALES',
  Vat = 'VAT',
  ZaVat = 'ZA_VAT'
}

export type TeamAccount = {
  /** Date of when the team account was created in the database */
  createdAt: Maybe<Scalars['Timestamp']['output']>;
  /** Default assignee for the new team account clients */
  defaultAssignee: Maybe<TeamMember>;
  id: Scalars['ID']['output'];
  /**
   * Image (logo) of the team account.
   * Currently, it is equal to the owner's profile picture.
   */
  image: Maybe<TeamAccountAttachment>;
  /** List of the team account invitations */
  invitations: Array<TeamMemberInvitation>;
  /** List of the team members */
  members: Array<TeamMember>;
  /**
   * Name of the team account.
   * Currently, it is equal to the owner's display name.
   */
  name: Maybe<Scalars['String']['output']>;
  /** Seller associated with the team (team account owner) */
  owner: Seller;
  /** Total number of members that can be added to the team account */
  seatCapacity: Maybe<Scalars['Int']['output']>;
  /** Unique slug for the team account used in the URL */
  slug: Maybe<Scalars['String']['output']>;
  /** Status of the team account */
  status: Maybe<TeamAccountStatus>;
  /** Date of when the team account's clients were last synchronized */
  synchronizedAt: Maybe<Scalars['Timestamp']['output']>;
  /** Available tags for assigning to clients in the team account */
  tags: Maybe<Array<TeamAccountTag>>;
};


export type TeamAccountInvitationsArgs = {
  statuses: InputMaybe<Array<TeamMemberInvitationStatus>>;
};

export type TeamAccountAttachment = {
  id: Scalars['ID']['output'];
  previewUrl: Maybe<TeamAccountAttachmentUrl>;
};


export type TeamAccountAttachmentPreviewUrlArgs = {
  transformation: TeamAccountAttachmentTransformation;
};

export enum TeamAccountAttachmentTransformation {
  TeamImageOriginal = 'TEAM_IMAGE_ORIGINAL',
  TeamImageSmall = 'TEAM_IMAGE_SMALL',
  TeamImageThumb = 'TEAM_IMAGE_THUMB'
}

export type TeamAccountAttachmentUrl = {
  transformation: Maybe<TeamAccountAttachmentTransformation>;
  url: Maybe<Scalars['URI']['output']>;
};

export type TeamAccountClient = {
  /** Team members assigned to this client */
  assignedMembers: Maybe<Array<TeamMember>>;
  /** Embed sessions associated with this client */
  embedSessions: Array<EmbedSessionMatch>;
  /** Whether the client has some active orders */
  hasActiveOrders: Maybe<Scalars['Boolean']['output']>;
  /** Whether the client has some new activity (unread messages, etc.) */
  hasNewActivity: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** The timestamp of the most recent interaction with the team account */
  lastInteraction: Maybe<Scalars['Timestamp']['output']>;
  /** The current status of the team account client */
  status: TeamAccountClientStatus;
  /** A list of labels (tags) assigned to this client */
  tags: Maybe<Array<TeamAccountTag>>;
  /** The team account this client belongs to */
  teamAccount: Maybe<TeamAccount>;
  /** The user associated with this team account client */
  user: User;
};

export enum TeamAccountClientSearchStatus {
  ActiveClient = 'ACTIVE_CLIENT',
  Archived = 'ARCHIVED',
  Client = 'CLIENT',
  Lead = 'LEAD',
  RepeatedClient = 'REPEATED_CLIENT',
  Spam = 'SPAM'
}

export enum TeamAccountClientStatus {
  Archived = 'ARCHIVED',
  Client = 'CLIENT',
  Lead = 'LEAD',
  RepeatedClient = 'REPEATED_CLIENT',
  Spam = 'SPAM'
}

export type TeamAccountClientsConnection = {
  nodes: Array<TeamAccountClient>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum TeamAccountStatus {
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
  Suspended = 'SUSPENDED'
}

export type TeamAccountTag = {
  id: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  type: TeamAccountTagType;
};

export enum TeamAccountTagType {
  Custom = 'CUSTOM',
  Embed = 'EMBED',
  Predefined = 'PREDEFINED'
}

export type TeamMember = {
  /** Date of when the member was created */
  createdAt: Maybe<Scalars['Timestamp']['output']>;
  /** Team member's department within the team (e.g. Project Management, Finance, etc.) */
  department: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Representing the importance of the team member by specifically indicating their position.
   * This might be taken into consideration when rendering UI elements.
   */
  position: Maybe<Scalars['Int']['output']>;
  /** Role of the team member (e.g. Owner / Regular member) */
  role: TeamMemberRole;
  /** Status of the team member */
  status: TeamMemberStatus;
  /** Status history of the team member */
  statusHistory: Array<TeamMemberStatusHistory>;
  /** Team Account this member belongs to */
  team: TeamAccount;
  /** User associated with the team member */
  user: User;
  /** Team member's view preferences */
  viewPreferences: Maybe<TeamMemberViewPreferences>;
};

export type TeamMemberInvitation = {
  /** Date of when the invitation was created */
  createdAt: Scalars['Timestamp']['output'];
  /** Email associated with the invitee */
  email: Scalars['String']['output'];
  /** Invitation expiration date */
  expirationDate: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  /** Invitation status */
  status: TeamMemberInvitationStatus;
  /** Team Account associated with the invitation */
  teamAccount: Maybe<TeamAccount>;
  /** User associated with the invitee */
  user: Maybe<User>;
};

export enum TeamMemberInvitationStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Revoked = 'REVOKED'
}

export enum TeamMemberRole {
  Member = 'MEMBER',
  Owner = 'OWNER'
}

export enum TeamMemberStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Onboarding = 'ONBOARDING'
}

export type TeamMemberStatusHistory = {
  /** Status of the team member */
  status: TeamMemberStatus;
  /** Date of when the member status was changed */
  timestamp: Scalars['Timestamp']['output'];
};

export type TeamMemberViewFilter = {
  fieldName: Scalars['String']['output'];
  fieldValues: Array<Scalars['String']['output']>;
};

export type TeamMemberViewPreferences = {
  filters: Maybe<Array<TeamMemberViewFilter>>;
  sortBy: Maybe<TeamMemberViewSort>;
};

export type TeamMemberViewSort = {
  fieldName: Scalars['String']['output'];
  order: SortOrder;
};

export enum Tier {
  Basic = 'BASIC',
  Premium = 'PREMIUM',
  Standard = 'STANDARD'
}

export type TiersThresholds = {
  diamond: Scalars['Int']['output'];
  gold: Scalars['Int']['output'];
  platinum: Scalars['Int']['output'];
  silver: Scalars['Int']['output'];
};

export type TimeRange = {
  endTimeExcluding: InputMaybe<Scalars['Timestamp']['input']>;
  startTimeIncluding: InputMaybe<Scalars['Timestamp']['input']>;
};

export enum TimeUnit {
  Day = 'DAY'
}

export type TimestampRange = {
  from: Scalars['Timestamp']['output'];
  to: Scalars['Timestamp']['output'];
};

export type Tip = Item & {
  id: Maybe<Scalars['Int']['output']>;
  price: ExtendedMoney;
  quantity: Scalars['Int']['output'];
  title: Maybe<Scalars['String']['output']>;
};

export type TopReviewedSeller = {
  profileImage: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type TopicSubscriptionInput = {
  gigCategory: GigCategoryInput;
  subscribe: Scalars['Boolean']['input'];
};

export type TopicSubscriptionResult = {
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type TotalPointsEarnedByParentId = {
  amount: Maybe<Scalars['Int']['output']>;
};

export type TransformationParametersInput = {
  /** Custom crop to apply to the image */
  crop: InputMaybe<CropOptions>;
  /** Custom height to apply to the image */
  height: InputMaybe<Scalars['Float']['input']>;
  /** Key used to map the transformation to the url */
  key: Scalars['String']['input'];
  /** The transformation type to apply to the image */
  type: InputMaybe<Scalars['String']['input']>;
  /** Custom width to apply to the image */
  width: InputMaybe<Scalars['Float']['input']>;
};

/** Represents content that can be translated */
export type TranslatableContent = {
  /** The translation key */
  key: Maybe<Scalars['String']['output']>;
  /** The raw translation value */
  params: Array<TranslationsParam>;
};

export type TranslationsParam = {
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TrendingDeliveriesFilter = {
  first: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['Timestamp']['input'];
  subCategoryIds: InputMaybe<Array<Scalars['Int']['input']>>;
  to: Scalars['Timestamp']['input'];
};

export type TrendingSubCategoriesFilter = {
  from: Scalars['Timestamp']['input'];
  subCategoryIds: InputMaybe<Array<Scalars['Int']['input']>>;
  to: Scalars['Timestamp']['input'];
};

export enum UnitStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Delivered = 'DELIVERED',
  InProgress = 'IN_PROGRESS',
  Rejected = 'REJECTED',
  Unknown = 'UNKNOWN'
}

export type UpdateAgencyInput = {
  description: InputMaybe<Scalars['String']['input']>;
  displayName: InputMaybe<Scalars['String']['input']>;
  established: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  industries: InputMaybe<Array<Scalars['String']['input']>>;
  locale: InputMaybe<Scalars['String']['input']>;
  members: InputMaybe<Array<AgencyMemberInput>>;
  oneLiner: InputMaybe<Scalars['String']['input']>;
  profileBackgroundAttachmentId: InputMaybe<Scalars['String']['input']>;
  services: InputMaybe<Array<Scalars['Int']['input']>>;
  slug: InputMaybe<Scalars['String']['input']>;
  teamSize: InputMaybe<Scalars['Int']['input']>;
};

export type UsedBenefit = {
  actionExternalId: Maybe<Scalars['String']['output']>;
  actionId: Maybe<Scalars['String']['output']>;
  contextId: Scalars['String']['output'];
  contextType: ContextType;
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  programId: Scalars['String']['output'];
  tierWhenUsed: LoyaltyProgramTier;
  type: LoyaltyBenefitType;
};

export type UsedBenefitConnection = {
  edges: Maybe<Array<UsedBenefitEdge>>;
  pageInfo: PageInfo;
  totalCount: Maybe<Scalars['Float']['output']>;
};

export type UsedBenefitEdge = {
  cursor: Scalars['String']['output'];
  node: UsedBenefit;
};

export type UsedEarnReference = {
  pointsAmount: Scalars['Float']['output'];
  type: PointsEarnReferenceType;
};

export type UsefulSubcategory = {
  id: Scalars['Float']['output'];
  link: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Should be user from federation */
export type User = Node & {
  address: Maybe<UserAddress>;
  /** Buyer aspect of the user */
  buyer: Maybe<Buyer>;
  email: Maybe<Scalars['Email']['output']>;
  fullName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Indicates if user has completed the activation */
  isActivationCompleted: Scalars['Boolean']['output'];
  /** @deprecated For mobile-app use only */
  isOnline: Scalars['Boolean']['output'];
  joinedAt: Maybe<Scalars['Timestamp']['output']>;
  languages: Array<ProficientLanguage>;
  localization: Localization;
  name: Scalars['String']['output'];
  profile: UserProfile;
  profileImage: Maybe<UserProfileImageAttachment>;
  profileImageUrl: Maybe<Scalars['URI']['output']>;
  /** Seller aspect of the user */
  seller: Maybe<Seller>;
  /** User's memberships in team accounts. There can be only one active membership, but multiple inactive ones (e.g. from past team enrollments). */
  teamMemberships: Maybe<Array<TeamMember>>;
};


/** Should be user from federation */
export type UserTeamMembershipsArgs = {
  status: InputMaybe<TeamMemberStatus>;
  teamIds: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UserAddress = {
  /** Format ISO 3166-1 alpha-2 */
  countryCode: Maybe<CountryCode>;
  /** Full country name, e.g: Israel, Ukraine, etc */
  countryName: Maybe<Scalars['String']['output']>;
};

export type UserBuyingReviews = {
  averageValuation: Maybe<Scalars['Float']['output']>;
  communicationValuationAverage: Maybe<Scalars['Float']['output']>;
  recommendValuationAverage: Maybe<Scalars['Float']['output']>;
  serviceValuationAverage: Maybe<Scalars['Float']['output']>;
  totalReviewsCount: Maybe<Scalars['Int']['output']>;
};

export type UserCustomer = {
  user: Maybe<User>;
};

export type UserGoal = Goal & {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  requirementId: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type UserLastViewedSubcategories = {
  /** Indicates whether to force update categories tree */
  subCategoryId: Scalars['Int']['output'];
  /** Categories last update time represent as unix epoch time in seconds */
  viewedAt: Scalars['Timestamp']['output'];
};

export type UserMerchant = {
  seller: Maybe<Seller>;
  user: Maybe<User>;
};

/** A messaging participant who is a Fiverr user */
export type UserMessagingParticipant = {
  user: Maybe<User>;
};

export type UserMetrics = {
  asp: Maybe<Scalars['Float']['output']>;
  aspGrowth: Maybe<Scalars['Float']['output']>;
  aspPreviousYear: Maybe<Scalars['Float']['output']>;
  bestBuyer: Maybe<Scalars['String']['output']>;
  bestBuyerProfilePicture: Maybe<Scalars['String']['output']>;
  bestMonth: Maybe<Scalars['String']['output']>;
  bestMonthRevenue: Maybe<Scalars['Float']['output']>;
  bestOrdersSubcategoryName: Maybe<Scalars['String']['output']>;
  bestOrdersSubcategoryTotalOrders: Maybe<Scalars['Int']['output']>;
  bestRevenueSubcategoryName: Maybe<Scalars['String']['output']>;
  businessName: Maybe<Scalars['String']['output']>;
  buyers: Maybe<Scalars['Int']['output']>;
  buyersCountries: Maybe<Scalars['Int']['output']>;
  daysToDelivery: Maybe<Scalars['Int']['output']>;
  dominantCountry: Maybe<Scalars['String']['output']>;
  dominantCountryOrders: Maybe<Scalars['Int']['output']>;
  dominantCountryOrdersRatio: Maybe<Scalars['Float']['output']>;
  growthSinceSwitchedToAgency: Maybe<Scalars['Float']['output']>;
  hasPromotedGigs: Maybe<Scalars['Boolean']['output']>;
  highestEarningServiceOffered: Maybe<Scalars['String']['output']>;
  impressions: Maybe<Scalars['Int']['output']>;
  isSellerAgency: Maybe<Scalars['Boolean']['output']>;
  isSellerPlusMember: Maybe<Scalars['Boolean']['output']>;
  isSellerPro: Maybe<Scalars['Boolean']['output']>;
  leadsNumberSinceBecomingAgency: Maybe<Scalars['Int']['output']>;
  longestRelationshipOrders: Maybe<Scalars['Int']['output']>;
  mostPopularServiceOffered: Maybe<Scalars['String']['output']>;
  newActiveGigs: Maybe<Scalars['Int']['output']>;
  newBuyers: Maybe<Scalars['Int']['output']>;
  orders: Maybe<Scalars['Int']['output']>;
  ordersFromPG: Maybe<Scalars['Int']['output']>;
  ordersGrowth: Maybe<Scalars['Float']['output']>;
  ordersPreviousYear: Maybe<Scalars['Float']['output']>;
  projects: Maybe<Scalars['Int']['output']>;
  publicRating: Maybe<Scalars['Float']['output']>;
  ratingText: Maybe<Scalars['String']['output']>;
  repeatBuyers: Maybe<Scalars['Int']['output']>;
  revenue: Maybe<Scalars['Float']['output']>;
  revenueGrowth: Maybe<Scalars['Float']['output']>;
  revenuePreviousYear: Maybe<Scalars['Float']['output']>;
  reviewedOrders: Maybe<Scalars['Int']['output']>;
  roas: Maybe<Scalars['Float']['output']>;
  sellerLevel: Maybe<Scalars['String']['output']>;
  sellerLevelIncreased: Maybe<Scalars['Boolean']['output']>;
  sellerLevelPhoto: Maybe<Scalars['String']['output']>;
  sellerPlusEnrollDuration: Maybe<Scalars['Int']['output']>;
  sellerPlusPremiumMember: Maybe<Scalars['Boolean']['output']>;
  sellers: Maybe<Scalars['Int']['output']>;
  sellersCountries: Maybe<Scalars['Int']['output']>;
  subcategories: Maybe<Scalars['Int']['output']>;
  tipAmount: Maybe<Scalars['Float']['output']>;
  tippedOrders: Maybe<Scalars['Int']['output']>;
  topReviewedSellers: Maybe<Array<TopReviewedSeller>>;
  topSubcategories: Maybe<Array<Scalars['String']['output']>>;
  usefulSubcategories: Maybe<Array<UsefulSubcategory>>;
};

export type UserProfile = {
  /** The user display name, the user public name in the site */
  displayName: Maybe<Scalars['String']['output']>;
};

export type UserProfileImageAttachment = {
  /** Filerr attachment ID */
  id: Scalars['ID']['output'];
  previewUrl: Maybe<UserProfileImageAttachmentUrl>;
};


export type UserProfileImageAttachmentPreviewUrlArgs = {
  transformation: UserProfileImageAttachmentTransformation;
};

export enum UserProfileImageAttachmentTransformation {
  None = 'NONE',
  UserProfileOriginal = 'USER_PROFILE_ORIGINAL',
  UserProfileSmall = 'USER_PROFILE_SMALL',
  UserProfileThumb = 'USER_PROFILE_THUMB'
}

export type UserProfileImageAttachmentUrl = {
  transformation: Maybe<UserProfileImageAttachmentTransformation>;
  url: Maybe<Scalars['URI']['output']>;
};

export type UserProjectGoal = {
  id: Scalars['String']['output'];
  projectGoal: ProjectGoal;
  services: Array<UserProjectService>;
  status: UserProjectStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type UserProjectService = {
  order: Maybe<Order>;
  service: ProjectService;
};

export enum UserProjectStatus {
  Closed = 'CLOSED',
  Done = 'DONE',
  InProgress = 'IN_PROGRESS'
}

export enum UserStatus {
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
  Pending = 'PENDING',
  Restricted = 'RESTRICTED'
}

export type Vacation = {
  /** Away message for buyers */
  awayMessage: Maybe<Scalars['String']['output']>;
  /** End date of seller's vacation */
  endsAt: Scalars['Timestamp']['output'];
  /** Indicates if the seller wants to be contacted during his vacation */
  isContactAllowed: Scalars['Boolean']['output'];
  /** Start date of seller's vacation */
  startsAt: Scalars['Timestamp']['output'];
};

export type VideoMeeting = {
  /** Identifies the time in which the video meeting ended */
  endTime: Maybe<Scalars['Timestamp']['output']>;
  provider: VideoMeetingProvider;
  recording: Maybe<VideoMeetingRecording>;
  /** Identifies the time in which the video meeting started */
  startTime: Maybe<Scalars['Timestamp']['output']>;
  status: VideoMeetingStatus;
  topic: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['URI']['output']>;
};

export type VideoMeetingProvider = {
  id: Maybe<Scalars['String']['output']>;
  type: VideoMeetingProviderType;
};

/** Video meeting provider type */
export enum VideoMeetingProviderType {
  Zoom = 'ZOOM'
}

export type VideoMeetingRecording = {
  previewUrl: Scalars['URI']['output'];
};

/** Video meeting status */
export enum VideoMeetingStatus {
  Ended = 'ENDED',
  NotStarted = 'NOT_STARTED',
  Started = 'STARTED'
}

export type VoiceOverCalculator = {
  maxNumberOfWordsPerOneMoreDay: Maybe<Scalars['Int']['output']>;
  maxNumberOfWordsPerPackageDuration: Maybe<Scalars['Int']['output']>;
};

export type VoteResult = {
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type VotesDiff = {
  count: Scalars['Int']['output'];
  period: TimestampRange;
};

export type WhatsNewData = {
  /** Min version to show whats new data */
  appVersion: Maybe<Scalars['String']['output']>;
  /** Whats new description text */
  description: Maybe<Scalars['String']['output']>;
};

export type WorkExperience = {
  company: CompanyProfile;
  /** Indicates if the work experience is the current job */
  currentJob: Scalars['Boolean']['output'];
  description: Maybe<Scalars['String']['output']>;
  employmentType: EmploymentType;
  /** End date of the work experience in Unix epoch time in seconds */
  endDate: Maybe<Scalars['Timestamp']['output']>;
  id: Scalars['ID']['output'];
  skills: Array<Scalars['String']['output']>;
  /** Start date of the work experience in Unix epoch time in seconds */
  startDate: Maybe<Scalars['Timestamp']['output']>;
  title: Scalars['String']['output'];
};

export type WorkExperienceConnection = {
  edges: Array<WorkExperienceEdge>;
  nodes: Maybe<Array<WorkExperience>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WorkExperienceEdge = {
  cursor: Scalars['String']['output'];
  node: WorkExperience;
};

export type LocalizedTextFieldsFragment = { original: string | null, localized: string | null };

export type IndustriesIndustryNodeIndustryFieldsFragment = { name: string, id: string };

export type IndustriesIndustryNodeFieldsFragment = { industry: { name: string, id: string } | null };

export type PortfolioIndustriesQueryVariables = Exact<{ [key: string]: never; }>;


export type PortfolioIndustriesQuery = { industriesTree: Array<{ children: Array<{ children: Array<{ children: Array<{ industry: { name: string, id: string } | null } | null>, industry: { name: string, id: string } | null } | null>, industry: { name: string, id: string } | null } | null>, industry: { name: string, id: string } | null }> };

export type PortfolioModalSellerPortfolioProjectAttachmentFieldsFragment = { contentType: string | null, filerrAttachmentId: string | null, previewUrl: string | null, mediaUrl: string | null, pdfOpenUrl: string | null, metadata: { height: number | null, width: number | null } | null };

export type PortfolioInternalProjectDetailsFragment = { buyerUserName: string | null, rating: number | null, nestedSubCategoryId: number | null };

export type PortfolioModalSellerPortfolioProjectFieldsFragment = { id: string, title: string | null, source: PortfolioProjectSource, description: string | null, duration: ProjectDuration | null, industryIds: Array<string>, subCategoryIds: Array<number>, projectStartedAt: number | null, internalProjectDetails: { buyerUserName: string | null, rating: number | null, nestedSubCategoryId: number | null } | null, items: { totalCount: number, nodes: Array<{ id: string, attachment: { contentType: string | null, filerrAttachmentId: string | null, previewUrl: string | null, mediaUrl: string | null, pdfOpenUrl: string | null, metadata: { height: number | null, width: number | null } | null } | null }> | null } | null, portfolioProjectRoleCatalog: { metadataIds: Array<string>, roleIds: Array<string>, serviceIds: Array<string> }, price: { amount: string } | null };

export type PortfolioModalSellerPortfolioProjectFieldsWithModerationFragment = { id: string, title: string | null, source: PortfolioProjectSource, description: string | null, duration: ProjectDuration | null, industryIds: Array<string>, subCategoryIds: Array<number>, projectStartedAt: number | null, moderation: { status: PortfolioModerationStatus | null, reasons: Array<PortfolioModerationReason> | null, violatedFields: Array<{ attachmentId: string | null, type: PortfolioProjectFieldType }> | null } | null, internalProjectDetails: { buyerUserName: string | null, rating: number | null, nestedSubCategoryId: number | null } | null, items: { totalCount: number, nodes: Array<{ id: string, attachment: { contentType: string | null, filerrAttachmentId: string | null, previewUrl: string | null, mediaUrl: string | null, pdfOpenUrl: string | null, metadata: { height: number | null, width: number | null } | null } | null }> | null } | null, portfolioProjectRoleCatalog: { metadataIds: Array<string>, roleIds: Array<string>, serviceIds: Array<string> }, price: { amount: string } | null };

export type PortfolioModalProjectQueryVariables = Exact<{
  usernames: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  projectIds: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  projectCardTransformation?: InputMaybe<PortfolioAttachmentTransformation>;
  projectSource: InputMaybe<ProjectSourceFilter>;
  projectStatusFilter?: InputMaybe<ProjectStatusFilter>;
}>;


export type PortfolioModalProjectQuery = { sellersDataByUsernames: Array<{ portfolios: { nodes: Array<{ id: string, title: string | null, source: PortfolioProjectSource, description: string | null, duration: ProjectDuration | null, industryIds: Array<string>, subCategoryIds: Array<number>, projectStartedAt: number | null, internalProjectDetails: { buyerUserName: string | null, rating: number | null, nestedSubCategoryId: number | null } | null, items: { totalCount: number, nodes: Array<{ id: string, attachment: { contentType: string | null, filerrAttachmentId: string | null, previewUrl: string | null, mediaUrl: string | null, pdfOpenUrl: string | null, metadata: { height: number | null, width: number | null } | null } | null }> | null } | null, portfolioProjectRoleCatalog: { metadataIds: Array<string>, roleIds: Array<string>, serviceIds: Array<string> }, price: { amount: string } | null }> | null } | null }> };

export type PortfolioModalProjectWithModerationQueryVariables = Exact<{
  usernames: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  projectIds: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  projectCardTransformation?: InputMaybe<PortfolioAttachmentTransformation>;
  projectSource: InputMaybe<ProjectSourceFilter>;
  projectStatusFilter?: InputMaybe<ProjectStatusFilter>;
}>;


export type PortfolioModalProjectWithModerationQuery = { sellersDataByUsernames: Array<{ portfolios: { nodes: Array<{ id: string, title: string | null, source: PortfolioProjectSource, description: string | null, duration: ProjectDuration | null, industryIds: Array<string>, subCategoryIds: Array<number>, projectStartedAt: number | null, moderation: { status: PortfolioModerationStatus | null, reasons: Array<PortfolioModerationReason> | null, violatedFields: Array<{ attachmentId: string | null, type: PortfolioProjectFieldType }> | null } | null, internalProjectDetails: { buyerUserName: string | null, rating: number | null, nestedSubCategoryId: number | null } | null, items: { totalCount: number, nodes: Array<{ id: string, attachment: { contentType: string | null, filerrAttachmentId: string | null, previewUrl: string | null, mediaUrl: string | null, pdfOpenUrl: string | null, metadata: { height: number | null, width: number | null } | null } | null }> | null } | null, portfolioProjectRoleCatalog: { metadataIds: Array<string>, roleIds: Array<string>, serviceIds: Array<string> }, price: { amount: string } | null }> | null } | null }> };

export type PortfolioWidgetSellerPortfolioProjectFieldsFragment = { id: string, title: string | null, source: PortfolioProjectSource, items: { nodes: Array<{ attachment: { previewUrl: string | null } | null }> | null } | null };

export type PortfolioWidgetQueryVariables = Exact<{
  usernames: Array<Scalars['String']['input']> | Scalars['String']['input'];
  roleIds: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  sellerRoleIds: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  projectCardTransformation?: InputMaybe<PortfolioAttachmentTransformation>;
  projectSource?: InputMaybe<ProjectSourceFilter>;
}>;


export type PortfolioWidgetQuery = { sellersByUsernames: Array<{ firstPortfolio: { nodes: Array<{ id: string, title: string | null, source: PortfolioProjectSource, description: string | null, duration: ProjectDuration | null, industryIds: Array<string>, subCategoryIds: Array<number>, projectStartedAt: number | null, internalProjectDetails: { buyerUserName: string | null, rating: number | null, nestedSubCategoryId: number | null } | null, items: { totalCount: number, nodes: Array<{ id: string, attachment: { contentType: string | null, filerrAttachmentId: string | null, previewUrl: string | null, mediaUrl: string | null, pdfOpenUrl: string | null, metadata: { height: number | null, width: number | null } | null } | null }> | null } | null, portfolioProjectRoleCatalog: { metadataIds: Array<string>, roleIds: Array<string>, serviceIds: Array<string> }, price: { amount: string } | null }> | null } | null, portfolios: { totalCount: number, nodes: Array<{ id: string, title: string | null, source: PortfolioProjectSource, items: { nodes: Array<{ attachment: { previewUrl: string | null } | null }> | null } | null }> | null } | null }> };

export type SellerUserFieldsFragment = { id: string, name: string, fullName: string | null, profileImageUrl: string | null, profile: { displayName: string | null } };

export type SellerFieldsFragment = { introVideo: { attachment: { mediaUrl: string | null } | null } | null, user: { id: string, name: string, fullName: string | null, profileImageUrl: string | null, profile: { displayName: string | null } }, agency: { id: string } | null };

export type PortfolioModalSellersDataQueryVariables = Exact<{
  usernames: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type PortfolioModalSellersDataQuery = { sellersByUsernames: Array<{ introVideo: { attachment: { mediaUrl: string | null } | null } | null, user: { id: string, name: string, fullName: string | null, profileImageUrl: string | null, profile: { displayName: string | null } }, agency: { id: string } | null }> };

export const LocalizedTextFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocalizedTextFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LocalizedText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"original"}},{"kind":"Field","name":{"kind":"Name","value":"localized"}}]}}]} as unknown as DocumentNode<LocalizedTextFieldsFragment, unknown>;
export const IndustriesIndustryNodeIndustryFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IndustriesIndustryNodeIndustryFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Industry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]} as unknown as DocumentNode<IndustriesIndustryNodeIndustryFieldsFragment, unknown>;
export const IndustriesIndustryNodeFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IndustriesIndustryNodeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IndustryTreeNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"industry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IndustriesIndustryNodeIndustryFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IndustriesIndustryNodeIndustryFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Industry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]} as unknown as DocumentNode<IndustriesIndustryNodeFieldsFragment, unknown>;
export const PortfolioInternalProjectDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortfolioInternalProjectDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioProjectInternalProjectDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyerUserName"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"nestedSubCategoryId"}}]}}]} as unknown as DocumentNode<PortfolioInternalProjectDetailsFragment, unknown>;
export const PortfolioModalSellerPortfolioProjectAttachmentFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortfolioModalSellerPortfolioProjectAttachmentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SellerPortfolioAttachment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"filerrAttachmentId"}},{"kind":"Field","name":{"kind":"Name","value":"previewUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"transformation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectCardTransformation"}}}]},{"kind":"Field","name":{"kind":"Name","value":"mediaUrl"}},{"kind":"Field","name":{"kind":"Name","value":"pdfOpenUrl"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}}]}}]}}]} as unknown as DocumentNode<PortfolioModalSellerPortfolioProjectAttachmentFieldsFragment, unknown>;
export const PortfolioModalSellerPortfolioProjectFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortfolioModalSellerPortfolioProjectFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SellerPortfolioProject"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"internalProjectDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortfolioInternalProjectDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortfolioModalSellerPortfolioProjectAttachmentFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"industryIds"}},{"kind":"Field","name":{"kind":"Name","value":"portfolioProjectRoleCatalog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadataIds"}},{"kind":"Field","name":{"kind":"Name","value":"roleIds"}},{"kind":"Field","name":{"kind":"Name","value":"serviceIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subCategoryIds"}},{"kind":"Field","name":{"kind":"Name","value":"projectStartedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortfolioInternalProjectDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioProjectInternalProjectDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyerUserName"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"nestedSubCategoryId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortfolioModalSellerPortfolioProjectAttachmentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SellerPortfolioAttachment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"filerrAttachmentId"}},{"kind":"Field","name":{"kind":"Name","value":"previewUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"transformation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectCardTransformation"}}}]},{"kind":"Field","name":{"kind":"Name","value":"mediaUrl"}},{"kind":"Field","name":{"kind":"Name","value":"pdfOpenUrl"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}}]}}]}}]} as unknown as DocumentNode<PortfolioModalSellerPortfolioProjectFieldsFragment, unknown>;
export const PortfolioModalSellerPortfolioProjectFieldsWithModerationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortfolioModalSellerPortfolioProjectFieldsWithModeration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SellerPortfolioProject"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortfolioModalSellerPortfolioProjectFields"}},{"kind":"Field","name":{"kind":"Name","value":"moderation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"reasons"}},{"kind":"Field","name":{"kind":"Name","value":"violatedFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachmentId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortfolioInternalProjectDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioProjectInternalProjectDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyerUserName"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"nestedSubCategoryId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortfolioModalSellerPortfolioProjectAttachmentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SellerPortfolioAttachment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"filerrAttachmentId"}},{"kind":"Field","name":{"kind":"Name","value":"previewUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"transformation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectCardTransformation"}}}]},{"kind":"Field","name":{"kind":"Name","value":"mediaUrl"}},{"kind":"Field","name":{"kind":"Name","value":"pdfOpenUrl"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortfolioModalSellerPortfolioProjectFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SellerPortfolioProject"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"internalProjectDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortfolioInternalProjectDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortfolioModalSellerPortfolioProjectAttachmentFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"industryIds"}},{"kind":"Field","name":{"kind":"Name","value":"portfolioProjectRoleCatalog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadataIds"}},{"kind":"Field","name":{"kind":"Name","value":"roleIds"}},{"kind":"Field","name":{"kind":"Name","value":"serviceIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subCategoryIds"}},{"kind":"Field","name":{"kind":"Name","value":"projectStartedAt"}}]}}]} as unknown as DocumentNode<PortfolioModalSellerPortfolioProjectFieldsWithModerationFragment, unknown>;
export const PortfolioWidgetSellerPortfolioProjectFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortfolioWidgetSellerPortfolioProjectFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SellerPortfolioProject"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"transformation"},"value":{"kind":"EnumValue","value":"T_PORTFOLIO_PROJECT_GRID"}}]}]}}]}}]}}]}}]} as unknown as DocumentNode<PortfolioWidgetSellerPortfolioProjectFieldsFragment, unknown>;
export const SellerUserFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SellerUserFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}}]}}]} as unknown as DocumentNode<SellerUserFieldsFragment, unknown>;
export const SellerFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SellerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Seller"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"introVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SellerUserFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SellerUserFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}}]}}]} as unknown as DocumentNode<SellerFieldsFragment, unknown>;
export const PortfolioIndustriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PortfolioIndustries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"industriesTree"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IndustriesIndustryNodeFields"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IndustriesIndustryNodeFields"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IndustriesIndustryNodeFields"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IndustriesIndustryNodeFields"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IndustriesIndustryNodeIndustryFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Industry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IndustriesIndustryNodeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IndustryTreeNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"industry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IndustriesIndustryNodeIndustryFields"}}]}}]}}]} as unknown as DocumentNode<PortfolioIndustriesQuery, PortfolioIndustriesQueryVariables>;
export const PortfolioModalProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PortfolioModalProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"usernames"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectCardTransformation"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioAttachmentTransformation"}},"defaultValue":{"kind":"EnumValue","value":"NONE"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectSource"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectSourceFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectStatusFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectStatusFilter"}},"defaultValue":{"kind":"EnumValue","value":"PUBLIC_VISIBLE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sellersDataByUsernames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"usernames"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usernames"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portfolios"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"projectSourceFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectSource"}}},{"kind":"Argument","name":{"kind":"Name","value":"projectStatusFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectStatusFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortfolioModalSellerPortfolioProjectFields"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortfolioInternalProjectDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioProjectInternalProjectDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyerUserName"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"nestedSubCategoryId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortfolioModalSellerPortfolioProjectAttachmentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SellerPortfolioAttachment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"filerrAttachmentId"}},{"kind":"Field","name":{"kind":"Name","value":"previewUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"transformation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectCardTransformation"}}}]},{"kind":"Field","name":{"kind":"Name","value":"mediaUrl"}},{"kind":"Field","name":{"kind":"Name","value":"pdfOpenUrl"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortfolioModalSellerPortfolioProjectFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SellerPortfolioProject"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"internalProjectDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortfolioInternalProjectDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortfolioModalSellerPortfolioProjectAttachmentFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"industryIds"}},{"kind":"Field","name":{"kind":"Name","value":"portfolioProjectRoleCatalog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadataIds"}},{"kind":"Field","name":{"kind":"Name","value":"roleIds"}},{"kind":"Field","name":{"kind":"Name","value":"serviceIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subCategoryIds"}},{"kind":"Field","name":{"kind":"Name","value":"projectStartedAt"}}]}}]} as unknown as DocumentNode<PortfolioModalProjectQuery, PortfolioModalProjectQueryVariables>;
export const PortfolioModalProjectWithModerationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PortfolioModalProjectWithModeration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"usernames"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectCardTransformation"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioAttachmentTransformation"}},"defaultValue":{"kind":"EnumValue","value":"NONE"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectSource"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectSourceFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectStatusFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectStatusFilter"}},"defaultValue":{"kind":"EnumValue","value":"ALL"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sellersDataByUsernames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"usernames"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usernames"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portfolios"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"projectSourceFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectSource"}}},{"kind":"Argument","name":{"kind":"Name","value":"projectStatusFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectStatusFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortfolioModalSellerPortfolioProjectFieldsWithModeration"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortfolioInternalProjectDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioProjectInternalProjectDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyerUserName"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"nestedSubCategoryId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortfolioModalSellerPortfolioProjectAttachmentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SellerPortfolioAttachment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"filerrAttachmentId"}},{"kind":"Field","name":{"kind":"Name","value":"previewUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"transformation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectCardTransformation"}}}]},{"kind":"Field","name":{"kind":"Name","value":"mediaUrl"}},{"kind":"Field","name":{"kind":"Name","value":"pdfOpenUrl"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortfolioModalSellerPortfolioProjectFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SellerPortfolioProject"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"internalProjectDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortfolioInternalProjectDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortfolioModalSellerPortfolioProjectAttachmentFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"industryIds"}},{"kind":"Field","name":{"kind":"Name","value":"portfolioProjectRoleCatalog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadataIds"}},{"kind":"Field","name":{"kind":"Name","value":"roleIds"}},{"kind":"Field","name":{"kind":"Name","value":"serviceIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subCategoryIds"}},{"kind":"Field","name":{"kind":"Name","value":"projectStartedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortfolioModalSellerPortfolioProjectFieldsWithModeration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SellerPortfolioProject"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortfolioModalSellerPortfolioProjectFields"}},{"kind":"Field","name":{"kind":"Name","value":"moderation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"reasons"}},{"kind":"Field","name":{"kind":"Name","value":"violatedFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachmentId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<PortfolioModalProjectWithModerationQuery, PortfolioModalProjectWithModerationQueryVariables>;
export const PortfolioWidgetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PortfolioWidget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"usernames"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roleIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sellerRoleIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectCardTransformation"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioAttachmentTransformation"}},"defaultValue":{"kind":"EnumValue","value":"T_PORTFOLIO_PROJECT_CARD"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectSource"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectSourceFilter"}},"defaultValue":{"kind":"EnumValue","value":"ALL"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sellersByUsernames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"usernames"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usernames"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"firstPortfolio"},"name":{"kind":"Name","value":"portfolios"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"roleIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"sellerRoleIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sellerRoleIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"projectSourceFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectSource"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortfolioModalSellerPortfolioProjectFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portfolios"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"roleIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roleIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"sellerRoleIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sellerRoleIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"projectSourceFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectSource"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortfolioWidgetSellerPortfolioProjectFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortfolioInternalProjectDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PortfolioProjectInternalProjectDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyerUserName"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"nestedSubCategoryId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortfolioModalSellerPortfolioProjectAttachmentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SellerPortfolioAttachment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"filerrAttachmentId"}},{"kind":"Field","name":{"kind":"Name","value":"previewUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"transformation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectCardTransformation"}}}]},{"kind":"Field","name":{"kind":"Name","value":"mediaUrl"}},{"kind":"Field","name":{"kind":"Name","value":"pdfOpenUrl"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"width"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortfolioModalSellerPortfolioProjectFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SellerPortfolioProject"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"internalProjectDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortfolioInternalProjectDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortfolioModalSellerPortfolioProjectAttachmentFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"industryIds"}},{"kind":"Field","name":{"kind":"Name","value":"portfolioProjectRoleCatalog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadataIds"}},{"kind":"Field","name":{"kind":"Name","value":"roleIds"}},{"kind":"Field","name":{"kind":"Name","value":"serviceIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subCategoryIds"}},{"kind":"Field","name":{"kind":"Name","value":"projectStartedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortfolioWidgetSellerPortfolioProjectFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SellerPortfolioProject"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"transformation"},"value":{"kind":"EnumValue","value":"T_PORTFOLIO_PROJECT_GRID"}}]}]}}]}}]}}]}}]} as unknown as DocumentNode<PortfolioWidgetQuery, PortfolioWidgetQueryVariables>;
export const PortfolioModalSellersDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PortfolioModalSellersData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"usernames"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sellersByUsernames"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"usernames"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usernames"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SellerFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SellerUserFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SellerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Seller"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"introVideo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mediaUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SellerUserFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<PortfolioModalSellersDataQuery, PortfolioModalSellersDataQueryVariables>;